/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  float8: any;
  jsonb: any;
  numeric: any;
  point: any;
  polygon: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type Api_Accept_Invite_Input = {
  inviteCode: Scalars['String'];
};

export type Api_Accept_Invite_Output = {
  __typename?: 'api_accept_invite_output';
  ok: Scalars['Boolean'];
};

export type Api_Login_User_Input = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type Api_Login_User_Output = {
  __typename?: 'api_login_user_output';
  id: Scalars['Int'];
  token: Scalars['String'];
};

export type Api_Sign_Up_User_Input = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  inviteCode?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
};

export type Api_Sign_Up_User_Output = {
  __typename?: 'api_sign_up_user_output';
  id: Scalars['Int'];
  token: Scalars['String'];
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "chargeable_units" */
export type Chargeable_Units = {
  __typename?: 'chargeable_units';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "chargeable_units" */
export type Chargeable_Units_Aggregate = {
  __typename?: 'chargeable_units_aggregate';
  aggregate?: Maybe<Chargeable_Units_Aggregate_Fields>;
  nodes: Array<Chargeable_Units>;
};

/** aggregate fields of "chargeable_units" */
export type Chargeable_Units_Aggregate_Fields = {
  __typename?: 'chargeable_units_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chargeable_Units_Max_Fields>;
  min?: Maybe<Chargeable_Units_Min_Fields>;
};


/** aggregate fields of "chargeable_units" */
export type Chargeable_Units_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chargeable_Units_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "chargeable_units". All fields are combined with a logical 'AND'. */
export type Chargeable_Units_Bool_Exp = {
  _and?: InputMaybe<Array<Chargeable_Units_Bool_Exp>>;
  _not?: InputMaybe<Chargeable_Units_Bool_Exp>;
  _or?: InputMaybe<Array<Chargeable_Units_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chargeable_units" */
export enum Chargeable_Units_Constraint {
  /** unique or primary key constraint on columns "value" */
  ChargeableUnitsPkey = 'chargeable_units_pkey'
}

export enum Chargeable_Units_Enum {
  Acre = 'acre',
  Bag = 'bag',
  Bales = 'bales',
  /** °C */
  Celsius = 'celsius',
  CubicLitre = 'cubic_litre',
  CubicMetre = 'cubic_metre',
  Day = 'day',
  FixedCost = 'fixed_cost',
  /** gram */
  G = 'g',
  Gallon = 'gallon',
  Head = 'head',
  Hectare = 'hectare',
  Hour = 'hour',
  Kg = 'kg',
  /** kg/acre */
  KgPerAcre = 'kg_per_acre',
  /** kg/ha */
  KgPerHa = 'kg_per_ha',
  Km = 'km',
  Lb = 'lb',
  /** lb/acre */
  LbPerAcre = 'lb_per_acre',
  /** lb/ha */
  LbPerHa = 'lb_per_ha',
  Litre = 'litre',
  /** l/ha */
  LitrePerHa = 'litre_per_ha',
  Load = 'load',
  Metre = 'metre',
  /** m/sec */
  MetrePerSecond = 'metre_per_second',
  Mile = 'mile',
  Minute = 'minute',
  Number = 'number',
  Pack = 'pack',
  /** % */
  Percent = 'percent',
  /** % rate */
  PercentRate = 'percent_rate',
  /** rate/ha */
  RatePerHa = 'rate_per_ha',
  Roll = 'roll',
  SquareMetre = 'square_metre',
  Tonne = 'tonne',
  Unit = 'unit',
  Wrap = 'wrap'
}

/** Boolean expression to compare columns of type "chargeable_units_enum". All fields are combined with logical 'AND'. */
export type Chargeable_Units_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Chargeable_Units_Enum>;
  _in?: InputMaybe<Array<Chargeable_Units_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Chargeable_Units_Enum>;
  _nin?: InputMaybe<Array<Chargeable_Units_Enum>>;
};

/** input type for inserting data into table "chargeable_units" */
export type Chargeable_Units_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Chargeable_Units_Max_Fields = {
  __typename?: 'chargeable_units_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Chargeable_Units_Min_Fields = {
  __typename?: 'chargeable_units_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chargeable_units" */
export type Chargeable_Units_Mutation_Response = {
  __typename?: 'chargeable_units_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chargeable_Units>;
};

/** on_conflict condition type for table "chargeable_units" */
export type Chargeable_Units_On_Conflict = {
  constraint: Chargeable_Units_Constraint;
  update_columns?: Array<Chargeable_Units_Update_Column>;
  where?: InputMaybe<Chargeable_Units_Bool_Exp>;
};

/** Ordering options when selecting data from "chargeable_units". */
export type Chargeable_Units_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chargeable_units */
export type Chargeable_Units_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "chargeable_units" */
export enum Chargeable_Units_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "chargeable_units" */
export type Chargeable_Units_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "chargeable_units" */
export type Chargeable_Units_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chargeable_Units_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chargeable_Units_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chargeable_units" */
export enum Chargeable_Units_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Chargeable_Units_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chargeable_Units_Set_Input>;
  /** filter the rows which have to be updated */
  where: Chargeable_Units_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "entity_status" */
export type Entity_Status = {
  __typename?: 'entity_status';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "entity_status" */
export type Entity_Status_Aggregate = {
  __typename?: 'entity_status_aggregate';
  aggregate?: Maybe<Entity_Status_Aggregate_Fields>;
  nodes: Array<Entity_Status>;
};

/** aggregate fields of "entity_status" */
export type Entity_Status_Aggregate_Fields = {
  __typename?: 'entity_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Entity_Status_Max_Fields>;
  min?: Maybe<Entity_Status_Min_Fields>;
};


/** aggregate fields of "entity_status" */
export type Entity_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "entity_status". All fields are combined with a logical 'AND'. */
export type Entity_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Status_Bool_Exp>>;
  _not?: InputMaybe<Entity_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity_status" */
export enum Entity_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  EntityStatusPkey = 'entity_status_pkey'
}

export enum Entity_Status_Enum {
  Active = 'active',
  Archived = 'archived',
  Deleted = 'deleted'
}

/** Boolean expression to compare columns of type "entity_status_enum". All fields are combined with logical 'AND'. */
export type Entity_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Entity_Status_Enum>;
  _in?: InputMaybe<Array<Entity_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Entity_Status_Enum>;
  _nin?: InputMaybe<Array<Entity_Status_Enum>>;
};

/** input type for inserting data into table "entity_status" */
export type Entity_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Entity_Status_Max_Fields = {
  __typename?: 'entity_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Entity_Status_Min_Fields = {
  __typename?: 'entity_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "entity_status" */
export type Entity_Status_Mutation_Response = {
  __typename?: 'entity_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity_Status>;
};

/** on_conflict condition type for table "entity_status" */
export type Entity_Status_On_Conflict = {
  constraint: Entity_Status_Constraint;
  update_columns?: Array<Entity_Status_Update_Column>;
  where?: InputMaybe<Entity_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "entity_status". */
export type Entity_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity_status */
export type Entity_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "entity_status" */
export enum Entity_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "entity_status" */
export type Entity_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "entity_status" */
export type Entity_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "entity_status" */
export enum Entity_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Entity_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entity_Status_Bool_Exp;
};

/** Groups fields */
export type Farms = {
  __typename?: 'farms';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  geoLocation?: Maybe<Scalars['point']>;
  highResLink?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint'];
};

/** aggregated selection of "farms" */
export type Farms_Aggregate = {
  __typename?: 'farms_aggregate';
  aggregate?: Maybe<Farms_Aggregate_Fields>;
  nodes: Array<Farms>;
};

/** aggregate fields of "farms" */
export type Farms_Aggregate_Fields = {
  __typename?: 'farms_aggregate_fields';
  avg?: Maybe<Farms_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Farms_Max_Fields>;
  min?: Maybe<Farms_Min_Fields>;
  stddev?: Maybe<Farms_Stddev_Fields>;
  stddev_pop?: Maybe<Farms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Farms_Stddev_Samp_Fields>;
  sum?: Maybe<Farms_Sum_Fields>;
  var_pop?: Maybe<Farms_Var_Pop_Fields>;
  var_samp?: Maybe<Farms_Var_Samp_Fields>;
  variance?: Maybe<Farms_Variance_Fields>;
};


/** aggregate fields of "farms" */
export type Farms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Farms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Farms_Avg_Fields = {
  __typename?: 'farms_avg_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "farms". All fields are combined with a logical 'AND'. */
export type Farms_Bool_Exp = {
  _and?: InputMaybe<Array<Farms_Bool_Exp>>;
  _not?: InputMaybe<Farms_Bool_Exp>;
  _or?: InputMaybe<Array<Farms_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  geoLocation?: InputMaybe<Point_Comparison_Exp>;
  highResLink?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "farms" */
export enum Farms_Constraint {
  /** unique or primary key constraint on columns "id" */
  FarmsPkey = 'farms_pkey'
}

/** input type for incrementing numeric columns in table "farms" */
export type Farms_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "farms" */
export type Farms_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<Scalars['point']>;
  highResLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Farms_Max_Fields = {
  __typename?: 'farms_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  highResLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Farms_Min_Fields = {
  __typename?: 'farms_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  highResLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "farms" */
export type Farms_Mutation_Response = {
  __typename?: 'farms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Farms>;
};

/** input type for inserting object relation for remote table "farms" */
export type Farms_Obj_Rel_Insert_Input = {
  data: Farms_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Farms_On_Conflict>;
};

/** on_conflict condition type for table "farms" */
export type Farms_On_Conflict = {
  constraint: Farms_Constraint;
  update_columns?: Array<Farms_Update_Column>;
  where?: InputMaybe<Farms_Bool_Exp>;
};

/** Ordering options when selecting data from "farms". */
export type Farms_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  geoLocation?: InputMaybe<Order_By>;
  highResLink?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: farms */
export type Farms_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "farms" */
export enum Farms_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  HighResLink = 'highResLink',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "farms" */
export type Farms_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<Scalars['point']>;
  highResLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Farms_Stddev_Fields = {
  __typename?: 'farms_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Farms_Stddev_Pop_Fields = {
  __typename?: 'farms_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Farms_Stddev_Samp_Fields = {
  __typename?: 'farms_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "farms" */
export type Farms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Farms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Farms_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<Scalars['point']>;
  highResLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Farms_Sum_Fields = {
  __typename?: 'farms_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['bigint']>;
};

/** update columns of table "farms" */
export enum Farms_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  HighResLink = 'highResLink',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Farms_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Farms_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Farms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Farms_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Farms_Var_Pop_Fields = {
  __typename?: 'farms_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Farms_Var_Samp_Fields = {
  __typename?: 'farms_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Farms_Variance_Fields = {
  __typename?: 'farms_variance_fields';
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Snapshot of a field unique for each season */
export type Field_Season_Shot = {
  __typename?: 'field_season_shot';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cropName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  farm: Farms;
  farmId: Scalars['bigint'];
  /** An object relationship */
  field: Fields;
  fieldId: Scalars['bigint'];
  id: Scalars['bigint'];
  /** An array relationship */
  jobs: Array<Job_Fields>;
  /** An aggregate relationship */
  jobs_aggregate: Job_Fields_Aggregate;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  ownershipType: Scalars['String'];
  /** An object relationship */
  polygon: Polygons;
  polygonId: Scalars['bigint'];
  season: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** Snapshot of a field unique for each season */
export type Field_Season_ShotJobsArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


/** Snapshot of a field unique for each season */
export type Field_Season_ShotJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};

/** aggregated selection of "field_season_shot" */
export type Field_Season_Shot_Aggregate = {
  __typename?: 'field_season_shot_aggregate';
  aggregate?: Maybe<Field_Season_Shot_Aggregate_Fields>;
  nodes: Array<Field_Season_Shot>;
};

export type Field_Season_Shot_Aggregate_Bool_Exp = {
  count?: InputMaybe<Field_Season_Shot_Aggregate_Bool_Exp_Count>;
};

export type Field_Season_Shot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Field_Season_Shot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "field_season_shot" */
export type Field_Season_Shot_Aggregate_Fields = {
  __typename?: 'field_season_shot_aggregate_fields';
  avg?: Maybe<Field_Season_Shot_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Field_Season_Shot_Max_Fields>;
  min?: Maybe<Field_Season_Shot_Min_Fields>;
  stddev?: Maybe<Field_Season_Shot_Stddev_Fields>;
  stddev_pop?: Maybe<Field_Season_Shot_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Field_Season_Shot_Stddev_Samp_Fields>;
  sum?: Maybe<Field_Season_Shot_Sum_Fields>;
  var_pop?: Maybe<Field_Season_Shot_Var_Pop_Fields>;
  var_samp?: Maybe<Field_Season_Shot_Var_Samp_Fields>;
  variance?: Maybe<Field_Season_Shot_Variance_Fields>;
};


/** aggregate fields of "field_season_shot" */
export type Field_Season_Shot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "field_season_shot" */
export type Field_Season_Shot_Aggregate_Order_By = {
  avg?: InputMaybe<Field_Season_Shot_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Field_Season_Shot_Max_Order_By>;
  min?: InputMaybe<Field_Season_Shot_Min_Order_By>;
  stddev?: InputMaybe<Field_Season_Shot_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Field_Season_Shot_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Field_Season_Shot_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Field_Season_Shot_Sum_Order_By>;
  var_pop?: InputMaybe<Field_Season_Shot_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Field_Season_Shot_Var_Samp_Order_By>;
  variance?: InputMaybe<Field_Season_Shot_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "field_season_shot" */
export type Field_Season_Shot_Arr_Rel_Insert_Input = {
  data: Array<Field_Season_Shot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Season_Shot_On_Conflict>;
};

/** aggregate avg on columns */
export type Field_Season_Shot_Avg_Fields = {
  __typename?: 'field_season_shot_avg_fields';
  farmId?: Maybe<Scalars['Float']>;
  fieldId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  polygonId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "field_season_shot" */
export type Field_Season_Shot_Avg_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "field_season_shot". All fields are combined with a logical 'AND'. */
export type Field_Season_Shot_Bool_Exp = {
  _and?: InputMaybe<Array<Field_Season_Shot_Bool_Exp>>;
  _not?: InputMaybe<Field_Season_Shot_Bool_Exp>;
  _or?: InputMaybe<Array<Field_Season_Shot_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  cropName?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  farm?: InputMaybe<Farms_Bool_Exp>;
  farmId?: InputMaybe<Bigint_Comparison_Exp>;
  field?: InputMaybe<Fields_Bool_Exp>;
  fieldId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jobs?: InputMaybe<Job_Fields_Bool_Exp>;
  jobs_aggregate?: InputMaybe<Job_Fields_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  ownershipType?: InputMaybe<String_Comparison_Exp>;
  polygon?: InputMaybe<Polygons_Bool_Exp>;
  polygonId?: InputMaybe<Bigint_Comparison_Exp>;
  season?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "field_season_shot" */
export enum Field_Season_Shot_Constraint {
  /** unique or primary key constraint on columns "field_id", "season" */
  FieldSeasonShotFieldIdSeasonKey = 'field_season_shot_field_id_season_key',
  /** unique or primary key constraint on columns "id" */
  FieldSeasonShotPkey = 'field_season_shot_pkey'
}

/** input type for incrementing numeric columns in table "field_season_shot" */
export type Field_Season_Shot_Inc_Input = {
  farmId?: InputMaybe<Scalars['bigint']>;
  fieldId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  polygonId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "field_season_shot" */
export type Field_Season_Shot_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cropName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  farm?: InputMaybe<Farms_Obj_Rel_Insert_Input>;
  farmId?: InputMaybe<Scalars['bigint']>;
  field?: InputMaybe<Fields_Obj_Rel_Insert_Input>;
  fieldId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  jobs?: InputMaybe<Job_Fields_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownershipType?: InputMaybe<Scalars['String']>;
  polygon?: InputMaybe<Polygons_Obj_Rel_Insert_Input>;
  polygonId?: InputMaybe<Scalars['bigint']>;
  season?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Field_Season_Shot_Max_Fields = {
  __typename?: 'field_season_shot_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cropName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  farmId?: Maybe<Scalars['bigint']>;
  fieldId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  ownershipType?: Maybe<Scalars['String']>;
  polygonId?: Maybe<Scalars['bigint']>;
  season?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "field_season_shot" */
export type Field_Season_Shot_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  cropName?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  ownershipType?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Field_Season_Shot_Min_Fields = {
  __typename?: 'field_season_shot_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  cropName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  farmId?: Maybe<Scalars['bigint']>;
  fieldId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  ownershipType?: Maybe<Scalars['String']>;
  polygonId?: Maybe<Scalars['bigint']>;
  season?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "field_season_shot" */
export type Field_Season_Shot_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  cropName?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  ownershipType?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "field_season_shot" */
export type Field_Season_Shot_Mutation_Response = {
  __typename?: 'field_season_shot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Field_Season_Shot>;
};

/** input type for inserting object relation for remote table "field_season_shot" */
export type Field_Season_Shot_Obj_Rel_Insert_Input = {
  data: Field_Season_Shot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Field_Season_Shot_On_Conflict>;
};

/** on_conflict condition type for table "field_season_shot" */
export type Field_Season_Shot_On_Conflict = {
  constraint: Field_Season_Shot_Constraint;
  update_columns?: Array<Field_Season_Shot_Update_Column>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};

/** Ordering options when selecting data from "field_season_shot". */
export type Field_Season_Shot_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  cropName?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  farm?: InputMaybe<Farms_Order_By>;
  farmId?: InputMaybe<Order_By>;
  field?: InputMaybe<Fields_Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<Job_Fields_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  ownershipType?: InputMaybe<Order_By>;
  polygon?: InputMaybe<Polygons_Order_By>;
  polygonId?: InputMaybe<Order_By>;
  season?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: field_season_shot */
export type Field_Season_Shot_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "field_season_shot" */
export enum Field_Season_Shot_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CropName = 'cropName',
  /** column name */
  Description = 'description',
  /** column name */
  FarmId = 'farmId',
  /** column name */
  FieldId = 'fieldId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OwnershipType = 'ownershipType',
  /** column name */
  PolygonId = 'polygonId',
  /** column name */
  Season = 'season',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "field_season_shot" */
export type Field_Season_Shot_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cropName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  farmId?: InputMaybe<Scalars['bigint']>;
  fieldId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownershipType?: InputMaybe<Scalars['String']>;
  polygonId?: InputMaybe<Scalars['bigint']>;
  season?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Field_Season_Shot_Stddev_Fields = {
  __typename?: 'field_season_shot_stddev_fields';
  farmId?: Maybe<Scalars['Float']>;
  fieldId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  polygonId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "field_season_shot" */
export type Field_Season_Shot_Stddev_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Field_Season_Shot_Stddev_Pop_Fields = {
  __typename?: 'field_season_shot_stddev_pop_fields';
  farmId?: Maybe<Scalars['Float']>;
  fieldId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  polygonId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "field_season_shot" */
export type Field_Season_Shot_Stddev_Pop_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Field_Season_Shot_Stddev_Samp_Fields = {
  __typename?: 'field_season_shot_stddev_samp_fields';
  farmId?: Maybe<Scalars['Float']>;
  fieldId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  polygonId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "field_season_shot" */
export type Field_Season_Shot_Stddev_Samp_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "field_season_shot" */
export type Field_Season_Shot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Field_Season_Shot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Field_Season_Shot_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  cropName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  farmId?: InputMaybe<Scalars['bigint']>;
  fieldId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownershipType?: InputMaybe<Scalars['String']>;
  polygonId?: InputMaybe<Scalars['bigint']>;
  season?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Field_Season_Shot_Sum_Fields = {
  __typename?: 'field_season_shot_sum_fields';
  farmId?: Maybe<Scalars['bigint']>;
  fieldId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  polygonId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "field_season_shot" */
export type Field_Season_Shot_Sum_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** update columns of table "field_season_shot" */
export enum Field_Season_Shot_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CropName = 'cropName',
  /** column name */
  Description = 'description',
  /** column name */
  FarmId = 'farmId',
  /** column name */
  FieldId = 'fieldId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Notes = 'notes',
  /** column name */
  OwnershipType = 'ownershipType',
  /** column name */
  PolygonId = 'polygonId',
  /** column name */
  Season = 'season',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Field_Season_Shot_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Field_Season_Shot_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Field_Season_Shot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Field_Season_Shot_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Field_Season_Shot_Var_Pop_Fields = {
  __typename?: 'field_season_shot_var_pop_fields';
  farmId?: Maybe<Scalars['Float']>;
  fieldId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  polygonId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "field_season_shot" */
export type Field_Season_Shot_Var_Pop_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Field_Season_Shot_Var_Samp_Fields = {
  __typename?: 'field_season_shot_var_samp_fields';
  farmId?: Maybe<Scalars['Float']>;
  fieldId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  polygonId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "field_season_shot" */
export type Field_Season_Shot_Var_Samp_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Field_Season_Shot_Variance_Fields = {
  __typename?: 'field_season_shot_variance_fields';
  farmId?: Maybe<Scalars['Float']>;
  fieldId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  polygonId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "field_season_shot" */
export type Field_Season_Shot_Variance_Order_By = {
  farmId?: InputMaybe<Order_By>;
  fieldId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  polygonId?: InputMaybe<Order_By>;
};

/** columns and relationships of "fields" */
export type Fields = {
  __typename?: 'fields';
  /** An object relationship */
  defaultFarm: Farms;
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId: Scalars['bigint'];
  id: Scalars['bigint'];
};

/** aggregated selection of "fields" */
export type Fields_Aggregate = {
  __typename?: 'fields_aggregate';
  aggregate?: Maybe<Fields_Aggregate_Fields>;
  nodes: Array<Fields>;
};

/** aggregate fields of "fields" */
export type Fields_Aggregate_Fields = {
  __typename?: 'fields_aggregate_fields';
  avg?: Maybe<Fields_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fields_Max_Fields>;
  min?: Maybe<Fields_Min_Fields>;
  stddev?: Maybe<Fields_Stddev_Fields>;
  stddev_pop?: Maybe<Fields_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fields_Stddev_Samp_Fields>;
  sum?: Maybe<Fields_Sum_Fields>;
  var_pop?: Maybe<Fields_Var_Pop_Fields>;
  var_samp?: Maybe<Fields_Var_Samp_Fields>;
  variance?: Maybe<Fields_Variance_Fields>;
};


/** aggregate fields of "fields" */
export type Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fields_Avg_Fields = {
  __typename?: 'fields_avg_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fields". All fields are combined with a logical 'AND'. */
export type Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Fields_Bool_Exp>>;
  _not?: InputMaybe<Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Fields_Bool_Exp>>;
  defaultFarm?: InputMaybe<Farms_Bool_Exp>;
  defaultFarmId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "fields" */
export enum Fields_Constraint {
  /** unique or primary key constraint on columns "id" */
  FieldsPkey = 'fields_pkey'
}

/** input type for incrementing numeric columns in table "fields" */
export type Fields_Inc_Input = {
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "fields" */
export type Fields_Insert_Input = {
  defaultFarm?: InputMaybe<Farms_Obj_Rel_Insert_Input>;
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Fields_Max_Fields = {
  __typename?: 'fields_max_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Fields_Min_Fields = {
  __typename?: 'fields_min_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "fields" */
export type Fields_Mutation_Response = {
  __typename?: 'fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fields>;
};

/** input type for inserting object relation for remote table "fields" */
export type Fields_Obj_Rel_Insert_Input = {
  data: Fields_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fields_On_Conflict>;
};

/** on_conflict condition type for table "fields" */
export type Fields_On_Conflict = {
  constraint: Fields_Constraint;
  update_columns?: Array<Fields_Update_Column>;
  where?: InputMaybe<Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "fields". */
export type Fields_Order_By = {
  defaultFarm?: InputMaybe<Farms_Order_By>;
  defaultFarmId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fields */
export type Fields_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "fields" */
export enum Fields_Select_Column {
  /** column name */
  DefaultFarmId = 'defaultFarmId',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "fields" */
export type Fields_Set_Input = {
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Fields_Stddev_Fields = {
  __typename?: 'fields_stddev_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fields_Stddev_Pop_Fields = {
  __typename?: 'fields_stddev_pop_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fields_Stddev_Samp_Fields = {
  __typename?: 'fields_stddev_samp_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fields" */
export type Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fields_Stream_Cursor_Value_Input = {
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Fields_Sum_Fields = {
  __typename?: 'fields_sum_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** update columns of table "fields" */
export enum Fields_Update_Column {
  /** column name */
  DefaultFarmId = 'defaultFarmId',
  /** column name */
  Id = 'id'
}

export type Fields_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fields_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fields_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fields_Var_Pop_Fields = {
  __typename?: 'fields_var_pop_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fields_Var_Samp_Fields = {
  __typename?: 'fields_var_samp_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fields_Variance_Fields = {
  __typename?: 'fields_variance_fields';
  /** Field ownership w.r.t farm is considered dynamic, so we add farm_id to season_shot as well, but still keep a default id at field level */
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "high_res_map_annotations" */
export type High_Res_Map_Annotations = {
  __typename?: 'high_res_map_annotations';
  /** in acres */
  area?: Maybe<Scalars['float8']>;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  geometry: Scalars['String'];
  /** An object relationship */
  highResMap: High_Res_Maps;
  highResMapId: Scalars['bigint'];
  id: Scalars['bigint'];
  name: Scalars['String'];
};

/** aggregated selection of "high_res_map_annotations" */
export type High_Res_Map_Annotations_Aggregate = {
  __typename?: 'high_res_map_annotations_aggregate';
  aggregate?: Maybe<High_Res_Map_Annotations_Aggregate_Fields>;
  nodes: Array<High_Res_Map_Annotations>;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp = {
  avg?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp_Var_Samp>;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Avg = {
  arguments: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Corr = {
  arguments: High_Res_Map_Annotations_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Corr_Arguments = {
  X: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: High_Res_Map_Annotations_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Max = {
  arguments: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Min = {
  arguments: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Sum = {
  arguments: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type High_Res_Map_Annotations_Aggregate_Bool_Exp_Var_Samp = {
  arguments: High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "high_res_map_annotations" */
export type High_Res_Map_Annotations_Aggregate_Fields = {
  __typename?: 'high_res_map_annotations_aggregate_fields';
  avg?: Maybe<High_Res_Map_Annotations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<High_Res_Map_Annotations_Max_Fields>;
  min?: Maybe<High_Res_Map_Annotations_Min_Fields>;
  stddev?: Maybe<High_Res_Map_Annotations_Stddev_Fields>;
  stddev_pop?: Maybe<High_Res_Map_Annotations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<High_Res_Map_Annotations_Stddev_Samp_Fields>;
  sum?: Maybe<High_Res_Map_Annotations_Sum_Fields>;
  var_pop?: Maybe<High_Res_Map_Annotations_Var_Pop_Fields>;
  var_samp?: Maybe<High_Res_Map_Annotations_Var_Samp_Fields>;
  variance?: Maybe<High_Res_Map_Annotations_Variance_Fields>;
};


/** aggregate fields of "high_res_map_annotations" */
export type High_Res_Map_Annotations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Aggregate_Order_By = {
  avg?: InputMaybe<High_Res_Map_Annotations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<High_Res_Map_Annotations_Max_Order_By>;
  min?: InputMaybe<High_Res_Map_Annotations_Min_Order_By>;
  stddev?: InputMaybe<High_Res_Map_Annotations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<High_Res_Map_Annotations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<High_Res_Map_Annotations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<High_Res_Map_Annotations_Sum_Order_By>;
  var_pop?: InputMaybe<High_Res_Map_Annotations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<High_Res_Map_Annotations_Var_Samp_Order_By>;
  variance?: InputMaybe<High_Res_Map_Annotations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Arr_Rel_Insert_Input = {
  data: Array<High_Res_Map_Annotations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<High_Res_Map_Annotations_On_Conflict>;
};

/** aggregate avg on columns */
export type High_Res_Map_Annotations_Avg_Fields = {
  __typename?: 'high_res_map_annotations_avg_fields';
  /** in acres */
  area?: Maybe<Scalars['Float']>;
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Avg_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "high_res_map_annotations". All fields are combined with a logical 'AND'. */
export type High_Res_Map_Annotations_Bool_Exp = {
  _and?: InputMaybe<Array<High_Res_Map_Annotations_Bool_Exp>>;
  _not?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  _or?: InputMaybe<Array<High_Res_Map_Annotations_Bool_Exp>>;
  area?: InputMaybe<Float8_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  geometry?: InputMaybe<String_Comparison_Exp>;
  highResMap?: InputMaybe<High_Res_Maps_Bool_Exp>;
  highResMapId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Constraint {
  /** unique or primary key constraint on columns "id" */
  HighResMapAnnotationsPkey = 'high_res_map_annotations_pkey'
}

/** input type for incrementing numeric columns in table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Inc_Input = {
  /** in acres */
  area?: InputMaybe<Scalars['float8']>;
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Insert_Input = {
  /** in acres */
  area?: InputMaybe<Scalars['float8']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['String']>;
  highResMap?: InputMaybe<High_Res_Maps_Obj_Rel_Insert_Input>;
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type High_Res_Map_Annotations_Max_Fields = {
  __typename?: 'high_res_map_annotations_max_fields';
  /** in acres */
  area?: Maybe<Scalars['float8']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['String']>;
  highResMapId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Max_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  geometry?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type High_Res_Map_Annotations_Min_Fields = {
  __typename?: 'high_res_map_annotations_min_fields';
  /** in acres */
  area?: Maybe<Scalars['float8']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  geometry?: Maybe<Scalars['String']>;
  highResMapId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Min_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  geometry?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Mutation_Response = {
  __typename?: 'high_res_map_annotations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<High_Res_Map_Annotations>;
};

/** on_conflict condition type for table "high_res_map_annotations" */
export type High_Res_Map_Annotations_On_Conflict = {
  constraint: High_Res_Map_Annotations_Constraint;
  update_columns?: Array<High_Res_Map_Annotations_Update_Column>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};

/** Ordering options when selecting data from "high_res_map_annotations". */
export type High_Res_Map_Annotations_Order_By = {
  area?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  geometry?: InputMaybe<Order_By>;
  highResMap?: InputMaybe<High_Res_Maps_Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: high_res_map_annotations */
export type High_Res_Map_Annotations_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column {
  /** column name */
  Area = 'area',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  HighResMapId = 'highResMapId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** select "high_res_map_annotations_aggregate_bool_exp_avg_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** select "high_res_map_annotations_aggregate_bool_exp_corr_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** select "high_res_map_annotations_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** select "high_res_map_annotations_aggregate_bool_exp_max_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** select "high_res_map_annotations_aggregate_bool_exp_min_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** select "high_res_map_annotations_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** select "high_res_map_annotations_aggregate_bool_exp_sum_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** select "high_res_map_annotations_aggregate_bool_exp_var_samp_arguments_columns" columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Select_Column_High_Res_Map_Annotations_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Area = 'area'
}

/** input type for updating data in table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Set_Input = {
  /** in acres */
  area?: InputMaybe<Scalars['float8']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['String']>;
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type High_Res_Map_Annotations_Stddev_Fields = {
  __typename?: 'high_res_map_annotations_stddev_fields';
  /** in acres */
  area?: Maybe<Scalars['Float']>;
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Stddev_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type High_Res_Map_Annotations_Stddev_Pop_Fields = {
  __typename?: 'high_res_map_annotations_stddev_pop_fields';
  /** in acres */
  area?: Maybe<Scalars['Float']>;
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Stddev_Pop_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type High_Res_Map_Annotations_Stddev_Samp_Fields = {
  __typename?: 'high_res_map_annotations_stddev_samp_fields';
  /** in acres */
  area?: Maybe<Scalars['Float']>;
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Stddev_Samp_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: High_Res_Map_Annotations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type High_Res_Map_Annotations_Stream_Cursor_Value_Input = {
  /** in acres */
  area?: InputMaybe<Scalars['float8']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  geometry?: InputMaybe<Scalars['String']>;
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type High_Res_Map_Annotations_Sum_Fields = {
  __typename?: 'high_res_map_annotations_sum_fields';
  /** in acres */
  area?: Maybe<Scalars['float8']>;
  highResMapId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Sum_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "high_res_map_annotations" */
export enum High_Res_Map_Annotations_Update_Column {
  /** column name */
  Area = 'area',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  HighResMapId = 'highResMapId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type High_Res_Map_Annotations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<High_Res_Map_Annotations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<High_Res_Map_Annotations_Set_Input>;
  /** filter the rows which have to be updated */
  where: High_Res_Map_Annotations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type High_Res_Map_Annotations_Var_Pop_Fields = {
  __typename?: 'high_res_map_annotations_var_pop_fields';
  /** in acres */
  area?: Maybe<Scalars['Float']>;
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Var_Pop_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type High_Res_Map_Annotations_Var_Samp_Fields = {
  __typename?: 'high_res_map_annotations_var_samp_fields';
  /** in acres */
  area?: Maybe<Scalars['Float']>;
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Var_Samp_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type High_Res_Map_Annotations_Variance_Fields = {
  __typename?: 'high_res_map_annotations_variance_fields';
  /** in acres */
  area?: Maybe<Scalars['Float']>;
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "high_res_map_annotations" */
export type High_Res_Map_Annotations_Variance_Order_By = {
  /** in acres */
  area?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "high_res_map_layers" */
export type High_Res_Map_Layers = {
  __typename?: 'high_res_map_layers';
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  highResMap: High_Res_Maps;
  highResMapId: Scalars['bigint'];
  id: Scalars['bigint'];
  link: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** aggregated selection of "high_res_map_layers" */
export type High_Res_Map_Layers_Aggregate = {
  __typename?: 'high_res_map_layers_aggregate';
  aggregate?: Maybe<High_Res_Map_Layers_Aggregate_Fields>;
  nodes: Array<High_Res_Map_Layers>;
};

export type High_Res_Map_Layers_Aggregate_Bool_Exp = {
  count?: InputMaybe<High_Res_Map_Layers_Aggregate_Bool_Exp_Count>;
};

export type High_Res_Map_Layers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "high_res_map_layers" */
export type High_Res_Map_Layers_Aggregate_Fields = {
  __typename?: 'high_res_map_layers_aggregate_fields';
  avg?: Maybe<High_Res_Map_Layers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<High_Res_Map_Layers_Max_Fields>;
  min?: Maybe<High_Res_Map_Layers_Min_Fields>;
  stddev?: Maybe<High_Res_Map_Layers_Stddev_Fields>;
  stddev_pop?: Maybe<High_Res_Map_Layers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<High_Res_Map_Layers_Stddev_Samp_Fields>;
  sum?: Maybe<High_Res_Map_Layers_Sum_Fields>;
  var_pop?: Maybe<High_Res_Map_Layers_Var_Pop_Fields>;
  var_samp?: Maybe<High_Res_Map_Layers_Var_Samp_Fields>;
  variance?: Maybe<High_Res_Map_Layers_Variance_Fields>;
};


/** aggregate fields of "high_res_map_layers" */
export type High_Res_Map_Layers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "high_res_map_layers" */
export type High_Res_Map_Layers_Aggregate_Order_By = {
  avg?: InputMaybe<High_Res_Map_Layers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<High_Res_Map_Layers_Max_Order_By>;
  min?: InputMaybe<High_Res_Map_Layers_Min_Order_By>;
  stddev?: InputMaybe<High_Res_Map_Layers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<High_Res_Map_Layers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<High_Res_Map_Layers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<High_Res_Map_Layers_Sum_Order_By>;
  var_pop?: InputMaybe<High_Res_Map_Layers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<High_Res_Map_Layers_Var_Samp_Order_By>;
  variance?: InputMaybe<High_Res_Map_Layers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "high_res_map_layers" */
export type High_Res_Map_Layers_Arr_Rel_Insert_Input = {
  data: Array<High_Res_Map_Layers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<High_Res_Map_Layers_On_Conflict>;
};

/** aggregate avg on columns */
export type High_Res_Map_Layers_Avg_Fields = {
  __typename?: 'high_res_map_layers_avg_fields';
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Avg_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "high_res_map_layers". All fields are combined with a logical 'AND'. */
export type High_Res_Map_Layers_Bool_Exp = {
  _and?: InputMaybe<Array<High_Res_Map_Layers_Bool_Exp>>;
  _not?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
  _or?: InputMaybe<Array<High_Res_Map_Layers_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  highResMap?: InputMaybe<High_Res_Maps_Bool_Exp>;
  highResMapId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "high_res_map_layers" */
export enum High_Res_Map_Layers_Constraint {
  /** unique or primary key constraint on columns "id" */
  HighResMapLayersPkey = 'high_res_map_layers_pkey'
}

/** input type for incrementing numeric columns in table "high_res_map_layers" */
export type High_Res_Map_Layers_Inc_Input = {
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "high_res_map_layers" */
export type High_Res_Map_Layers_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  highResMap?: InputMaybe<High_Res_Maps_Obj_Rel_Insert_Input>;
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type High_Res_Map_Layers_Max_Fields = {
  __typename?: 'high_res_map_layers_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  highResMapId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type High_Res_Map_Layers_Min_Fields = {
  __typename?: 'high_res_map_layers_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  highResMapId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "high_res_map_layers" */
export type High_Res_Map_Layers_Mutation_Response = {
  __typename?: 'high_res_map_layers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<High_Res_Map_Layers>;
};

/** on_conflict condition type for table "high_res_map_layers" */
export type High_Res_Map_Layers_On_Conflict = {
  constraint: High_Res_Map_Layers_Constraint;
  update_columns?: Array<High_Res_Map_Layers_Update_Column>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};

/** Ordering options when selecting data from "high_res_map_layers". */
export type High_Res_Map_Layers_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  highResMap?: InputMaybe<High_Res_Maps_Order_By>;
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: high_res_map_layers */
export type High_Res_Map_Layers_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "high_res_map_layers" */
export enum High_Res_Map_Layers_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HighResMapId = 'highResMapId',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "high_res_map_layers" */
export type High_Res_Map_Layers_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type High_Res_Map_Layers_Stddev_Fields = {
  __typename?: 'high_res_map_layers_stddev_fields';
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Stddev_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type High_Res_Map_Layers_Stddev_Pop_Fields = {
  __typename?: 'high_res_map_layers_stddev_pop_fields';
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Stddev_Pop_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type High_Res_Map_Layers_Stddev_Samp_Fields = {
  __typename?: 'high_res_map_layers_stddev_samp_fields';
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Stddev_Samp_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "high_res_map_layers" */
export type High_Res_Map_Layers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: High_Res_Map_Layers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type High_Res_Map_Layers_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  highResMapId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type High_Res_Map_Layers_Sum_Fields = {
  __typename?: 'high_res_map_layers_sum_fields';
  highResMapId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Sum_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "high_res_map_layers" */
export enum High_Res_Map_Layers_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  HighResMapId = 'highResMapId',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name'
}

export type High_Res_Map_Layers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<High_Res_Map_Layers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<High_Res_Map_Layers_Set_Input>;
  /** filter the rows which have to be updated */
  where: High_Res_Map_Layers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type High_Res_Map_Layers_Var_Pop_Fields = {
  __typename?: 'high_res_map_layers_var_pop_fields';
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Var_Pop_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type High_Res_Map_Layers_Var_Samp_Fields = {
  __typename?: 'high_res_map_layers_var_samp_fields';
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Var_Samp_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type High_Res_Map_Layers_Variance_Fields = {
  __typename?: 'high_res_map_layers_variance_fields';
  highResMapId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "high_res_map_layers" */
export type High_Res_Map_Layers_Variance_Order_By = {
  highResMapId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "high_res_maps" */
export type High_Res_Maps = {
  __typename?: 'high_res_maps';
  /** An array relationship */
  annotations: Array<High_Res_Map_Annotations>;
  /** An aggregate relationship */
  annotations_aggregate: High_Res_Map_Annotations_Aggregate;
  createdAt: Scalars['timestamptz'];
  id: Scalars['bigint'];
  /** An array relationship */
  layers: Array<High_Res_Map_Layers>;
  /** An aggregate relationship */
  layers_aggregate: High_Res_Map_Layers_Aggregate;
  link: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  seasonShot: Field_Season_Shot;
  seasonShotId: Scalars['bigint'];
};


/** columns and relationships of "high_res_maps" */
export type High_Res_MapsAnnotationsArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Annotations_Order_By>>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};


/** columns and relationships of "high_res_maps" */
export type High_Res_MapsAnnotations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Annotations_Order_By>>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};


/** columns and relationships of "high_res_maps" */
export type High_Res_MapsLayersArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Layers_Order_By>>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};


/** columns and relationships of "high_res_maps" */
export type High_Res_MapsLayers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Layers_Order_By>>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};

/** aggregated selection of "high_res_maps" */
export type High_Res_Maps_Aggregate = {
  __typename?: 'high_res_maps_aggregate';
  aggregate?: Maybe<High_Res_Maps_Aggregate_Fields>;
  nodes: Array<High_Res_Maps>;
};

/** aggregate fields of "high_res_maps" */
export type High_Res_Maps_Aggregate_Fields = {
  __typename?: 'high_res_maps_aggregate_fields';
  avg?: Maybe<High_Res_Maps_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<High_Res_Maps_Max_Fields>;
  min?: Maybe<High_Res_Maps_Min_Fields>;
  stddev?: Maybe<High_Res_Maps_Stddev_Fields>;
  stddev_pop?: Maybe<High_Res_Maps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<High_Res_Maps_Stddev_Samp_Fields>;
  sum?: Maybe<High_Res_Maps_Sum_Fields>;
  var_pop?: Maybe<High_Res_Maps_Var_Pop_Fields>;
  var_samp?: Maybe<High_Res_Maps_Var_Samp_Fields>;
  variance?: Maybe<High_Res_Maps_Variance_Fields>;
};


/** aggregate fields of "high_res_maps" */
export type High_Res_Maps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<High_Res_Maps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type High_Res_Maps_Avg_Fields = {
  __typename?: 'high_res_maps_avg_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "high_res_maps". All fields are combined with a logical 'AND'. */
export type High_Res_Maps_Bool_Exp = {
  _and?: InputMaybe<Array<High_Res_Maps_Bool_Exp>>;
  _not?: InputMaybe<High_Res_Maps_Bool_Exp>;
  _or?: InputMaybe<Array<High_Res_Maps_Bool_Exp>>;
  annotations?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
  annotations_aggregate?: InputMaybe<High_Res_Map_Annotations_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  layers?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
  layers_aggregate?: InputMaybe<High_Res_Map_Layers_Aggregate_Bool_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  seasonShot?: InputMaybe<Field_Season_Shot_Bool_Exp>;
  seasonShotId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "high_res_maps" */
export enum High_Res_Maps_Constraint {
  /** unique or primary key constraint on columns "id" */
  HighResMapsPkey = 'high_res_maps_pkey'
}

/** input type for incrementing numeric columns in table "high_res_maps" */
export type High_Res_Maps_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "high_res_maps" */
export type High_Res_Maps_Insert_Input = {
  annotations?: InputMaybe<High_Res_Map_Annotations_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  layers?: InputMaybe<High_Res_Map_Layers_Arr_Rel_Insert_Input>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seasonShot?: InputMaybe<Field_Season_Shot_Obj_Rel_Insert_Input>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type High_Res_Maps_Max_Fields = {
  __typename?: 'high_res_maps_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type High_Res_Maps_Min_Fields = {
  __typename?: 'high_res_maps_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "high_res_maps" */
export type High_Res_Maps_Mutation_Response = {
  __typename?: 'high_res_maps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<High_Res_Maps>;
};

/** input type for inserting object relation for remote table "high_res_maps" */
export type High_Res_Maps_Obj_Rel_Insert_Input = {
  data: High_Res_Maps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<High_Res_Maps_On_Conflict>;
};

/** on_conflict condition type for table "high_res_maps" */
export type High_Res_Maps_On_Conflict = {
  constraint: High_Res_Maps_Constraint;
  update_columns?: Array<High_Res_Maps_Update_Column>;
  where?: InputMaybe<High_Res_Maps_Bool_Exp>;
};

/** Ordering options when selecting data from "high_res_maps". */
export type High_Res_Maps_Order_By = {
  annotations_aggregate?: InputMaybe<High_Res_Map_Annotations_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  layers_aggregate?: InputMaybe<High_Res_Map_Layers_Aggregate_Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  seasonShot?: InputMaybe<Field_Season_Shot_Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: high_res_maps */
export type High_Res_Maps_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "high_res_maps" */
export enum High_Res_Maps_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  SeasonShotId = 'seasonShotId'
}

/** input type for updating data in table "high_res_maps" */
export type High_Res_Maps_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type High_Res_Maps_Stddev_Fields = {
  __typename?: 'high_res_maps_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type High_Res_Maps_Stddev_Pop_Fields = {
  __typename?: 'high_res_maps_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type High_Res_Maps_Stddev_Samp_Fields = {
  __typename?: 'high_res_maps_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "high_res_maps" */
export type High_Res_Maps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: High_Res_Maps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type High_Res_Maps_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type High_Res_Maps_Sum_Fields = {
  __typename?: 'high_res_maps_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
};

/** update columns of table "high_res_maps" */
export enum High_Res_Maps_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  SeasonShotId = 'seasonShotId'
}

export type High_Res_Maps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<High_Res_Maps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<High_Res_Maps_Set_Input>;
  /** filter the rows which have to be updated */
  where: High_Res_Maps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type High_Res_Maps_Var_Pop_Fields = {
  __typename?: 'high_res_maps_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type High_Res_Maps_Var_Samp_Fields = {
  __typename?: 'high_res_maps_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type High_Res_Maps_Variance_Fields = {
  __typename?: 'high_res_maps_variance_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "implements" */
export type Implements = {
  __typename?: 'implements';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  jobs: Array<Job_Operator_Implements>;
  /** An aggregate relationship */
  jobs_aggregate: Job_Operator_Implements_Aggregate;
  length?: Maybe<Scalars['numeric']>;
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownership: Ownership_Types_Enum;
  status: Entity_Status_Enum;
  userId: Scalars['Int'];
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "implements" */
export type ImplementsJobsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


/** columns and relationships of "implements" */
export type ImplementsJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};

/** aggregated selection of "implements" */
export type Implements_Aggregate = {
  __typename?: 'implements_aggregate';
  aggregate?: Maybe<Implements_Aggregate_Fields>;
  nodes: Array<Implements>;
};

/** aggregate fields of "implements" */
export type Implements_Aggregate_Fields = {
  __typename?: 'implements_aggregate_fields';
  avg?: Maybe<Implements_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Implements_Max_Fields>;
  min?: Maybe<Implements_Min_Fields>;
  stddev?: Maybe<Implements_Stddev_Fields>;
  stddev_pop?: Maybe<Implements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Implements_Stddev_Samp_Fields>;
  sum?: Maybe<Implements_Sum_Fields>;
  var_pop?: Maybe<Implements_Var_Pop_Fields>;
  var_samp?: Maybe<Implements_Var_Samp_Fields>;
  variance?: Maybe<Implements_Variance_Fields>;
};


/** aggregate fields of "implements" */
export type Implements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Implements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Implements_Avg_Fields = {
  __typename?: 'implements_avg_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "implements". All fields are combined with a logical 'AND'. */
export type Implements_Bool_Exp = {
  _and?: InputMaybe<Array<Implements_Bool_Exp>>;
  _not?: InputMaybe<Implements_Bool_Exp>;
  _or?: InputMaybe<Array<Implements_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobs?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
  jobs_aggregate?: InputMaybe<Job_Operator_Implements_Aggregate_Bool_Exp>;
  length?: InputMaybe<Numeric_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownership?: InputMaybe<Ownership_Types_Enum_Comparison_Exp>;
  status?: InputMaybe<Entity_Status_Enum_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
  width?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "implements" */
export enum Implements_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImplementsPkey = 'implements_pkey'
}

/** input type for incrementing numeric columns in table "implements" */
export type Implements_Inc_Input = {
  length?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "implements" */
export type Implements_Insert_Input = {
  brand?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobs?: InputMaybe<Job_Operator_Implements_Arr_Rel_Insert_Input>;
  length?: InputMaybe<Scalars['numeric']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Ownership_Types_Enum>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Implements_Max_Fields = {
  __typename?: 'implements_max_fields';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  length?: Maybe<Scalars['numeric']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Implements_Min_Fields = {
  __typename?: 'implements_min_fields';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  length?: Maybe<Scalars['numeric']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "implements" */
export type Implements_Mutation_Response = {
  __typename?: 'implements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Implements>;
};

/** input type for inserting object relation for remote table "implements" */
export type Implements_Obj_Rel_Insert_Input = {
  data: Implements_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Implements_On_Conflict>;
};

/** on_conflict condition type for table "implements" */
export type Implements_On_Conflict = {
  constraint: Implements_Constraint;
  update_columns?: Array<Implements_Update_Column>;
  where?: InputMaybe<Implements_Bool_Exp>;
};

/** Ordering options when selecting data from "implements". */
export type Implements_Order_By = {
  brand?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<Job_Operator_Implements_Aggregate_Order_By>;
  length?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** primary key columns input for table: implements */
export type Implements_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "implements" */
export enum Implements_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Length = 'length',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'userId',
  /** column name */
  Weight = 'weight',
  /** column name */
  Width = 'width'
}

/** input type for updating data in table "implements" */
export type Implements_Set_Input = {
  brand?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  length?: InputMaybe<Scalars['numeric']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Ownership_Types_Enum>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Implements_Stddev_Fields = {
  __typename?: 'implements_stddev_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Implements_Stddev_Pop_Fields = {
  __typename?: 'implements_stddev_pop_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Implements_Stddev_Samp_Fields = {
  __typename?: 'implements_stddev_samp_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "implements" */
export type Implements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Implements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Implements_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  length?: InputMaybe<Scalars['numeric']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Ownership_Types_Enum>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Implements_Sum_Fields = {
  __typename?: 'implements_sum_fields';
  length?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};

/** update columns of table "implements" */
export enum Implements_Update_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Length = 'length',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'userId',
  /** column name */
  Weight = 'weight',
  /** column name */
  Width = 'width'
}

export type Implements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Implements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Implements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Implements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Implements_Var_Pop_Fields = {
  __typename?: 'implements_var_pop_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Implements_Var_Samp_Fields = {
  __typename?: 'implements_var_samp_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Implements_Variance_Fields = {
  __typename?: 'implements_variance_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "inventory" */
export type Inventory = {
  __typename?: 'inventory';
  amount: Scalars['numeric'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['bigint'];
  price: Scalars['numeric'];
  /** An object relationship */
  product: Products;
  productId: Scalars['uuid'];
  remaining: Scalars['numeric'];
  userId: Scalars['Int'];
  /** An object relationship */
  warehouse?: Maybe<Warehouses>;
  warehouseId?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "inventory" */
export type Inventory_Aggregate = {
  __typename?: 'inventory_aggregate';
  aggregate?: Maybe<Inventory_Aggregate_Fields>;
  nodes: Array<Inventory>;
};

/** aggregate fields of "inventory" */
export type Inventory_Aggregate_Fields = {
  __typename?: 'inventory_aggregate_fields';
  avg?: Maybe<Inventory_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Inventory_Max_Fields>;
  min?: Maybe<Inventory_Min_Fields>;
  stddev?: Maybe<Inventory_Stddev_Fields>;
  stddev_pop?: Maybe<Inventory_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Inventory_Stddev_Samp_Fields>;
  sum?: Maybe<Inventory_Sum_Fields>;
  var_pop?: Maybe<Inventory_Var_Pop_Fields>;
  var_samp?: Maybe<Inventory_Var_Samp_Fields>;
  variance?: Maybe<Inventory_Variance_Fields>;
};


/** aggregate fields of "inventory" */
export type Inventory_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Inventory_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Inventory_Avg_Fields = {
  __typename?: 'inventory_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remaining?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "inventory". All fields are combined with a logical 'AND'. */
export type Inventory_Bool_Exp = {
  _and?: InputMaybe<Array<Inventory_Bool_Exp>>;
  _not?: InputMaybe<Inventory_Bool_Exp>;
  _or?: InputMaybe<Array<Inventory_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  remaining?: InputMaybe<Numeric_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  warehouse?: InputMaybe<Warehouses_Bool_Exp>;
  warehouseId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "inventory" */
export enum Inventory_Constraint {
  /** unique or primary key constraint on columns "id" */
  InventoryPkey = 'inventory_pkey'
}

/** input type for incrementing numeric columns in table "inventory" */
export type Inventory_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['numeric']>;
  remaining?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "inventory" */
export type Inventory_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  remaining?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['Int']>;
  warehouse?: InputMaybe<Warehouses_Obj_Rel_Insert_Input>;
  warehouseId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Inventory_Max_Fields = {
  __typename?: 'inventory_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['numeric']>;
  productId?: Maybe<Scalars['uuid']>;
  remaining?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Inventory_Min_Fields = {
  __typename?: 'inventory_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['numeric']>;
  productId?: Maybe<Scalars['uuid']>;
  remaining?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "inventory" */
export type Inventory_Mutation_Response = {
  __typename?: 'inventory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Inventory>;
};

/** on_conflict condition type for table "inventory" */
export type Inventory_On_Conflict = {
  constraint: Inventory_Constraint;
  update_columns?: Array<Inventory_Update_Column>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};

/** Ordering options when selecting data from "inventory". */
export type Inventory_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  productId?: InputMaybe<Order_By>;
  remaining?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Warehouses_Order_By>;
  warehouseId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: inventory */
export type Inventory_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "inventory" */
export enum Inventory_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Remaining = 'remaining',
  /** column name */
  UserId = 'userId',
  /** column name */
  WarehouseId = 'warehouseId'
}

/** input type for updating data in table "inventory" */
export type Inventory_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['numeric']>;
  productId?: InputMaybe<Scalars['uuid']>;
  remaining?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Inventory_Stddev_Fields = {
  __typename?: 'inventory_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remaining?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Inventory_Stddev_Pop_Fields = {
  __typename?: 'inventory_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remaining?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Inventory_Stddev_Samp_Fields = {
  __typename?: 'inventory_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remaining?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "inventory" */
export type Inventory_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Inventory_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Inventory_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  price?: InputMaybe<Scalars['numeric']>;
  productId?: InputMaybe<Scalars['uuid']>;
  remaining?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['Int']>;
  warehouseId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Inventory_Sum_Fields = {
  __typename?: 'inventory_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  price?: Maybe<Scalars['numeric']>;
  remaining?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
  warehouseId?: Maybe<Scalars['bigint']>;
};

/** update columns of table "inventory" */
export enum Inventory_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Remaining = 'remaining',
  /** column name */
  UserId = 'userId',
  /** column name */
  WarehouseId = 'warehouseId'
}

export type Inventory_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Inventory_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Inventory_Set_Input>;
  /** filter the rows which have to be updated */
  where: Inventory_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Inventory_Var_Pop_Fields = {
  __typename?: 'inventory_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remaining?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Inventory_Var_Samp_Fields = {
  __typename?: 'inventory_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remaining?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Inventory_Variance_Fields = {
  __typename?: 'inventory_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  remaining?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  warehouseId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_extras" */
export type Job_Extras = {
  __typename?: 'job_extras';
  /** An object relationship */
  job: Jobs;
  jobId: Scalars['bigint'];
  name: Scalars['String'];
  unit: Chargeable_Units_Enum;
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_extras" */
export type Job_Extras_Aggregate = {
  __typename?: 'job_extras_aggregate';
  aggregate?: Maybe<Job_Extras_Aggregate_Fields>;
  nodes: Array<Job_Extras>;
};

export type Job_Extras_Aggregate_Bool_Exp = {
  count?: InputMaybe<Job_Extras_Aggregate_Bool_Exp_Count>;
};

export type Job_Extras_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Extras_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_extras" */
export type Job_Extras_Aggregate_Fields = {
  __typename?: 'job_extras_aggregate_fields';
  avg?: Maybe<Job_Extras_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Extras_Max_Fields>;
  min?: Maybe<Job_Extras_Min_Fields>;
  stddev?: Maybe<Job_Extras_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Extras_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Extras_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Extras_Sum_Fields>;
  var_pop?: Maybe<Job_Extras_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Extras_Var_Samp_Fields>;
  variance?: Maybe<Job_Extras_Variance_Fields>;
};


/** aggregate fields of "job_extras" */
export type Job_Extras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_extras" */
export type Job_Extras_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Extras_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Extras_Max_Order_By>;
  min?: InputMaybe<Job_Extras_Min_Order_By>;
  stddev?: InputMaybe<Job_Extras_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Extras_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Extras_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Extras_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Extras_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Extras_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Extras_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_extras" */
export type Job_Extras_Arr_Rel_Insert_Input = {
  data: Array<Job_Extras_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Extras_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Extras_Avg_Fields = {
  __typename?: 'job_extras_avg_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_extras" */
export type Job_Extras_Avg_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_extras". All fields are combined with a logical 'AND'. */
export type Job_Extras_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Extras_Bool_Exp>>;
  _not?: InputMaybe<Job_Extras_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Extras_Bool_Exp>>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  jobId?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Chargeable_Units_Enum_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_extras" */
export enum Job_Extras_Constraint {
  /** unique or primary key constraint on columns "name", "job_id" */
  JobExtrasPkey = 'job_extras_pkey'
}

/** input type for incrementing numeric columns in table "job_extras" */
export type Job_Extras_Inc_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_extras" */
export type Job_Extras_Insert_Input = {
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Chargeable_Units_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Extras_Max_Fields = {
  __typename?: 'job_extras_max_fields';
  jobId?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "job_extras" */
export type Job_Extras_Max_Order_By = {
  jobId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Extras_Min_Fields = {
  __typename?: 'job_extras_min_fields';
  jobId?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "job_extras" */
export type Job_Extras_Min_Order_By = {
  jobId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_extras" */
export type Job_Extras_Mutation_Response = {
  __typename?: 'job_extras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Extras>;
};

/** on_conflict condition type for table "job_extras" */
export type Job_Extras_On_Conflict = {
  constraint: Job_Extras_Constraint;
  update_columns?: Array<Job_Extras_Update_Column>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};

/** Ordering options when selecting data from "job_extras". */
export type Job_Extras_Order_By = {
  job?: InputMaybe<Jobs_Order_By>;
  jobId?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_extras */
export type Job_Extras_Pk_Columns_Input = {
  jobId: Scalars['bigint'];
  name: Scalars['String'];
};

/** select columns of table "job_extras" */
export enum Job_Extras_Select_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  Name = 'name',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "job_extras" */
export type Job_Extras_Set_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Chargeable_Units_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Extras_Stddev_Fields = {
  __typename?: 'job_extras_stddev_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_extras" */
export type Job_Extras_Stddev_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Extras_Stddev_Pop_Fields = {
  __typename?: 'job_extras_stddev_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_extras" */
export type Job_Extras_Stddev_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Extras_Stddev_Samp_Fields = {
  __typename?: 'job_extras_stddev_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_extras" */
export type Job_Extras_Stddev_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_extras" */
export type Job_Extras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Extras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Extras_Stream_Cursor_Value_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Chargeable_Units_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Extras_Sum_Fields = {
  __typename?: 'job_extras_sum_fields';
  jobId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "job_extras" */
export type Job_Extras_Sum_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** update columns of table "job_extras" */
export enum Job_Extras_Update_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  Name = 'name',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

export type Job_Extras_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Extras_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Extras_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Extras_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Extras_Var_Pop_Fields = {
  __typename?: 'job_extras_var_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_extras" */
export type Job_Extras_Var_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Extras_Var_Samp_Fields = {
  __typename?: 'job_extras_var_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_extras" */
export type Job_Extras_Var_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Extras_Variance_Fields = {
  __typename?: 'job_extras_variance_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_extras" */
export type Job_Extras_Variance_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** columns and relationships of "job_fields" */
export type Job_Fields = {
  __typename?: 'job_fields';
  /** An object relationship */
  job: Jobs;
  jobId: Scalars['bigint'];
  /** An object relationship */
  seasonShot: Field_Season_Shot;
  seasonShotId: Scalars['bigint'];
};

/** aggregated selection of "job_fields" */
export type Job_Fields_Aggregate = {
  __typename?: 'job_fields_aggregate';
  aggregate?: Maybe<Job_Fields_Aggregate_Fields>;
  nodes: Array<Job_Fields>;
};

export type Job_Fields_Aggregate_Bool_Exp = {
  count?: InputMaybe<Job_Fields_Aggregate_Bool_Exp_Count>;
};

export type Job_Fields_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Fields_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_fields" */
export type Job_Fields_Aggregate_Fields = {
  __typename?: 'job_fields_aggregate_fields';
  avg?: Maybe<Job_Fields_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Fields_Max_Fields>;
  min?: Maybe<Job_Fields_Min_Fields>;
  stddev?: Maybe<Job_Fields_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Fields_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Fields_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Fields_Sum_Fields>;
  var_pop?: Maybe<Job_Fields_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Fields_Var_Samp_Fields>;
  variance?: Maybe<Job_Fields_Variance_Fields>;
};


/** aggregate fields of "job_fields" */
export type Job_Fields_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Fields_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_fields" */
export type Job_Fields_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Fields_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Fields_Max_Order_By>;
  min?: InputMaybe<Job_Fields_Min_Order_By>;
  stddev?: InputMaybe<Job_Fields_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Fields_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Fields_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Fields_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Fields_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Fields_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Fields_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_fields" */
export type Job_Fields_Arr_Rel_Insert_Input = {
  data: Array<Job_Fields_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Fields_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Fields_Avg_Fields = {
  __typename?: 'job_fields_avg_fields';
  jobId?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_fields" */
export type Job_Fields_Avg_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_fields". All fields are combined with a logical 'AND'. */
export type Job_Fields_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Fields_Bool_Exp>>;
  _not?: InputMaybe<Job_Fields_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Fields_Bool_Exp>>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  jobId?: InputMaybe<Bigint_Comparison_Exp>;
  seasonShot?: InputMaybe<Field_Season_Shot_Bool_Exp>;
  seasonShotId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_fields" */
export enum Job_Fields_Constraint {
  /** unique or primary key constraint on columns "season_shot_id", "job_id" */
  JobFieldsPkey = 'job_fields_pkey'
}

/** input type for incrementing numeric columns in table "job_fields" */
export type Job_Fields_Inc_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_fields" */
export type Job_Fields_Insert_Input = {
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['bigint']>;
  seasonShot?: InputMaybe<Field_Season_Shot_Obj_Rel_Insert_Input>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Job_Fields_Max_Fields = {
  __typename?: 'job_fields_max_fields';
  jobId?: Maybe<Scalars['bigint']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "job_fields" */
export type Job_Fields_Max_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Fields_Min_Fields = {
  __typename?: 'job_fields_min_fields';
  jobId?: Maybe<Scalars['bigint']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "job_fields" */
export type Job_Fields_Min_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_fields" */
export type Job_Fields_Mutation_Response = {
  __typename?: 'job_fields_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Fields>;
};

/** on_conflict condition type for table "job_fields" */
export type Job_Fields_On_Conflict = {
  constraint: Job_Fields_Constraint;
  update_columns?: Array<Job_Fields_Update_Column>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};

/** Ordering options when selecting data from "job_fields". */
export type Job_Fields_Order_By = {
  job?: InputMaybe<Jobs_Order_By>;
  jobId?: InputMaybe<Order_By>;
  seasonShot?: InputMaybe<Field_Season_Shot_Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_fields */
export type Job_Fields_Pk_Columns_Input = {
  jobId: Scalars['bigint'];
  seasonShotId: Scalars['bigint'];
};

/** select columns of table "job_fields" */
export enum Job_Fields_Select_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  SeasonShotId = 'seasonShotId'
}

/** input type for updating data in table "job_fields" */
export type Job_Fields_Set_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Job_Fields_Stddev_Fields = {
  __typename?: 'job_fields_stddev_fields';
  jobId?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_fields" */
export type Job_Fields_Stddev_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Fields_Stddev_Pop_Fields = {
  __typename?: 'job_fields_stddev_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_fields" */
export type Job_Fields_Stddev_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Fields_Stddev_Samp_Fields = {
  __typename?: 'job_fields_stddev_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_fields" */
export type Job_Fields_Stddev_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_fields" */
export type Job_Fields_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Fields_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Fields_Stream_Cursor_Value_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Job_Fields_Sum_Fields = {
  __typename?: 'job_fields_sum_fields';
  jobId?: Maybe<Scalars['bigint']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "job_fields" */
export type Job_Fields_Sum_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** update columns of table "job_fields" */
export enum Job_Fields_Update_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  SeasonShotId = 'seasonShotId'
}

export type Job_Fields_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Fields_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Fields_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Fields_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Fields_Var_Pop_Fields = {
  __typename?: 'job_fields_var_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_fields" */
export type Job_Fields_Var_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Fields_Var_Samp_Fields = {
  __typename?: 'job_fields_var_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_fields" */
export type Job_Fields_Var_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Fields_Variance_Fields = {
  __typename?: 'job_fields_variance_fields';
  jobId?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_fields" */
export type Job_Fields_Variance_Order_By = {
  jobId?: InputMaybe<Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
};

/** columns and relationships of "job_locations" */
export type Job_Locations = {
  __typename?: 'job_locations';
  geoLocation?: Maybe<Scalars['point']>;
  id: Scalars['bigint'];
  /** An object relationship */
  job: Jobs;
  jobId: Scalars['bigint'];
  notes: Scalars['String'];
};

/** aggregated selection of "job_locations" */
export type Job_Locations_Aggregate = {
  __typename?: 'job_locations_aggregate';
  aggregate?: Maybe<Job_Locations_Aggregate_Fields>;
  nodes: Array<Job_Locations>;
};

export type Job_Locations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Job_Locations_Aggregate_Bool_Exp_Count>;
};

export type Job_Locations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Locations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_locations" */
export type Job_Locations_Aggregate_Fields = {
  __typename?: 'job_locations_aggregate_fields';
  avg?: Maybe<Job_Locations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Locations_Max_Fields>;
  min?: Maybe<Job_Locations_Min_Fields>;
  stddev?: Maybe<Job_Locations_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Locations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Locations_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Locations_Sum_Fields>;
  var_pop?: Maybe<Job_Locations_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Locations_Var_Samp_Fields>;
  variance?: Maybe<Job_Locations_Variance_Fields>;
};


/** aggregate fields of "job_locations" */
export type Job_Locations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Locations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_locations" */
export type Job_Locations_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Locations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Locations_Max_Order_By>;
  min?: InputMaybe<Job_Locations_Min_Order_By>;
  stddev?: InputMaybe<Job_Locations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Locations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Locations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Locations_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Locations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Locations_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Locations_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_locations" */
export type Job_Locations_Arr_Rel_Insert_Input = {
  data: Array<Job_Locations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Locations_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Locations_Avg_Fields = {
  __typename?: 'job_locations_avg_fields';
  id?: Maybe<Scalars['Float']>;
  jobId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_locations" */
export type Job_Locations_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_locations". All fields are combined with a logical 'AND'. */
export type Job_Locations_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Locations_Bool_Exp>>;
  _not?: InputMaybe<Job_Locations_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Locations_Bool_Exp>>;
  geoLocation?: InputMaybe<Point_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  jobId?: InputMaybe<Bigint_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_locations" */
export enum Job_Locations_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobLocationsPkey = 'job_locations_pkey'
}

/** input type for incrementing numeric columns in table "job_locations" */
export type Job_Locations_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  jobId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_locations" */
export type Job_Locations_Insert_Input = {
  geoLocation?: InputMaybe<Scalars['point']>;
  id?: InputMaybe<Scalars['bigint']>;
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['bigint']>;
  notes?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Locations_Max_Fields = {
  __typename?: 'job_locations_max_fields';
  id?: Maybe<Scalars['bigint']>;
  jobId?: Maybe<Scalars['bigint']>;
  notes?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "job_locations" */
export type Job_Locations_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Locations_Min_Fields = {
  __typename?: 'job_locations_min_fields';
  id?: Maybe<Scalars['bigint']>;
  jobId?: Maybe<Scalars['bigint']>;
  notes?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "job_locations" */
export type Job_Locations_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_locations" */
export type Job_Locations_Mutation_Response = {
  __typename?: 'job_locations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Locations>;
};

/** on_conflict condition type for table "job_locations" */
export type Job_Locations_On_Conflict = {
  constraint: Job_Locations_Constraint;
  update_columns?: Array<Job_Locations_Update_Column>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};

/** Ordering options when selecting data from "job_locations". */
export type Job_Locations_Order_By = {
  geoLocation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job?: InputMaybe<Jobs_Order_By>;
  jobId?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_locations */
export type Job_Locations_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "job_locations" */
export enum Job_Locations_Select_Column {
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  Notes = 'notes'
}

/** input type for updating data in table "job_locations" */
export type Job_Locations_Set_Input = {
  geoLocation?: InputMaybe<Scalars['point']>;
  id?: InputMaybe<Scalars['bigint']>;
  jobId?: InputMaybe<Scalars['bigint']>;
  notes?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Locations_Stddev_Fields = {
  __typename?: 'job_locations_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_locations" */
export type Job_Locations_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Locations_Stddev_Pop_Fields = {
  __typename?: 'job_locations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_locations" */
export type Job_Locations_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Locations_Stddev_Samp_Fields = {
  __typename?: 'job_locations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_locations" */
export type Job_Locations_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_locations" */
export type Job_Locations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Locations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Locations_Stream_Cursor_Value_Input = {
  geoLocation?: InputMaybe<Scalars['point']>;
  id?: InputMaybe<Scalars['bigint']>;
  jobId?: InputMaybe<Scalars['bigint']>;
  notes?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Locations_Sum_Fields = {
  __typename?: 'job_locations_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  jobId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "job_locations" */
export type Job_Locations_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** update columns of table "job_locations" */
export enum Job_Locations_Update_Column {
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  Notes = 'notes'
}

export type Job_Locations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Locations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Locations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Locations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Locations_Var_Pop_Fields = {
  __typename?: 'job_locations_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  jobId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_locations" */
export type Job_Locations_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Locations_Var_Samp_Fields = {
  __typename?: 'job_locations_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  jobId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_locations" */
export type Job_Locations_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Locations_Variance_Fields = {
  __typename?: 'job_locations_variance_fields';
  id?: Maybe<Scalars['Float']>;
  jobId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_locations" */
export type Job_Locations_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
};

/** columns and relationships of "job_operator_implements" */
export type Job_Operator_Implements = {
  __typename?: 'job_operator_implements';
  /** An object relationship */
  implement: Implements;
  implementId: Scalars['uuid'];
  /** An object relationship */
  job: Jobs;
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};

/** aggregated selection of "job_operator_implements" */
export type Job_Operator_Implements_Aggregate = {
  __typename?: 'job_operator_implements_aggregate';
  aggregate?: Maybe<Job_Operator_Implements_Aggregate_Fields>;
  nodes: Array<Job_Operator_Implements>;
};

export type Job_Operator_Implements_Aggregate_Bool_Exp = {
  count?: InputMaybe<Job_Operator_Implements_Aggregate_Bool_Exp_Count>;
};

export type Job_Operator_Implements_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_operator_implements" */
export type Job_Operator_Implements_Aggregate_Fields = {
  __typename?: 'job_operator_implements_aggregate_fields';
  avg?: Maybe<Job_Operator_Implements_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Operator_Implements_Max_Fields>;
  min?: Maybe<Job_Operator_Implements_Min_Fields>;
  stddev?: Maybe<Job_Operator_Implements_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Operator_Implements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Operator_Implements_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Operator_Implements_Sum_Fields>;
  var_pop?: Maybe<Job_Operator_Implements_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Operator_Implements_Var_Samp_Fields>;
  variance?: Maybe<Job_Operator_Implements_Variance_Fields>;
};


/** aggregate fields of "job_operator_implements" */
export type Job_Operator_Implements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_operator_implements" */
export type Job_Operator_Implements_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Operator_Implements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Operator_Implements_Max_Order_By>;
  min?: InputMaybe<Job_Operator_Implements_Min_Order_By>;
  stddev?: InputMaybe<Job_Operator_Implements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Operator_Implements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Operator_Implements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Operator_Implements_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Operator_Implements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Operator_Implements_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Operator_Implements_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_operator_implements" */
export type Job_Operator_Implements_Arr_Rel_Insert_Input = {
  data: Array<Job_Operator_Implements_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Operator_Implements_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Operator_Implements_Avg_Fields = {
  __typename?: 'job_operator_implements_avg_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Avg_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_operator_implements". All fields are combined with a logical 'AND'. */
export type Job_Operator_Implements_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Operator_Implements_Bool_Exp>>;
  _not?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Operator_Implements_Bool_Exp>>;
  implement?: InputMaybe<Implements_Bool_Exp>;
  implementId?: InputMaybe<Uuid_Comparison_Exp>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  jobId?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_operator_implements" */
export enum Job_Operator_Implements_Constraint {
  /** unique or primary key constraint on columns "job_id", "user_id", "implement_id" */
  JobOperatorImplementsPkey = 'job_operator_implements_pkey'
}

/** input type for incrementing numeric columns in table "job_operator_implements" */
export type Job_Operator_Implements_Inc_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_operator_implements" */
export type Job_Operator_Implements_Insert_Input = {
  implement?: InputMaybe<Implements_Obj_Rel_Insert_Input>;
  implementId?: InputMaybe<Scalars['uuid']>;
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Job_Operator_Implements_Max_Fields = {
  __typename?: 'job_operator_implements_max_fields';
  implementId?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Max_Order_By = {
  implementId?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Operator_Implements_Min_Fields = {
  __typename?: 'job_operator_implements_min_fields';
  implementId?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Min_Order_By = {
  implementId?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_operator_implements" */
export type Job_Operator_Implements_Mutation_Response = {
  __typename?: 'job_operator_implements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Operator_Implements>;
};

/** on_conflict condition type for table "job_operator_implements" */
export type Job_Operator_Implements_On_Conflict = {
  constraint: Job_Operator_Implements_Constraint;
  update_columns?: Array<Job_Operator_Implements_Update_Column>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};

/** Ordering options when selecting data from "job_operator_implements". */
export type Job_Operator_Implements_Order_By = {
  implement?: InputMaybe<Implements_Order_By>;
  implementId?: InputMaybe<Order_By>;
  job?: InputMaybe<Jobs_Order_By>;
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_operator_implements */
export type Job_Operator_Implements_Pk_Columns_Input = {
  implementId: Scalars['uuid'];
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};

/** select columns of table "job_operator_implements" */
export enum Job_Operator_Implements_Select_Column {
  /** column name */
  ImplementId = 'implementId',
  /** column name */
  JobId = 'jobId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "job_operator_implements" */
export type Job_Operator_Implements_Set_Input = {
  implementId?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Job_Operator_Implements_Stddev_Fields = {
  __typename?: 'job_operator_implements_stddev_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Stddev_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Operator_Implements_Stddev_Pop_Fields = {
  __typename?: 'job_operator_implements_stddev_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Stddev_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Operator_Implements_Stddev_Samp_Fields = {
  __typename?: 'job_operator_implements_stddev_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Stddev_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_operator_implements" */
export type Job_Operator_Implements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Operator_Implements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Operator_Implements_Stream_Cursor_Value_Input = {
  implementId?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Job_Operator_Implements_Sum_Fields = {
  __typename?: 'job_operator_implements_sum_fields';
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Sum_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "job_operator_implements" */
export enum Job_Operator_Implements_Update_Column {
  /** column name */
  ImplementId = 'implementId',
  /** column name */
  JobId = 'jobId',
  /** column name */
  UserId = 'userId'
}

export type Job_Operator_Implements_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Operator_Implements_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Operator_Implements_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Operator_Implements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Operator_Implements_Var_Pop_Fields = {
  __typename?: 'job_operator_implements_var_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Var_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Operator_Implements_Var_Samp_Fields = {
  __typename?: 'job_operator_implements_var_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Var_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Operator_Implements_Variance_Fields = {
  __typename?: 'job_operator_implements_variance_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_operator_implements" */
export type Job_Operator_Implements_Variance_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "job_operator_vehicles" */
export type Job_Operator_Vehicles = {
  __typename?: 'job_operator_vehicles';
  /** An object relationship */
  job: Jobs;
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
  /** An object relationship */
  vehicle: Vehicles;
  vehicleId: Scalars['uuid'];
};

/** aggregated selection of "job_operator_vehicles" */
export type Job_Operator_Vehicles_Aggregate = {
  __typename?: 'job_operator_vehicles_aggregate';
  aggregate?: Maybe<Job_Operator_Vehicles_Aggregate_Fields>;
  nodes: Array<Job_Operator_Vehicles>;
};

export type Job_Operator_Vehicles_Aggregate_Bool_Exp = {
  count?: InputMaybe<Job_Operator_Vehicles_Aggregate_Bool_Exp_Count>;
};

export type Job_Operator_Vehicles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_operator_vehicles" */
export type Job_Operator_Vehicles_Aggregate_Fields = {
  __typename?: 'job_operator_vehicles_aggregate_fields';
  avg?: Maybe<Job_Operator_Vehicles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Operator_Vehicles_Max_Fields>;
  min?: Maybe<Job_Operator_Vehicles_Min_Fields>;
  stddev?: Maybe<Job_Operator_Vehicles_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Operator_Vehicles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Operator_Vehicles_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Operator_Vehicles_Sum_Fields>;
  var_pop?: Maybe<Job_Operator_Vehicles_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Operator_Vehicles_Var_Samp_Fields>;
  variance?: Maybe<Job_Operator_Vehicles_Variance_Fields>;
};


/** aggregate fields of "job_operator_vehicles" */
export type Job_Operator_Vehicles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Operator_Vehicles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Operator_Vehicles_Max_Order_By>;
  min?: InputMaybe<Job_Operator_Vehicles_Min_Order_By>;
  stddev?: InputMaybe<Job_Operator_Vehicles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Operator_Vehicles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Operator_Vehicles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Operator_Vehicles_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Operator_Vehicles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Operator_Vehicles_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Operator_Vehicles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Arr_Rel_Insert_Input = {
  data: Array<Job_Operator_Vehicles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Operator_Vehicles_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Operator_Vehicles_Avg_Fields = {
  __typename?: 'job_operator_vehicles_avg_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Avg_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_operator_vehicles". All fields are combined with a logical 'AND'. */
export type Job_Operator_Vehicles_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Operator_Vehicles_Bool_Exp>>;
  _not?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Operator_Vehicles_Bool_Exp>>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  jobId?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  vehicle?: InputMaybe<Vehicles_Bool_Exp>;
  vehicleId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_operator_vehicles" */
export enum Job_Operator_Vehicles_Constraint {
  /** unique or primary key constraint on columns "job_id", "vehicle_id", "user_id" */
  JobOperatorVehiclesPkey = 'job_operator_vehicles_pkey'
}

/** input type for incrementing numeric columns in table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Inc_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Insert_Input = {
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
  vehicle?: InputMaybe<Vehicles_Obj_Rel_Insert_Input>;
  vehicleId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Job_Operator_Vehicles_Max_Fields = {
  __typename?: 'job_operator_vehicles_max_fields';
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
  vehicleId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Max_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  vehicleId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Operator_Vehicles_Min_Fields = {
  __typename?: 'job_operator_vehicles_min_fields';
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
  vehicleId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Min_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  vehicleId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Mutation_Response = {
  __typename?: 'job_operator_vehicles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Operator_Vehicles>;
};

/** on_conflict condition type for table "job_operator_vehicles" */
export type Job_Operator_Vehicles_On_Conflict = {
  constraint: Job_Operator_Vehicles_Constraint;
  update_columns?: Array<Job_Operator_Vehicles_Update_Column>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};

/** Ordering options when selecting data from "job_operator_vehicles". */
export type Job_Operator_Vehicles_Order_By = {
  job?: InputMaybe<Jobs_Order_By>;
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  vehicle?: InputMaybe<Vehicles_Order_By>;
  vehicleId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_operator_vehicles */
export type Job_Operator_Vehicles_Pk_Columns_Input = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
  vehicleId: Scalars['uuid'];
};

/** select columns of table "job_operator_vehicles" */
export enum Job_Operator_Vehicles_Select_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  UserId = 'userId',
  /** column name */
  VehicleId = 'vehicleId'
}

/** input type for updating data in table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Set_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Job_Operator_Vehicles_Stddev_Fields = {
  __typename?: 'job_operator_vehicles_stddev_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Stddev_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Operator_Vehicles_Stddev_Pop_Fields = {
  __typename?: 'job_operator_vehicles_stddev_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Stddev_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Operator_Vehicles_Stddev_Samp_Fields = {
  __typename?: 'job_operator_vehicles_stddev_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Stddev_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Operator_Vehicles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Operator_Vehicles_Stream_Cursor_Value_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Job_Operator_Vehicles_Sum_Fields = {
  __typename?: 'job_operator_vehicles_sum_fields';
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Sum_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "job_operator_vehicles" */
export enum Job_Operator_Vehicles_Update_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  UserId = 'userId',
  /** column name */
  VehicleId = 'vehicleId'
}

export type Job_Operator_Vehicles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Operator_Vehicles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Operator_Vehicles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Operator_Vehicles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Operator_Vehicles_Var_Pop_Fields = {
  __typename?: 'job_operator_vehicles_var_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Var_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Operator_Vehicles_Var_Samp_Fields = {
  __typename?: 'job_operator_vehicles_var_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Var_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Operator_Vehicles_Variance_Fields = {
  __typename?: 'job_operator_vehicles_variance_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_operator_vehicles" */
export type Job_Operator_Vehicles_Variance_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "job_operators" */
export type Job_Operators = {
  __typename?: 'job_operators';
  /** An array relationship */
  implements: Array<Job_Operator_Implements>;
  /** An aggregate relationship */
  implements_aggregate: Job_Operator_Implements_Aggregate;
  /** An object relationship */
  job: Jobs;
  jobId: Scalars['bigint'];
  teamLead?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['Int'];
  /** An array relationship */
  vehicles: Array<Job_Operator_Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Job_Operator_Vehicles_Aggregate;
};


/** columns and relationships of "job_operators" */
export type Job_OperatorsImplementsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


/** columns and relationships of "job_operators" */
export type Job_OperatorsImplements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


/** columns and relationships of "job_operators" */
export type Job_OperatorsVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


/** columns and relationships of "job_operators" */
export type Job_OperatorsVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};

/** aggregated selection of "job_operators" */
export type Job_Operators_Aggregate = {
  __typename?: 'job_operators_aggregate';
  aggregate?: Maybe<Job_Operators_Aggregate_Fields>;
  nodes: Array<Job_Operators>;
};

export type Job_Operators_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Job_Operators_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Job_Operators_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Job_Operators_Aggregate_Bool_Exp_Count>;
};

export type Job_Operators_Aggregate_Bool_Exp_Bool_And = {
  arguments: Job_Operators_Select_Column_Job_Operators_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Operators_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Operators_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Job_Operators_Select_Column_Job_Operators_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Operators_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Operators_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Operators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Operators_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_operators" */
export type Job_Operators_Aggregate_Fields = {
  __typename?: 'job_operators_aggregate_fields';
  avg?: Maybe<Job_Operators_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Operators_Max_Fields>;
  min?: Maybe<Job_Operators_Min_Fields>;
  stddev?: Maybe<Job_Operators_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Operators_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Operators_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Operators_Sum_Fields>;
  var_pop?: Maybe<Job_Operators_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Operators_Var_Samp_Fields>;
  variance?: Maybe<Job_Operators_Variance_Fields>;
};


/** aggregate fields of "job_operators" */
export type Job_Operators_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Operators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_operators" */
export type Job_Operators_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Operators_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Operators_Max_Order_By>;
  min?: InputMaybe<Job_Operators_Min_Order_By>;
  stddev?: InputMaybe<Job_Operators_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Operators_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Operators_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Operators_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Operators_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Operators_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Operators_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_operators" */
export type Job_Operators_Arr_Rel_Insert_Input = {
  data: Array<Job_Operators_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Operators_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Operators_Avg_Fields = {
  __typename?: 'job_operators_avg_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_operators" */
export type Job_Operators_Avg_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_operators". All fields are combined with a logical 'AND'. */
export type Job_Operators_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Operators_Bool_Exp>>;
  _not?: InputMaybe<Job_Operators_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Operators_Bool_Exp>>;
  implements?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
  implements_aggregate?: InputMaybe<Job_Operator_Implements_Aggregate_Bool_Exp>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  jobId?: InputMaybe<Bigint_Comparison_Exp>;
  teamLead?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  vehicles?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Job_Operator_Vehicles_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "job_operators" */
export enum Job_Operators_Constraint {
  /** unique or primary key constraint on columns "job_id", "user_id" */
  JobOperatorsPkey = 'job_operators_pkey'
}

/** input type for incrementing numeric columns in table "job_operators" */
export type Job_Operators_Inc_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_operators" */
export type Job_Operators_Insert_Input = {
  implements?: InputMaybe<Job_Operator_Implements_Arr_Rel_Insert_Input>;
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['bigint']>;
  teamLead?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
  vehicles?: InputMaybe<Job_Operator_Vehicles_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Job_Operators_Max_Fields = {
  __typename?: 'job_operators_max_fields';
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "job_operators" */
export type Job_Operators_Max_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Operators_Min_Fields = {
  __typename?: 'job_operators_min_fields';
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "job_operators" */
export type Job_Operators_Min_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_operators" */
export type Job_Operators_Mutation_Response = {
  __typename?: 'job_operators_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Operators>;
};

/** on_conflict condition type for table "job_operators" */
export type Job_Operators_On_Conflict = {
  constraint: Job_Operators_Constraint;
  update_columns?: Array<Job_Operators_Update_Column>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};

/** Ordering options when selecting data from "job_operators". */
export type Job_Operators_Order_By = {
  implements_aggregate?: InputMaybe<Job_Operator_Implements_Aggregate_Order_By>;
  job?: InputMaybe<Jobs_Order_By>;
  jobId?: InputMaybe<Order_By>;
  teamLead?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  vehicles_aggregate?: InputMaybe<Job_Operator_Vehicles_Aggregate_Order_By>;
};

/** primary key columns input for table: job_operators */
export type Job_Operators_Pk_Columns_Input = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};

/** select columns of table "job_operators" */
export enum Job_Operators_Select_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  TeamLead = 'teamLead',
  /** column name */
  UserId = 'userId'
}

/** select "job_operators_aggregate_bool_exp_bool_and_arguments_columns" columns of table "job_operators" */
export enum Job_Operators_Select_Column_Job_Operators_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  TeamLead = 'teamLead'
}

/** select "job_operators_aggregate_bool_exp_bool_or_arguments_columns" columns of table "job_operators" */
export enum Job_Operators_Select_Column_Job_Operators_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  TeamLead = 'teamLead'
}

/** input type for updating data in table "job_operators" */
export type Job_Operators_Set_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  teamLead?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Job_Operators_Stddev_Fields = {
  __typename?: 'job_operators_stddev_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_operators" */
export type Job_Operators_Stddev_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Operators_Stddev_Pop_Fields = {
  __typename?: 'job_operators_stddev_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_operators" */
export type Job_Operators_Stddev_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Operators_Stddev_Samp_Fields = {
  __typename?: 'job_operators_stddev_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_operators" */
export type Job_Operators_Stddev_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_operators" */
export type Job_Operators_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Operators_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Operators_Stream_Cursor_Value_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  teamLead?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Job_Operators_Sum_Fields = {
  __typename?: 'job_operators_sum_fields';
  jobId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_operators" */
export type Job_Operators_Sum_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "job_operators" */
export enum Job_Operators_Update_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  TeamLead = 'teamLead',
  /** column name */
  UserId = 'userId'
}

export type Job_Operators_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Operators_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Operators_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Operators_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Operators_Var_Pop_Fields = {
  __typename?: 'job_operators_var_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_operators" */
export type Job_Operators_Var_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Operators_Var_Samp_Fields = {
  __typename?: 'job_operators_var_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_operators" */
export type Job_Operators_Var_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Operators_Variance_Fields = {
  __typename?: 'job_operators_variance_fields';
  jobId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_operators" */
export type Job_Operators_Variance_Order_By = {
  jobId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "job_products" */
export type Job_Products = {
  __typename?: 'job_products';
  /** An object relationship */
  job: Jobs;
  jobId: Scalars['bigint'];
  locked: Scalars['Boolean'];
  /** An object relationship */
  product: Products;
  productId: Scalars['uuid'];
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "job_products" */
export type Job_Products_Aggregate = {
  __typename?: 'job_products_aggregate';
  aggregate?: Maybe<Job_Products_Aggregate_Fields>;
  nodes: Array<Job_Products>;
};

export type Job_Products_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Job_Products_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Job_Products_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Job_Products_Aggregate_Bool_Exp_Count>;
};

export type Job_Products_Aggregate_Bool_Exp_Bool_And = {
  arguments: Job_Products_Select_Column_Job_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Products_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Products_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Job_Products_Select_Column_Job_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Products_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_products" */
export type Job_Products_Aggregate_Fields = {
  __typename?: 'job_products_aggregate_fields';
  avg?: Maybe<Job_Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Job_Products_Max_Fields>;
  min?: Maybe<Job_Products_Min_Fields>;
  stddev?: Maybe<Job_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Job_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Job_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Job_Products_Sum_Fields>;
  var_pop?: Maybe<Job_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Job_Products_Var_Samp_Fields>;
  variance?: Maybe<Job_Products_Variance_Fields>;
};


/** aggregate fields of "job_products" */
export type Job_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_products" */
export type Job_Products_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Products_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Products_Max_Order_By>;
  min?: InputMaybe<Job_Products_Min_Order_By>;
  stddev?: InputMaybe<Job_Products_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Products_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Products_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Products_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Products_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Products_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_products" */
export type Job_Products_Arr_Rel_Insert_Input = {
  data: Array<Job_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Products_Avg_Fields = {
  __typename?: 'job_products_avg_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_products" */
export type Job_Products_Avg_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_products". All fields are combined with a logical 'AND'. */
export type Job_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Products_Bool_Exp>>;
  _not?: InputMaybe<Job_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Products_Bool_Exp>>;
  job?: InputMaybe<Jobs_Bool_Exp>;
  jobId?: InputMaybe<Bigint_Comparison_Exp>;
  locked?: InputMaybe<Boolean_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_products" */
export enum Job_Products_Constraint {
  /** unique or primary key constraint on columns "job_id", "product_id" */
  JobProductsPkey = 'job_products_pkey'
}

/** input type for incrementing numeric columns in table "job_products" */
export type Job_Products_Inc_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_products" */
export type Job_Products_Insert_Input = {
  job?: InputMaybe<Jobs_Obj_Rel_Insert_Input>;
  jobId?: InputMaybe<Scalars['bigint']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Products_Max_Fields = {
  __typename?: 'job_products_max_fields';
  jobId?: Maybe<Scalars['bigint']>;
  productId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "job_products" */
export type Job_Products_Max_Order_By = {
  jobId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Products_Min_Fields = {
  __typename?: 'job_products_min_fields';
  jobId?: Maybe<Scalars['bigint']>;
  productId?: Maybe<Scalars['uuid']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "job_products" */
export type Job_Products_Min_Order_By = {
  jobId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_products" */
export type Job_Products_Mutation_Response = {
  __typename?: 'job_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Products>;
};

/** on_conflict condition type for table "job_products" */
export type Job_Products_On_Conflict = {
  constraint: Job_Products_Constraint;
  update_columns?: Array<Job_Products_Update_Column>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "job_products". */
export type Job_Products_Order_By = {
  job?: InputMaybe<Jobs_Order_By>;
  jobId?: InputMaybe<Order_By>;
  locked?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  productId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_products */
export type Job_Products_Pk_Columns_Input = {
  jobId: Scalars['bigint'];
  productId: Scalars['uuid'];
};

/** select columns of table "job_products" */
export enum Job_Products_Select_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  Locked = 'locked',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Value = 'value'
}

/** select "job_products_aggregate_bool_exp_bool_and_arguments_columns" columns of table "job_products" */
export enum Job_Products_Select_Column_Job_Products_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Locked = 'locked'
}

/** select "job_products_aggregate_bool_exp_bool_or_arguments_columns" columns of table "job_products" */
export enum Job_Products_Select_Column_Job_Products_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Locked = 'locked'
}

/** input type for updating data in table "job_products" */
export type Job_Products_Set_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Job_Products_Stddev_Fields = {
  __typename?: 'job_products_stddev_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_products" */
export type Job_Products_Stddev_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Products_Stddev_Pop_Fields = {
  __typename?: 'job_products_stddev_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_products" */
export type Job_Products_Stddev_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Products_Stddev_Samp_Fields = {
  __typename?: 'job_products_stddev_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_products" */
export type Job_Products_Stddev_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_products" */
export type Job_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Products_Stream_Cursor_Value_Input = {
  jobId?: InputMaybe<Scalars['bigint']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Job_Products_Sum_Fields = {
  __typename?: 'job_products_sum_fields';
  jobId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "job_products" */
export type Job_Products_Sum_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** update columns of table "job_products" */
export enum Job_Products_Update_Column {
  /** column name */
  JobId = 'jobId',
  /** column name */
  Locked = 'locked',
  /** column name */
  ProductId = 'productId',
  /** column name */
  Value = 'value'
}

export type Job_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Products_Var_Pop_Fields = {
  __typename?: 'job_products_var_pop_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_products" */
export type Job_Products_Var_Pop_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Products_Var_Samp_Fields = {
  __typename?: 'job_products_var_samp_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_products" */
export type Job_Products_Var_Samp_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Products_Variance_Fields = {
  __typename?: 'job_products_variance_fields';
  jobId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_products" */
export type Job_Products_Variance_Order_By = {
  jobId?: InputMaybe<Order_By>;
};

/** columns and relationships of "job_status" */
export type Job_Status = {
  __typename?: 'job_status';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "job_status" */
export type Job_Status_Aggregate = {
  __typename?: 'job_status_aggregate';
  aggregate?: Maybe<Job_Status_Aggregate_Fields>;
  nodes: Array<Job_Status>;
};

/** aggregate fields of "job_status" */
export type Job_Status_Aggregate_Fields = {
  __typename?: 'job_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Job_Status_Max_Fields>;
  min?: Maybe<Job_Status_Min_Fields>;
};


/** aggregate fields of "job_status" */
export type Job_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_status". All fields are combined with a logical 'AND'. */
export type Job_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Status_Bool_Exp>>;
  _not?: InputMaybe<Job_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_status" */
export enum Job_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  JobStatusPkey = 'job_status_pkey'
}

export enum Job_Status_Enum {
  Cancelled = 'cancelled',
  Completed = 'completed',
  InProgress = 'in_progress',
  PartlyCompleted = 'partly_completed',
  Pending = 'pending',
  PendingCompletion = 'pending_completion',
  Ready = 'ready'
}

/** Boolean expression to compare columns of type "job_status_enum". All fields are combined with logical 'AND'. */
export type Job_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Job_Status_Enum>;
  _in?: InputMaybe<Array<Job_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Job_Status_Enum>;
  _nin?: InputMaybe<Array<Job_Status_Enum>>;
};

/** input type for inserting data into table "job_status" */
export type Job_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Job_Status_Max_Fields = {
  __typename?: 'job_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Job_Status_Min_Fields = {
  __typename?: 'job_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "job_status" */
export type Job_Status_Mutation_Response = {
  __typename?: 'job_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Status>;
};

/** on_conflict condition type for table "job_status" */
export type Job_Status_On_Conflict = {
  constraint: Job_Status_Constraint;
  update_columns?: Array<Job_Status_Update_Column>;
  where?: InputMaybe<Job_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "job_status". */
export type Job_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_status */
export type Job_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "job_status" */
export enum Job_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "job_status" */
export type Job_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "job_status" */
export type Job_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "job_status" */
export enum Job_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Job_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Status_Bool_Exp;
};

/** columns and relationships of "jobs" */
export type Jobs = {
  __typename?: 'jobs';
  /** An object relationship */
  assignedUser: Users;
  assignedUserId: Scalars['bigint'];
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  extras: Array<Job_Extras>;
  /** An aggregate relationship */
  extras_aggregate: Job_Extras_Aggregate;
  /** An array relationship */
  fields: Array<Job_Fields>;
  /** An aggregate relationship */
  fields_aggregate: Job_Fields_Aggregate;
  from?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  /** An array relationship */
  implements: Array<Job_Operator_Implements>;
  /** An aggregate relationship */
  implements_aggregate: Job_Operator_Implements_Aggregate;
  instructions?: Maybe<Scalars['String']>;
  /** An array relationship */
  locations: Array<Job_Locations>;
  /** An aggregate relationship */
  locations_aggregate: Job_Locations_Aggregate;
  /** An object relationship */
  operation?: Maybe<Operations>;
  operationId?: Maybe<Scalars['bigint']>;
  operationName: Scalars['String'];
  /** An array relationship */
  operators: Array<Job_Operators>;
  /** An aggregate relationship */
  operators_aggregate: Job_Operators_Aggregate;
  /** An array relationship */
  products: Array<Job_Products>;
  /** An aggregate relationship */
  products_aggregate: Job_Products_Aggregate;
  status: Job_Status_Enum;
  to?: Maybe<Scalars['timestamptz']>;
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint'];
  /** An array relationship */
  vehicles: Array<Job_Operator_Vehicles>;
  /** An aggregate relationship */
  vehicles_aggregate: Job_Operator_Vehicles_Aggregate;
};


/** columns and relationships of "jobs" */
export type JobsExtrasArgs = {
  distinct_on?: InputMaybe<Array<Job_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Extras_Order_By>>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsExtras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Extras_Order_By>>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsFieldsArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsImplementsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsImplements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsLocationsArgs = {
  distinct_on?: InputMaybe<Array<Job_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Locations_Order_By>>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsLocations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Locations_Order_By>>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsOperatorsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operators_Order_By>>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsOperators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operators_Order_By>>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsProductsArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


/** columns and relationships of "jobs" */
export type JobsVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};

/** aggregated selection of "jobs" */
export type Jobs_Aggregate = {
  __typename?: 'jobs_aggregate';
  aggregate?: Maybe<Jobs_Aggregate_Fields>;
  nodes: Array<Jobs>;
};

export type Jobs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Jobs_Aggregate_Bool_Exp_Count>;
};

export type Jobs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Jobs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "jobs" */
export type Jobs_Aggregate_Fields = {
  __typename?: 'jobs_aggregate_fields';
  avg?: Maybe<Jobs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Jobs_Max_Fields>;
  min?: Maybe<Jobs_Min_Fields>;
  stddev?: Maybe<Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Jobs_Sum_Fields>;
  var_pop?: Maybe<Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Jobs_Var_Samp_Fields>;
  variance?: Maybe<Jobs_Variance_Fields>;
};


/** aggregate fields of "jobs" */
export type Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "jobs" */
export type Jobs_Aggregate_Order_By = {
  avg?: InputMaybe<Jobs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Jobs_Max_Order_By>;
  min?: InputMaybe<Jobs_Min_Order_By>;
  stddev?: InputMaybe<Jobs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Jobs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Jobs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Jobs_Sum_Order_By>;
  var_pop?: InputMaybe<Jobs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Jobs_Var_Samp_Order_By>;
  variance?: InputMaybe<Jobs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "jobs" */
export type Jobs_Arr_Rel_Insert_Input = {
  data: Array<Jobs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** aggregate avg on columns */
export type Jobs_Avg_Fields = {
  __typename?: 'jobs_avg_fields';
  assignedUserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "jobs" */
export type Jobs_Avg_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "jobs". All fields are combined with a logical 'AND'. */
export type Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Jobs_Bool_Exp>>;
  _not?: InputMaybe<Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Jobs_Bool_Exp>>;
  assignedUser?: InputMaybe<Users_Bool_Exp>;
  assignedUserId?: InputMaybe<Bigint_Comparison_Exp>;
  completedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  extras?: InputMaybe<Job_Extras_Bool_Exp>;
  extras_aggregate?: InputMaybe<Job_Extras_Aggregate_Bool_Exp>;
  fields?: InputMaybe<Job_Fields_Bool_Exp>;
  fields_aggregate?: InputMaybe<Job_Fields_Aggregate_Bool_Exp>;
  from?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  implements?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
  implements_aggregate?: InputMaybe<Job_Operator_Implements_Aggregate_Bool_Exp>;
  instructions?: InputMaybe<String_Comparison_Exp>;
  locations?: InputMaybe<Job_Locations_Bool_Exp>;
  locations_aggregate?: InputMaybe<Job_Locations_Aggregate_Bool_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operationId?: InputMaybe<Bigint_Comparison_Exp>;
  operationName?: InputMaybe<String_Comparison_Exp>;
  operators?: InputMaybe<Job_Operators_Bool_Exp>;
  operators_aggregate?: InputMaybe<Job_Operators_Aggregate_Bool_Exp>;
  products?: InputMaybe<Job_Products_Bool_Exp>;
  products_aggregate?: InputMaybe<Job_Products_Aggregate_Bool_Exp>;
  status?: InputMaybe<Job_Status_Enum_Comparison_Exp>;
  to?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
  vehicles?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
  vehicles_aggregate?: InputMaybe<Job_Operator_Vehicles_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "jobs" */
export enum Jobs_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobsPkey = 'jobs_pkey'
}

/** input type for incrementing numeric columns in table "jobs" */
export type Jobs_Inc_Input = {
  assignedUserId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  operationId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "jobs" */
export type Jobs_Insert_Input = {
  assignedUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  assignedUserId?: InputMaybe<Scalars['bigint']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  extras?: InputMaybe<Job_Extras_Arr_Rel_Insert_Input>;
  fields?: InputMaybe<Job_Fields_Arr_Rel_Insert_Input>;
  from?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  implements?: InputMaybe<Job_Operator_Implements_Arr_Rel_Insert_Input>;
  instructions?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Job_Locations_Arr_Rel_Insert_Input>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operationId?: InputMaybe<Scalars['bigint']>;
  operationName?: InputMaybe<Scalars['String']>;
  operators?: InputMaybe<Job_Operators_Arr_Rel_Insert_Input>;
  products?: InputMaybe<Job_Products_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Job_Status_Enum>;
  to?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['bigint']>;
  vehicles?: InputMaybe<Job_Operator_Vehicles_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Jobs_Max_Fields = {
  __typename?: 'jobs_max_fields';
  assignedUserId?: Maybe<Scalars['bigint']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  from?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  instructions?: Maybe<Scalars['String']>;
  operationId?: Maybe<Scalars['bigint']>;
  operationName?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "jobs" */
export type Jobs_Max_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  completedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  operationName?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Jobs_Min_Fields = {
  __typename?: 'jobs_min_fields';
  assignedUserId?: Maybe<Scalars['bigint']>;
  completedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  from?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  instructions?: Maybe<Scalars['String']>;
  operationId?: Maybe<Scalars['bigint']>;
  operationName?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['timestamptz']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "jobs" */
export type Jobs_Min_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  completedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instructions?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  operationName?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "jobs" */
export type Jobs_Mutation_Response = {
  __typename?: 'jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Jobs>;
};

/** input type for inserting object relation for remote table "jobs" */
export type Jobs_Obj_Rel_Insert_Input = {
  data: Jobs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};

/** on_conflict condition type for table "jobs" */
export type Jobs_On_Conflict = {
  constraint: Jobs_Constraint;
  update_columns?: Array<Jobs_Update_Column>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "jobs". */
export type Jobs_Order_By = {
  assignedUser?: InputMaybe<Users_Order_By>;
  assignedUserId?: InputMaybe<Order_By>;
  completedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  extras_aggregate?: InputMaybe<Job_Extras_Aggregate_Order_By>;
  fields_aggregate?: InputMaybe<Job_Fields_Aggregate_Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  implements_aggregate?: InputMaybe<Job_Operator_Implements_Aggregate_Order_By>;
  instructions?: InputMaybe<Order_By>;
  locations_aggregate?: InputMaybe<Job_Locations_Aggregate_Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operationId?: InputMaybe<Order_By>;
  operationName?: InputMaybe<Order_By>;
  operators_aggregate?: InputMaybe<Job_Operators_Aggregate_Order_By>;
  products_aggregate?: InputMaybe<Job_Products_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
  vehicles_aggregate?: InputMaybe<Job_Operator_Vehicles_Aggregate_Order_By>;
};

/** primary key columns input for table: jobs */
export type Jobs_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "jobs" */
export enum Jobs_Select_Column {
  /** column name */
  AssignedUserId = 'assignedUserId',
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  OperationId = 'operationId',
  /** column name */
  OperationName = 'operationName',
  /** column name */
  Status = 'status',
  /** column name */
  To = 'to',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "jobs" */
export type Jobs_Set_Input = {
  assignedUserId?: InputMaybe<Scalars['bigint']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  from?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  instructions?: InputMaybe<Scalars['String']>;
  operationId?: InputMaybe<Scalars['bigint']>;
  operationName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Job_Status_Enum>;
  to?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Jobs_Stddev_Fields = {
  __typename?: 'jobs_stddev_fields';
  assignedUserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "jobs" */
export type Jobs_Stddev_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Jobs_Stddev_Pop_Fields = {
  __typename?: 'jobs_stddev_pop_fields';
  assignedUserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "jobs" */
export type Jobs_Stddev_Pop_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Jobs_Stddev_Samp_Fields = {
  __typename?: 'jobs_stddev_samp_fields';
  assignedUserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "jobs" */
export type Jobs_Stddev_Samp_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "jobs" */
export type Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Jobs_Stream_Cursor_Value_Input = {
  assignedUserId?: InputMaybe<Scalars['bigint']>;
  completedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  from?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  instructions?: InputMaybe<Scalars['String']>;
  operationId?: InputMaybe<Scalars['bigint']>;
  operationName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Job_Status_Enum>;
  to?: InputMaybe<Scalars['timestamptz']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Jobs_Sum_Fields = {
  __typename?: 'jobs_sum_fields';
  assignedUserId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  operationId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "jobs" */
export type Jobs_Sum_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "jobs" */
export enum Jobs_Update_Column {
  /** column name */
  AssignedUserId = 'assignedUserId',
  /** column name */
  CompletedAt = 'completedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  Instructions = 'instructions',
  /** column name */
  OperationId = 'operationId',
  /** column name */
  OperationName = 'operationName',
  /** column name */
  Status = 'status',
  /** column name */
  To = 'to',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Jobs_Var_Pop_Fields = {
  __typename?: 'jobs_var_pop_fields';
  assignedUserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "jobs" */
export type Jobs_Var_Pop_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Jobs_Var_Samp_Fields = {
  __typename?: 'jobs_var_samp_fields';
  assignedUserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "jobs" */
export type Jobs_Var_Samp_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Jobs_Variance_Fields = {
  __typename?: 'jobs_variance_fields';
  assignedUserId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "jobs" */
export type Jobs_Variance_Order_By = {
  assignedUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  api_accept_invite?: Maybe<Api_Accept_Invite_Output>;
  api_sign_up_user?: Maybe<Api_Sign_Up_User_Output>;
  /** delete data from the table: "chargeable_units" */
  delete_chargeable_units?: Maybe<Chargeable_Units_Mutation_Response>;
  /** delete single row from the table: "chargeable_units" */
  delete_chargeable_units_by_pk?: Maybe<Chargeable_Units>;
  /** delete data from the table: "entity_status" */
  delete_entity_status?: Maybe<Entity_Status_Mutation_Response>;
  /** delete single row from the table: "entity_status" */
  delete_entity_status_by_pk?: Maybe<Entity_Status>;
  /** delete data from the table: "farms" */
  delete_farms?: Maybe<Farms_Mutation_Response>;
  /** delete single row from the table: "farms" */
  delete_farms_by_pk?: Maybe<Farms>;
  /** delete data from the table: "field_season_shot" */
  delete_field_season_shot?: Maybe<Field_Season_Shot_Mutation_Response>;
  /** delete single row from the table: "field_season_shot" */
  delete_field_season_shot_by_pk?: Maybe<Field_Season_Shot>;
  /** delete data from the table: "fields" */
  delete_fields?: Maybe<Fields_Mutation_Response>;
  /** delete single row from the table: "fields" */
  delete_fields_by_pk?: Maybe<Fields>;
  /** delete data from the table: "high_res_map_annotations" */
  delete_high_res_map_annotations?: Maybe<High_Res_Map_Annotations_Mutation_Response>;
  /** delete single row from the table: "high_res_map_annotations" */
  delete_high_res_map_annotations_by_pk?: Maybe<High_Res_Map_Annotations>;
  /** delete data from the table: "high_res_map_layers" */
  delete_high_res_map_layers?: Maybe<High_Res_Map_Layers_Mutation_Response>;
  /** delete single row from the table: "high_res_map_layers" */
  delete_high_res_map_layers_by_pk?: Maybe<High_Res_Map_Layers>;
  /** delete data from the table: "high_res_maps" */
  delete_high_res_maps?: Maybe<High_Res_Maps_Mutation_Response>;
  /** delete single row from the table: "high_res_maps" */
  delete_high_res_maps_by_pk?: Maybe<High_Res_Maps>;
  /** delete data from the table: "implements" */
  delete_implements?: Maybe<Implements_Mutation_Response>;
  /** delete single row from the table: "implements" */
  delete_implements_by_pk?: Maybe<Implements>;
  /** delete data from the table: "inventory" */
  delete_inventory?: Maybe<Inventory_Mutation_Response>;
  /** delete single row from the table: "inventory" */
  delete_inventory_by_pk?: Maybe<Inventory>;
  /** delete data from the table: "job_extras" */
  delete_job_extras?: Maybe<Job_Extras_Mutation_Response>;
  /** delete single row from the table: "job_extras" */
  delete_job_extras_by_pk?: Maybe<Job_Extras>;
  /** delete data from the table: "job_fields" */
  delete_job_fields?: Maybe<Job_Fields_Mutation_Response>;
  /** delete single row from the table: "job_fields" */
  delete_job_fields_by_pk?: Maybe<Job_Fields>;
  /** delete data from the table: "job_locations" */
  delete_job_locations?: Maybe<Job_Locations_Mutation_Response>;
  /** delete single row from the table: "job_locations" */
  delete_job_locations_by_pk?: Maybe<Job_Locations>;
  /** delete data from the table: "job_operator_implements" */
  delete_job_operator_implements?: Maybe<Job_Operator_Implements_Mutation_Response>;
  /** delete single row from the table: "job_operator_implements" */
  delete_job_operator_implements_by_pk?: Maybe<Job_Operator_Implements>;
  /** delete data from the table: "job_operator_vehicles" */
  delete_job_operator_vehicles?: Maybe<Job_Operator_Vehicles_Mutation_Response>;
  /** delete single row from the table: "job_operator_vehicles" */
  delete_job_operator_vehicles_by_pk?: Maybe<Job_Operator_Vehicles>;
  /** delete data from the table: "job_operators" */
  delete_job_operators?: Maybe<Job_Operators_Mutation_Response>;
  /** delete single row from the table: "job_operators" */
  delete_job_operators_by_pk?: Maybe<Job_Operators>;
  /** delete data from the table: "job_products" */
  delete_job_products?: Maybe<Job_Products_Mutation_Response>;
  /** delete single row from the table: "job_products" */
  delete_job_products_by_pk?: Maybe<Job_Products>;
  /** delete data from the table: "job_status" */
  delete_job_status?: Maybe<Job_Status_Mutation_Response>;
  /** delete single row from the table: "job_status" */
  delete_job_status_by_pk?: Maybe<Job_Status>;
  /** delete data from the table: "jobs" */
  delete_jobs?: Maybe<Jobs_Mutation_Response>;
  /** delete single row from the table: "jobs" */
  delete_jobs_by_pk?: Maybe<Jobs>;
  /** delete data from the table: "operation_extras" */
  delete_operation_extras?: Maybe<Operation_Extras_Mutation_Response>;
  /** delete single row from the table: "operation_extras" */
  delete_operation_extras_by_pk?: Maybe<Operation_Extras>;
  /** delete data from the table: "operation_products" */
  delete_operation_products?: Maybe<Operation_Products_Mutation_Response>;
  /** delete single row from the table: "operation_products" */
  delete_operation_products_by_pk?: Maybe<Operation_Products>;
  /** delete data from the table: "operations" */
  delete_operations?: Maybe<Operations_Mutation_Response>;
  /** delete single row from the table: "operations" */
  delete_operations_by_pk?: Maybe<Operations>;
  /** delete data from the table: "otps" */
  delete_otps?: Maybe<Otps_Mutation_Response>;
  /** delete single row from the table: "otps" */
  delete_otps_by_pk?: Maybe<Otps>;
  /** delete data from the table: "ownership_types" */
  delete_ownership_types?: Maybe<Ownership_Types_Mutation_Response>;
  /** delete single row from the table: "ownership_types" */
  delete_ownership_types_by_pk?: Maybe<Ownership_Types>;
  /** delete data from the table: "polygons" */
  delete_polygons?: Maybe<Polygons_Mutation_Response>;
  /** delete single row from the table: "polygons" */
  delete_polygons_by_pk?: Maybe<Polygons>;
  /** delete data from the table: "products" */
  delete_products?: Maybe<Products_Mutation_Response>;
  /** delete single row from the table: "products" */
  delete_products_by_pk?: Maybe<Products>;
  /** delete data from the table: "reports" */
  delete_reports?: Maybe<Reports_Mutation_Response>;
  /** delete single row from the table: "reports" */
  delete_reports_by_pk?: Maybe<Reports>;
  /** delete data from the table: "roles" */
  delete_roles?: Maybe<Roles_Mutation_Response>;
  /** delete single row from the table: "roles" */
  delete_roles_by_pk?: Maybe<Roles>;
  /** delete data from the table: "team_members" */
  delete_team_members?: Maybe<Team_Members_Mutation_Response>;
  /** delete single row from the table: "team_members" */
  delete_team_members_by_pk?: Maybe<Team_Members>;
  /** delete data from the table: "user_invites" */
  delete_user_invites?: Maybe<User_Invites_Mutation_Response>;
  /** delete single row from the table: "user_invites" */
  delete_user_invites_by_pk?: Maybe<User_Invites>;
  /** delete data from the table: "user_prefs" */
  delete_user_prefs?: Maybe<User_Prefs_Mutation_Response>;
  /** delete single row from the table: "user_prefs" */
  delete_user_prefs_by_pk?: Maybe<User_Prefs>;
  /** delete data from the table: "user_profiles" */
  delete_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** delete single row from the table: "user_profiles" */
  delete_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** delete data from the table: "user_roles" */
  delete_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** delete single row from the table: "user_roles" */
  delete_user_roles_by_pk?: Maybe<User_Roles>;
  /** delete data from the table: "user_tax_rates" */
  delete_user_tax_rates?: Maybe<User_Tax_Rates_Mutation_Response>;
  /** delete single row from the table: "user_tax_rates" */
  delete_user_tax_rates_by_pk?: Maybe<User_Tax_Rates>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "vehicles" */
  delete_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** delete single row from the table: "vehicles" */
  delete_vehicles_by_pk?: Maybe<Vehicles>;
  /** delete data from the table: "warehouses" */
  delete_warehouses?: Maybe<Warehouses_Mutation_Response>;
  /** delete single row from the table: "warehouses" */
  delete_warehouses_by_pk?: Maybe<Warehouses>;
  /** insert data into the table: "chargeable_units" */
  insert_chargeable_units?: Maybe<Chargeable_Units_Mutation_Response>;
  /** insert a single row into the table: "chargeable_units" */
  insert_chargeable_units_one?: Maybe<Chargeable_Units>;
  /** insert data into the table: "entity_status" */
  insert_entity_status?: Maybe<Entity_Status_Mutation_Response>;
  /** insert a single row into the table: "entity_status" */
  insert_entity_status_one?: Maybe<Entity_Status>;
  /** insert data into the table: "farms" */
  insert_farms?: Maybe<Farms_Mutation_Response>;
  /** insert a single row into the table: "farms" */
  insert_farms_one?: Maybe<Farms>;
  /** insert data into the table: "field_season_shot" */
  insert_field_season_shot?: Maybe<Field_Season_Shot_Mutation_Response>;
  /** insert a single row into the table: "field_season_shot" */
  insert_field_season_shot_one?: Maybe<Field_Season_Shot>;
  /** insert data into the table: "fields" */
  insert_fields?: Maybe<Fields_Mutation_Response>;
  /** insert a single row into the table: "fields" */
  insert_fields_one?: Maybe<Fields>;
  /** insert data into the table: "high_res_map_annotations" */
  insert_high_res_map_annotations?: Maybe<High_Res_Map_Annotations_Mutation_Response>;
  /** insert a single row into the table: "high_res_map_annotations" */
  insert_high_res_map_annotations_one?: Maybe<High_Res_Map_Annotations>;
  /** insert data into the table: "high_res_map_layers" */
  insert_high_res_map_layers?: Maybe<High_Res_Map_Layers_Mutation_Response>;
  /** insert a single row into the table: "high_res_map_layers" */
  insert_high_res_map_layers_one?: Maybe<High_Res_Map_Layers>;
  /** insert data into the table: "high_res_maps" */
  insert_high_res_maps?: Maybe<High_Res_Maps_Mutation_Response>;
  /** insert a single row into the table: "high_res_maps" */
  insert_high_res_maps_one?: Maybe<High_Res_Maps>;
  /** insert data into the table: "implements" */
  insert_implements?: Maybe<Implements_Mutation_Response>;
  /** insert a single row into the table: "implements" */
  insert_implements_one?: Maybe<Implements>;
  /** insert data into the table: "inventory" */
  insert_inventory?: Maybe<Inventory_Mutation_Response>;
  /** insert a single row into the table: "inventory" */
  insert_inventory_one?: Maybe<Inventory>;
  /** insert data into the table: "job_extras" */
  insert_job_extras?: Maybe<Job_Extras_Mutation_Response>;
  /** insert a single row into the table: "job_extras" */
  insert_job_extras_one?: Maybe<Job_Extras>;
  /** insert data into the table: "job_fields" */
  insert_job_fields?: Maybe<Job_Fields_Mutation_Response>;
  /** insert a single row into the table: "job_fields" */
  insert_job_fields_one?: Maybe<Job_Fields>;
  /** insert data into the table: "job_locations" */
  insert_job_locations?: Maybe<Job_Locations_Mutation_Response>;
  /** insert a single row into the table: "job_locations" */
  insert_job_locations_one?: Maybe<Job_Locations>;
  /** insert data into the table: "job_operator_implements" */
  insert_job_operator_implements?: Maybe<Job_Operator_Implements_Mutation_Response>;
  /** insert a single row into the table: "job_operator_implements" */
  insert_job_operator_implements_one?: Maybe<Job_Operator_Implements>;
  /** insert data into the table: "job_operator_vehicles" */
  insert_job_operator_vehicles?: Maybe<Job_Operator_Vehicles_Mutation_Response>;
  /** insert a single row into the table: "job_operator_vehicles" */
  insert_job_operator_vehicles_one?: Maybe<Job_Operator_Vehicles>;
  /** insert data into the table: "job_operators" */
  insert_job_operators?: Maybe<Job_Operators_Mutation_Response>;
  /** insert a single row into the table: "job_operators" */
  insert_job_operators_one?: Maybe<Job_Operators>;
  /** insert data into the table: "job_products" */
  insert_job_products?: Maybe<Job_Products_Mutation_Response>;
  /** insert a single row into the table: "job_products" */
  insert_job_products_one?: Maybe<Job_Products>;
  /** insert data into the table: "job_status" */
  insert_job_status?: Maybe<Job_Status_Mutation_Response>;
  /** insert a single row into the table: "job_status" */
  insert_job_status_one?: Maybe<Job_Status>;
  /** insert data into the table: "jobs" */
  insert_jobs?: Maybe<Jobs_Mutation_Response>;
  /** insert a single row into the table: "jobs" */
  insert_jobs_one?: Maybe<Jobs>;
  /** insert data into the table: "operation_extras" */
  insert_operation_extras?: Maybe<Operation_Extras_Mutation_Response>;
  /** insert a single row into the table: "operation_extras" */
  insert_operation_extras_one?: Maybe<Operation_Extras>;
  /** insert data into the table: "operation_products" */
  insert_operation_products?: Maybe<Operation_Products_Mutation_Response>;
  /** insert a single row into the table: "operation_products" */
  insert_operation_products_one?: Maybe<Operation_Products>;
  /** insert data into the table: "operations" */
  insert_operations?: Maybe<Operations_Mutation_Response>;
  /** insert a single row into the table: "operations" */
  insert_operations_one?: Maybe<Operations>;
  /** insert data into the table: "otps" */
  insert_otps?: Maybe<Otps_Mutation_Response>;
  /** insert a single row into the table: "otps" */
  insert_otps_one?: Maybe<Otps>;
  /** insert data into the table: "ownership_types" */
  insert_ownership_types?: Maybe<Ownership_Types_Mutation_Response>;
  /** insert a single row into the table: "ownership_types" */
  insert_ownership_types_one?: Maybe<Ownership_Types>;
  /** insert data into the table: "polygons" */
  insert_polygons?: Maybe<Polygons_Mutation_Response>;
  /** insert a single row into the table: "polygons" */
  insert_polygons_one?: Maybe<Polygons>;
  /** insert data into the table: "products" */
  insert_products?: Maybe<Products_Mutation_Response>;
  /** insert a single row into the table: "products" */
  insert_products_one?: Maybe<Products>;
  /** insert data into the table: "reports" */
  insert_reports?: Maybe<Reports_Mutation_Response>;
  /** insert a single row into the table: "reports" */
  insert_reports_one?: Maybe<Reports>;
  /** insert data into the table: "roles" */
  insert_roles?: Maybe<Roles_Mutation_Response>;
  /** insert a single row into the table: "roles" */
  insert_roles_one?: Maybe<Roles>;
  /** insert data into the table: "team_members" */
  insert_team_members?: Maybe<Team_Members_Mutation_Response>;
  /** insert a single row into the table: "team_members" */
  insert_team_members_one?: Maybe<Team_Members>;
  /** insert data into the table: "user_invites" */
  insert_user_invites?: Maybe<User_Invites_Mutation_Response>;
  /** insert a single row into the table: "user_invites" */
  insert_user_invites_one?: Maybe<User_Invites>;
  /** insert data into the table: "user_prefs" */
  insert_user_prefs?: Maybe<User_Prefs_Mutation_Response>;
  /** insert a single row into the table: "user_prefs" */
  insert_user_prefs_one?: Maybe<User_Prefs>;
  /** insert data into the table: "user_profiles" */
  insert_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** insert a single row into the table: "user_profiles" */
  insert_user_profiles_one?: Maybe<User_Profiles>;
  /** insert data into the table: "user_roles" */
  insert_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** insert a single row into the table: "user_roles" */
  insert_user_roles_one?: Maybe<User_Roles>;
  /** insert data into the table: "user_tax_rates" */
  insert_user_tax_rates?: Maybe<User_Tax_Rates_Mutation_Response>;
  /** insert a single row into the table: "user_tax_rates" */
  insert_user_tax_rates_one?: Maybe<User_Tax_Rates>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "vehicles" */
  insert_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** insert a single row into the table: "vehicles" */
  insert_vehicles_one?: Maybe<Vehicles>;
  /** insert data into the table: "warehouses" */
  insert_warehouses?: Maybe<Warehouses_Mutation_Response>;
  /** insert a single row into the table: "warehouses" */
  insert_warehouses_one?: Maybe<Warehouses>;
  required?: Maybe<Scalars['Int']>;
  /** update data of the table: "chargeable_units" */
  update_chargeable_units?: Maybe<Chargeable_Units_Mutation_Response>;
  /** update single row of the table: "chargeable_units" */
  update_chargeable_units_by_pk?: Maybe<Chargeable_Units>;
  /** update multiples rows of table: "chargeable_units" */
  update_chargeable_units_many?: Maybe<Array<Maybe<Chargeable_Units_Mutation_Response>>>;
  /** update data of the table: "entity_status" */
  update_entity_status?: Maybe<Entity_Status_Mutation_Response>;
  /** update single row of the table: "entity_status" */
  update_entity_status_by_pk?: Maybe<Entity_Status>;
  /** update multiples rows of table: "entity_status" */
  update_entity_status_many?: Maybe<Array<Maybe<Entity_Status_Mutation_Response>>>;
  /** update data of the table: "farms" */
  update_farms?: Maybe<Farms_Mutation_Response>;
  /** update single row of the table: "farms" */
  update_farms_by_pk?: Maybe<Farms>;
  /** update multiples rows of table: "farms" */
  update_farms_many?: Maybe<Array<Maybe<Farms_Mutation_Response>>>;
  /** update data of the table: "field_season_shot" */
  update_field_season_shot?: Maybe<Field_Season_Shot_Mutation_Response>;
  /** update single row of the table: "field_season_shot" */
  update_field_season_shot_by_pk?: Maybe<Field_Season_Shot>;
  /** update multiples rows of table: "field_season_shot" */
  update_field_season_shot_many?: Maybe<Array<Maybe<Field_Season_Shot_Mutation_Response>>>;
  /** update data of the table: "fields" */
  update_fields?: Maybe<Fields_Mutation_Response>;
  /** update single row of the table: "fields" */
  update_fields_by_pk?: Maybe<Fields>;
  /** update multiples rows of table: "fields" */
  update_fields_many?: Maybe<Array<Maybe<Fields_Mutation_Response>>>;
  /** update data of the table: "high_res_map_annotations" */
  update_high_res_map_annotations?: Maybe<High_Res_Map_Annotations_Mutation_Response>;
  /** update single row of the table: "high_res_map_annotations" */
  update_high_res_map_annotations_by_pk?: Maybe<High_Res_Map_Annotations>;
  /** update multiples rows of table: "high_res_map_annotations" */
  update_high_res_map_annotations_many?: Maybe<Array<Maybe<High_Res_Map_Annotations_Mutation_Response>>>;
  /** update data of the table: "high_res_map_layers" */
  update_high_res_map_layers?: Maybe<High_Res_Map_Layers_Mutation_Response>;
  /** update single row of the table: "high_res_map_layers" */
  update_high_res_map_layers_by_pk?: Maybe<High_Res_Map_Layers>;
  /** update multiples rows of table: "high_res_map_layers" */
  update_high_res_map_layers_many?: Maybe<Array<Maybe<High_Res_Map_Layers_Mutation_Response>>>;
  /** update data of the table: "high_res_maps" */
  update_high_res_maps?: Maybe<High_Res_Maps_Mutation_Response>;
  /** update single row of the table: "high_res_maps" */
  update_high_res_maps_by_pk?: Maybe<High_Res_Maps>;
  /** update multiples rows of table: "high_res_maps" */
  update_high_res_maps_many?: Maybe<Array<Maybe<High_Res_Maps_Mutation_Response>>>;
  /** update data of the table: "implements" */
  update_implements?: Maybe<Implements_Mutation_Response>;
  /** update single row of the table: "implements" */
  update_implements_by_pk?: Maybe<Implements>;
  /** update multiples rows of table: "implements" */
  update_implements_many?: Maybe<Array<Maybe<Implements_Mutation_Response>>>;
  /** update data of the table: "inventory" */
  update_inventory?: Maybe<Inventory_Mutation_Response>;
  /** update single row of the table: "inventory" */
  update_inventory_by_pk?: Maybe<Inventory>;
  /** update multiples rows of table: "inventory" */
  update_inventory_many?: Maybe<Array<Maybe<Inventory_Mutation_Response>>>;
  /** update data of the table: "job_extras" */
  update_job_extras?: Maybe<Job_Extras_Mutation_Response>;
  /** update single row of the table: "job_extras" */
  update_job_extras_by_pk?: Maybe<Job_Extras>;
  /** update multiples rows of table: "job_extras" */
  update_job_extras_many?: Maybe<Array<Maybe<Job_Extras_Mutation_Response>>>;
  /** update data of the table: "job_fields" */
  update_job_fields?: Maybe<Job_Fields_Mutation_Response>;
  /** update single row of the table: "job_fields" */
  update_job_fields_by_pk?: Maybe<Job_Fields>;
  /** update multiples rows of table: "job_fields" */
  update_job_fields_many?: Maybe<Array<Maybe<Job_Fields_Mutation_Response>>>;
  /** update data of the table: "job_locations" */
  update_job_locations?: Maybe<Job_Locations_Mutation_Response>;
  /** update single row of the table: "job_locations" */
  update_job_locations_by_pk?: Maybe<Job_Locations>;
  /** update multiples rows of table: "job_locations" */
  update_job_locations_many?: Maybe<Array<Maybe<Job_Locations_Mutation_Response>>>;
  /** update data of the table: "job_operator_implements" */
  update_job_operator_implements?: Maybe<Job_Operator_Implements_Mutation_Response>;
  /** update single row of the table: "job_operator_implements" */
  update_job_operator_implements_by_pk?: Maybe<Job_Operator_Implements>;
  /** update multiples rows of table: "job_operator_implements" */
  update_job_operator_implements_many?: Maybe<Array<Maybe<Job_Operator_Implements_Mutation_Response>>>;
  /** update data of the table: "job_operator_vehicles" */
  update_job_operator_vehicles?: Maybe<Job_Operator_Vehicles_Mutation_Response>;
  /** update single row of the table: "job_operator_vehicles" */
  update_job_operator_vehicles_by_pk?: Maybe<Job_Operator_Vehicles>;
  /** update multiples rows of table: "job_operator_vehicles" */
  update_job_operator_vehicles_many?: Maybe<Array<Maybe<Job_Operator_Vehicles_Mutation_Response>>>;
  /** update data of the table: "job_operators" */
  update_job_operators?: Maybe<Job_Operators_Mutation_Response>;
  /** update single row of the table: "job_operators" */
  update_job_operators_by_pk?: Maybe<Job_Operators>;
  /** update multiples rows of table: "job_operators" */
  update_job_operators_many?: Maybe<Array<Maybe<Job_Operators_Mutation_Response>>>;
  /** update data of the table: "job_products" */
  update_job_products?: Maybe<Job_Products_Mutation_Response>;
  /** update single row of the table: "job_products" */
  update_job_products_by_pk?: Maybe<Job_Products>;
  /** update multiples rows of table: "job_products" */
  update_job_products_many?: Maybe<Array<Maybe<Job_Products_Mutation_Response>>>;
  /** update data of the table: "job_status" */
  update_job_status?: Maybe<Job_Status_Mutation_Response>;
  /** update single row of the table: "job_status" */
  update_job_status_by_pk?: Maybe<Job_Status>;
  /** update multiples rows of table: "job_status" */
  update_job_status_many?: Maybe<Array<Maybe<Job_Status_Mutation_Response>>>;
  /** update data of the table: "jobs" */
  update_jobs?: Maybe<Jobs_Mutation_Response>;
  /** update single row of the table: "jobs" */
  update_jobs_by_pk?: Maybe<Jobs>;
  /** update multiples rows of table: "jobs" */
  update_jobs_many?: Maybe<Array<Maybe<Jobs_Mutation_Response>>>;
  /** update data of the table: "operation_extras" */
  update_operation_extras?: Maybe<Operation_Extras_Mutation_Response>;
  /** update single row of the table: "operation_extras" */
  update_operation_extras_by_pk?: Maybe<Operation_Extras>;
  /** update multiples rows of table: "operation_extras" */
  update_operation_extras_many?: Maybe<Array<Maybe<Operation_Extras_Mutation_Response>>>;
  /** update data of the table: "operation_products" */
  update_operation_products?: Maybe<Operation_Products_Mutation_Response>;
  /** update single row of the table: "operation_products" */
  update_operation_products_by_pk?: Maybe<Operation_Products>;
  /** update multiples rows of table: "operation_products" */
  update_operation_products_many?: Maybe<Array<Maybe<Operation_Products_Mutation_Response>>>;
  /** update data of the table: "operations" */
  update_operations?: Maybe<Operations_Mutation_Response>;
  /** update single row of the table: "operations" */
  update_operations_by_pk?: Maybe<Operations>;
  /** update multiples rows of table: "operations" */
  update_operations_many?: Maybe<Array<Maybe<Operations_Mutation_Response>>>;
  /** update data of the table: "otps" */
  update_otps?: Maybe<Otps_Mutation_Response>;
  /** update single row of the table: "otps" */
  update_otps_by_pk?: Maybe<Otps>;
  /** update multiples rows of table: "otps" */
  update_otps_many?: Maybe<Array<Maybe<Otps_Mutation_Response>>>;
  /** update data of the table: "ownership_types" */
  update_ownership_types?: Maybe<Ownership_Types_Mutation_Response>;
  /** update single row of the table: "ownership_types" */
  update_ownership_types_by_pk?: Maybe<Ownership_Types>;
  /** update multiples rows of table: "ownership_types" */
  update_ownership_types_many?: Maybe<Array<Maybe<Ownership_Types_Mutation_Response>>>;
  /** update data of the table: "polygons" */
  update_polygons?: Maybe<Polygons_Mutation_Response>;
  /** update single row of the table: "polygons" */
  update_polygons_by_pk?: Maybe<Polygons>;
  /** update multiples rows of table: "polygons" */
  update_polygons_many?: Maybe<Array<Maybe<Polygons_Mutation_Response>>>;
  /** update data of the table: "products" */
  update_products?: Maybe<Products_Mutation_Response>;
  /** update single row of the table: "products" */
  update_products_by_pk?: Maybe<Products>;
  /** update multiples rows of table: "products" */
  update_products_many?: Maybe<Array<Maybe<Products_Mutation_Response>>>;
  /** update data of the table: "reports" */
  update_reports?: Maybe<Reports_Mutation_Response>;
  /** update single row of the table: "reports" */
  update_reports_by_pk?: Maybe<Reports>;
  /** update multiples rows of table: "reports" */
  update_reports_many?: Maybe<Array<Maybe<Reports_Mutation_Response>>>;
  /** update data of the table: "roles" */
  update_roles?: Maybe<Roles_Mutation_Response>;
  /** update single row of the table: "roles" */
  update_roles_by_pk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  update_roles_many?: Maybe<Array<Maybe<Roles_Mutation_Response>>>;
  /** update data of the table: "team_members" */
  update_team_members?: Maybe<Team_Members_Mutation_Response>;
  /** update single row of the table: "team_members" */
  update_team_members_by_pk?: Maybe<Team_Members>;
  /** update multiples rows of table: "team_members" */
  update_team_members_many?: Maybe<Array<Maybe<Team_Members_Mutation_Response>>>;
  /** update data of the table: "user_invites" */
  update_user_invites?: Maybe<User_Invites_Mutation_Response>;
  /** update single row of the table: "user_invites" */
  update_user_invites_by_pk?: Maybe<User_Invites>;
  /** update multiples rows of table: "user_invites" */
  update_user_invites_many?: Maybe<Array<Maybe<User_Invites_Mutation_Response>>>;
  /** update data of the table: "user_prefs" */
  update_user_prefs?: Maybe<User_Prefs_Mutation_Response>;
  /** update single row of the table: "user_prefs" */
  update_user_prefs_by_pk?: Maybe<User_Prefs>;
  /** update multiples rows of table: "user_prefs" */
  update_user_prefs_many?: Maybe<Array<Maybe<User_Prefs_Mutation_Response>>>;
  /** update data of the table: "user_profiles" */
  update_user_profiles?: Maybe<User_Profiles_Mutation_Response>;
  /** update single row of the table: "user_profiles" */
  update_user_profiles_by_pk?: Maybe<User_Profiles>;
  /** update multiples rows of table: "user_profiles" */
  update_user_profiles_many?: Maybe<Array<Maybe<User_Profiles_Mutation_Response>>>;
  /** update data of the table: "user_roles" */
  update_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** update single row of the table: "user_roles" */
  update_user_roles_by_pk?: Maybe<User_Roles>;
  /** update multiples rows of table: "user_roles" */
  update_user_roles_many?: Maybe<Array<Maybe<User_Roles_Mutation_Response>>>;
  /** update data of the table: "user_tax_rates" */
  update_user_tax_rates?: Maybe<User_Tax_Rates_Mutation_Response>;
  /** update single row of the table: "user_tax_rates" */
  update_user_tax_rates_by_pk?: Maybe<User_Tax_Rates>;
  /** update multiples rows of table: "user_tax_rates" */
  update_user_tax_rates_many?: Maybe<Array<Maybe<User_Tax_Rates_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "vehicles" */
  update_vehicles?: Maybe<Vehicles_Mutation_Response>;
  /** update single row of the table: "vehicles" */
  update_vehicles_by_pk?: Maybe<Vehicles>;
  /** update multiples rows of table: "vehicles" */
  update_vehicles_many?: Maybe<Array<Maybe<Vehicles_Mutation_Response>>>;
  /** update data of the table: "warehouses" */
  update_warehouses?: Maybe<Warehouses_Mutation_Response>;
  /** update single row of the table: "warehouses" */
  update_warehouses_by_pk?: Maybe<Warehouses>;
  /** update multiples rows of table: "warehouses" */
  update_warehouses_many?: Maybe<Array<Maybe<Warehouses_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootApi_Accept_InviteArgs = {
  input?: InputMaybe<Api_Accept_Invite_Input>;
};


/** mutation root */
export type Mutation_RootApi_Sign_Up_UserArgs = {
  input?: InputMaybe<Api_Sign_Up_User_Input>;
};


/** mutation root */
export type Mutation_RootDelete_Chargeable_UnitsArgs = {
  where: Chargeable_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chargeable_Units_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Entity_StatusArgs = {
  where: Entity_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_FarmsArgs = {
  where: Farms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Farms_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Field_Season_ShotArgs = {
  where: Field_Season_Shot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Field_Season_Shot_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_FieldsArgs = {
  where: Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fields_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_High_Res_Map_AnnotationsArgs = {
  where: High_Res_Map_Annotations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_High_Res_Map_Annotations_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_High_Res_Map_LayersArgs = {
  where: High_Res_Map_Layers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_High_Res_Map_Layers_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_High_Res_MapsArgs = {
  where: High_Res_Maps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_High_Res_Maps_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_ImplementsArgs = {
  where: Implements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Implements_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_InventoryArgs = {
  where: Inventory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Inventory_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Job_ExtrasArgs = {
  where: Job_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Extras_By_PkArgs = {
  jobId: Scalars['bigint'];
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Job_FieldsArgs = {
  where: Job_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Fields_By_PkArgs = {
  jobId: Scalars['bigint'];
  seasonShotId: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Job_LocationsArgs = {
  where: Job_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Locations_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Job_Operator_ImplementsArgs = {
  where: Job_Operator_Implements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Operator_Implements_By_PkArgs = {
  implementId: Scalars['uuid'];
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Job_Operator_VehiclesArgs = {
  where: Job_Operator_Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Operator_Vehicles_By_PkArgs = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
  vehicleId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Job_OperatorsArgs = {
  where: Job_Operators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Operators_By_PkArgs = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Job_ProductsArgs = {
  where: Job_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Products_By_PkArgs = {
  jobId: Scalars['bigint'];
  productId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Job_StatusArgs = {
  where: Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_JobsArgs = {
  where: Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Jobs_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Operation_ExtrasArgs = {
  where: Operation_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operation_Extras_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Operation_ProductsArgs = {
  where: Operation_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operation_Products_By_PkArgs = {
  operationId: Scalars['bigint'];
  productId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OperationsArgs = {
  where: Operations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Operations_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_OtpsArgs = {
  where: Otps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Otps_By_PkArgs = {
  otp: Scalars['String'];
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Ownership_TypesArgs = {
  where: Ownership_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ownership_Types_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PolygonsArgs = {
  where: Polygons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Polygons_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_ProductsArgs = {
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Products_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ReportsArgs = {
  where: Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reports_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_RolesArgs = {
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Roles_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Team_MembersArgs = {
  where: Team_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Members_By_PkArgs = {
  ownerId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_InvitesArgs = {
  where: User_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Invites_By_PkArgs = {
  invite_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_PrefsArgs = {
  where: User_Prefs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Prefs_By_PkArgs = {
  userId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProfilesArgs = {
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profiles_By_PkArgs = {
  userId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_RolesArgs = {
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Roles_By_PkArgs = {
  role: Roles_Enum;
  user_id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Tax_RatesArgs = {
  where: User_Tax_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Tax_Rates_By_PkArgs = {
  label: Scalars['String'];
  userId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VehiclesArgs = {
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vehicles_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_WarehousesArgs = {
  where: Warehouses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Warehouses_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootInsert_Chargeable_UnitsArgs = {
  objects: Array<Chargeable_Units_Insert_Input>;
  on_conflict?: InputMaybe<Chargeable_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chargeable_Units_OneArgs = {
  object: Chargeable_Units_Insert_Input;
  on_conflict?: InputMaybe<Chargeable_Units_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_StatusArgs = {
  objects: Array<Entity_Status_Insert_Input>;
  on_conflict?: InputMaybe<Entity_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_Status_OneArgs = {
  object: Entity_Status_Insert_Input;
  on_conflict?: InputMaybe<Entity_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FarmsArgs = {
  objects: Array<Farms_Insert_Input>;
  on_conflict?: InputMaybe<Farms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Farms_OneArgs = {
  object: Farms_Insert_Input;
  on_conflict?: InputMaybe<Farms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Season_ShotArgs = {
  objects: Array<Field_Season_Shot_Insert_Input>;
  on_conflict?: InputMaybe<Field_Season_Shot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Field_Season_Shot_OneArgs = {
  object: Field_Season_Shot_Insert_Input;
  on_conflict?: InputMaybe<Field_Season_Shot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FieldsArgs = {
  objects: Array<Fields_Insert_Input>;
  on_conflict?: InputMaybe<Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fields_OneArgs = {
  object: Fields_Insert_Input;
  on_conflict?: InputMaybe<Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_High_Res_Map_AnnotationsArgs = {
  objects: Array<High_Res_Map_Annotations_Insert_Input>;
  on_conflict?: InputMaybe<High_Res_Map_Annotations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_High_Res_Map_Annotations_OneArgs = {
  object: High_Res_Map_Annotations_Insert_Input;
  on_conflict?: InputMaybe<High_Res_Map_Annotations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_High_Res_Map_LayersArgs = {
  objects: Array<High_Res_Map_Layers_Insert_Input>;
  on_conflict?: InputMaybe<High_Res_Map_Layers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_High_Res_Map_Layers_OneArgs = {
  object: High_Res_Map_Layers_Insert_Input;
  on_conflict?: InputMaybe<High_Res_Map_Layers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_High_Res_MapsArgs = {
  objects: Array<High_Res_Maps_Insert_Input>;
  on_conflict?: InputMaybe<High_Res_Maps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_High_Res_Maps_OneArgs = {
  object: High_Res_Maps_Insert_Input;
  on_conflict?: InputMaybe<High_Res_Maps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ImplementsArgs = {
  objects: Array<Implements_Insert_Input>;
  on_conflict?: InputMaybe<Implements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Implements_OneArgs = {
  object: Implements_Insert_Input;
  on_conflict?: InputMaybe<Implements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InventoryArgs = {
  objects: Array<Inventory_Insert_Input>;
  on_conflict?: InputMaybe<Inventory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Inventory_OneArgs = {
  object: Inventory_Insert_Input;
  on_conflict?: InputMaybe<Inventory_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_ExtrasArgs = {
  objects: Array<Job_Extras_Insert_Input>;
  on_conflict?: InputMaybe<Job_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Extras_OneArgs = {
  object: Job_Extras_Insert_Input;
  on_conflict?: InputMaybe<Job_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_FieldsArgs = {
  objects: Array<Job_Fields_Insert_Input>;
  on_conflict?: InputMaybe<Job_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Fields_OneArgs = {
  object: Job_Fields_Insert_Input;
  on_conflict?: InputMaybe<Job_Fields_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_LocationsArgs = {
  objects: Array<Job_Locations_Insert_Input>;
  on_conflict?: InputMaybe<Job_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Locations_OneArgs = {
  object: Job_Locations_Insert_Input;
  on_conflict?: InputMaybe<Job_Locations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Operator_ImplementsArgs = {
  objects: Array<Job_Operator_Implements_Insert_Input>;
  on_conflict?: InputMaybe<Job_Operator_Implements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Operator_Implements_OneArgs = {
  object: Job_Operator_Implements_Insert_Input;
  on_conflict?: InputMaybe<Job_Operator_Implements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Operator_VehiclesArgs = {
  objects: Array<Job_Operator_Vehicles_Insert_Input>;
  on_conflict?: InputMaybe<Job_Operator_Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Operator_Vehicles_OneArgs = {
  object: Job_Operator_Vehicles_Insert_Input;
  on_conflict?: InputMaybe<Job_Operator_Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_OperatorsArgs = {
  objects: Array<Job_Operators_Insert_Input>;
  on_conflict?: InputMaybe<Job_Operators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Operators_OneArgs = {
  object: Job_Operators_Insert_Input;
  on_conflict?: InputMaybe<Job_Operators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_ProductsArgs = {
  objects: Array<Job_Products_Insert_Input>;
  on_conflict?: InputMaybe<Job_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Products_OneArgs = {
  object: Job_Products_Insert_Input;
  on_conflict?: InputMaybe<Job_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_StatusArgs = {
  objects: Array<Job_Status_Insert_Input>;
  on_conflict?: InputMaybe<Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Status_OneArgs = {
  object: Job_Status_Insert_Input;
  on_conflict?: InputMaybe<Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JobsArgs = {
  objects: Array<Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Jobs_OneArgs = {
  object: Jobs_Insert_Input;
  on_conflict?: InputMaybe<Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_ExtrasArgs = {
  objects: Array<Operation_Extras_Insert_Input>;
  on_conflict?: InputMaybe<Operation_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_Extras_OneArgs = {
  object: Operation_Extras_Insert_Input;
  on_conflict?: InputMaybe<Operation_Extras_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_ProductsArgs = {
  objects: Array<Operation_Products_Insert_Input>;
  on_conflict?: InputMaybe<Operation_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operation_Products_OneArgs = {
  object: Operation_Products_Insert_Input;
  on_conflict?: InputMaybe<Operation_Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OperationsArgs = {
  objects: Array<Operations_Insert_Input>;
  on_conflict?: InputMaybe<Operations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Operations_OneArgs = {
  object: Operations_Insert_Input;
  on_conflict?: InputMaybe<Operations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OtpsArgs = {
  objects: Array<Otps_Insert_Input>;
  on_conflict?: InputMaybe<Otps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Otps_OneArgs = {
  object: Otps_Insert_Input;
  on_conflict?: InputMaybe<Otps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ownership_TypesArgs = {
  objects: Array<Ownership_Types_Insert_Input>;
  on_conflict?: InputMaybe<Ownership_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ownership_Types_OneArgs = {
  object: Ownership_Types_Insert_Input;
  on_conflict?: InputMaybe<Ownership_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PolygonsArgs = {
  objects: Array<Polygons_Insert_Input>;
  on_conflict?: InputMaybe<Polygons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Polygons_OneArgs = {
  object: Polygons_Insert_Input;
  on_conflict?: InputMaybe<Polygons_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductsArgs = {
  objects: Array<Products_Insert_Input>;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Products_OneArgs = {
  object: Products_Insert_Input;
  on_conflict?: InputMaybe<Products_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportsArgs = {
  objects: Array<Reports_Insert_Input>;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reports_OneArgs = {
  object: Reports_Insert_Input;
  on_conflict?: InputMaybe<Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RolesArgs = {
  objects: Array<Roles_Insert_Input>;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Roles_OneArgs = {
  object: Roles_Insert_Input;
  on_conflict?: InputMaybe<Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_MembersArgs = {
  objects: Array<Team_Members_Insert_Input>;
  on_conflict?: InputMaybe<Team_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Members_OneArgs = {
  object: Team_Members_Insert_Input;
  on_conflict?: InputMaybe<Team_Members_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_InvitesArgs = {
  objects: Array<User_Invites_Insert_Input>;
  on_conflict?: InputMaybe<User_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Invites_OneArgs = {
  object: User_Invites_Insert_Input;
  on_conflict?: InputMaybe<User_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PrefsArgs = {
  objects: Array<User_Prefs_Insert_Input>;
  on_conflict?: InputMaybe<User_Prefs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Prefs_OneArgs = {
  object: User_Prefs_Insert_Input;
  on_conflict?: InputMaybe<User_Prefs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfilesArgs = {
  objects: Array<User_Profiles_Insert_Input>;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profiles_OneArgs = {
  object: User_Profiles_Insert_Input;
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RolesArgs = {
  objects: Array<User_Roles_Insert_Input>;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Roles_OneArgs = {
  object: User_Roles_Insert_Input;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Tax_RatesArgs = {
  objects: Array<User_Tax_Rates_Insert_Input>;
  on_conflict?: InputMaybe<User_Tax_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Tax_Rates_OneArgs = {
  object: User_Tax_Rates_Insert_Input;
  on_conflict?: InputMaybe<User_Tax_Rates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VehiclesArgs = {
  objects: Array<Vehicles_Insert_Input>;
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vehicles_OneArgs = {
  object: Vehicles_Insert_Input;
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WarehousesArgs = {
  objects: Array<Warehouses_Insert_Input>;
  on_conflict?: InputMaybe<Warehouses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Warehouses_OneArgs = {
  object: Warehouses_Insert_Input;
  on_conflict?: InputMaybe<Warehouses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Chargeable_UnitsArgs = {
  _set?: InputMaybe<Chargeable_Units_Set_Input>;
  where: Chargeable_Units_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chargeable_Units_By_PkArgs = {
  _set?: InputMaybe<Chargeable_Units_Set_Input>;
  pk_columns: Chargeable_Units_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chargeable_Units_ManyArgs = {
  updates: Array<Chargeable_Units_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_StatusArgs = {
  _set?: InputMaybe<Entity_Status_Set_Input>;
  where: Entity_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Status_By_PkArgs = {
  _set?: InputMaybe<Entity_Status_Set_Input>;
  pk_columns: Entity_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_Status_ManyArgs = {
  updates: Array<Entity_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FarmsArgs = {
  _inc?: InputMaybe<Farms_Inc_Input>;
  _set?: InputMaybe<Farms_Set_Input>;
  where: Farms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Farms_By_PkArgs = {
  _inc?: InputMaybe<Farms_Inc_Input>;
  _set?: InputMaybe<Farms_Set_Input>;
  pk_columns: Farms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Farms_ManyArgs = {
  updates: Array<Farms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Season_ShotArgs = {
  _inc?: InputMaybe<Field_Season_Shot_Inc_Input>;
  _set?: InputMaybe<Field_Season_Shot_Set_Input>;
  where: Field_Season_Shot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Season_Shot_By_PkArgs = {
  _inc?: InputMaybe<Field_Season_Shot_Inc_Input>;
  _set?: InputMaybe<Field_Season_Shot_Set_Input>;
  pk_columns: Field_Season_Shot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Field_Season_Shot_ManyArgs = {
  updates: Array<Field_Season_Shot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FieldsArgs = {
  _inc?: InputMaybe<Fields_Inc_Input>;
  _set?: InputMaybe<Fields_Set_Input>;
  where: Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fields_By_PkArgs = {
  _inc?: InputMaybe<Fields_Inc_Input>;
  _set?: InputMaybe<Fields_Set_Input>;
  pk_columns: Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fields_ManyArgs = {
  updates: Array<Fields_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Map_AnnotationsArgs = {
  _inc?: InputMaybe<High_Res_Map_Annotations_Inc_Input>;
  _set?: InputMaybe<High_Res_Map_Annotations_Set_Input>;
  where: High_Res_Map_Annotations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Map_Annotations_By_PkArgs = {
  _inc?: InputMaybe<High_Res_Map_Annotations_Inc_Input>;
  _set?: InputMaybe<High_Res_Map_Annotations_Set_Input>;
  pk_columns: High_Res_Map_Annotations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Map_Annotations_ManyArgs = {
  updates: Array<High_Res_Map_Annotations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Map_LayersArgs = {
  _inc?: InputMaybe<High_Res_Map_Layers_Inc_Input>;
  _set?: InputMaybe<High_Res_Map_Layers_Set_Input>;
  where: High_Res_Map_Layers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Map_Layers_By_PkArgs = {
  _inc?: InputMaybe<High_Res_Map_Layers_Inc_Input>;
  _set?: InputMaybe<High_Res_Map_Layers_Set_Input>;
  pk_columns: High_Res_Map_Layers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Map_Layers_ManyArgs = {
  updates: Array<High_Res_Map_Layers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_MapsArgs = {
  _inc?: InputMaybe<High_Res_Maps_Inc_Input>;
  _set?: InputMaybe<High_Res_Maps_Set_Input>;
  where: High_Res_Maps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Maps_By_PkArgs = {
  _inc?: InputMaybe<High_Res_Maps_Inc_Input>;
  _set?: InputMaybe<High_Res_Maps_Set_Input>;
  pk_columns: High_Res_Maps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_High_Res_Maps_ManyArgs = {
  updates: Array<High_Res_Maps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ImplementsArgs = {
  _inc?: InputMaybe<Implements_Inc_Input>;
  _set?: InputMaybe<Implements_Set_Input>;
  where: Implements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Implements_By_PkArgs = {
  _inc?: InputMaybe<Implements_Inc_Input>;
  _set?: InputMaybe<Implements_Set_Input>;
  pk_columns: Implements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Implements_ManyArgs = {
  updates: Array<Implements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InventoryArgs = {
  _inc?: InputMaybe<Inventory_Inc_Input>;
  _set?: InputMaybe<Inventory_Set_Input>;
  where: Inventory_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Inventory_By_PkArgs = {
  _inc?: InputMaybe<Inventory_Inc_Input>;
  _set?: InputMaybe<Inventory_Set_Input>;
  pk_columns: Inventory_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Inventory_ManyArgs = {
  updates: Array<Inventory_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_ExtrasArgs = {
  _inc?: InputMaybe<Job_Extras_Inc_Input>;
  _set?: InputMaybe<Job_Extras_Set_Input>;
  where: Job_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Extras_By_PkArgs = {
  _inc?: InputMaybe<Job_Extras_Inc_Input>;
  _set?: InputMaybe<Job_Extras_Set_Input>;
  pk_columns: Job_Extras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Extras_ManyArgs = {
  updates: Array<Job_Extras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_FieldsArgs = {
  _inc?: InputMaybe<Job_Fields_Inc_Input>;
  _set?: InputMaybe<Job_Fields_Set_Input>;
  where: Job_Fields_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Fields_By_PkArgs = {
  _inc?: InputMaybe<Job_Fields_Inc_Input>;
  _set?: InputMaybe<Job_Fields_Set_Input>;
  pk_columns: Job_Fields_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Fields_ManyArgs = {
  updates: Array<Job_Fields_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_LocationsArgs = {
  _inc?: InputMaybe<Job_Locations_Inc_Input>;
  _set?: InputMaybe<Job_Locations_Set_Input>;
  where: Job_Locations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Locations_By_PkArgs = {
  _inc?: InputMaybe<Job_Locations_Inc_Input>;
  _set?: InputMaybe<Job_Locations_Set_Input>;
  pk_columns: Job_Locations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Locations_ManyArgs = {
  updates: Array<Job_Locations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operator_ImplementsArgs = {
  _inc?: InputMaybe<Job_Operator_Implements_Inc_Input>;
  _set?: InputMaybe<Job_Operator_Implements_Set_Input>;
  where: Job_Operator_Implements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operator_Implements_By_PkArgs = {
  _inc?: InputMaybe<Job_Operator_Implements_Inc_Input>;
  _set?: InputMaybe<Job_Operator_Implements_Set_Input>;
  pk_columns: Job_Operator_Implements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operator_Implements_ManyArgs = {
  updates: Array<Job_Operator_Implements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operator_VehiclesArgs = {
  _inc?: InputMaybe<Job_Operator_Vehicles_Inc_Input>;
  _set?: InputMaybe<Job_Operator_Vehicles_Set_Input>;
  where: Job_Operator_Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operator_Vehicles_By_PkArgs = {
  _inc?: InputMaybe<Job_Operator_Vehicles_Inc_Input>;
  _set?: InputMaybe<Job_Operator_Vehicles_Set_Input>;
  pk_columns: Job_Operator_Vehicles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operator_Vehicles_ManyArgs = {
  updates: Array<Job_Operator_Vehicles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_OperatorsArgs = {
  _inc?: InputMaybe<Job_Operators_Inc_Input>;
  _set?: InputMaybe<Job_Operators_Set_Input>;
  where: Job_Operators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operators_By_PkArgs = {
  _inc?: InputMaybe<Job_Operators_Inc_Input>;
  _set?: InputMaybe<Job_Operators_Set_Input>;
  pk_columns: Job_Operators_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Operators_ManyArgs = {
  updates: Array<Job_Operators_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_ProductsArgs = {
  _inc?: InputMaybe<Job_Products_Inc_Input>;
  _set?: InputMaybe<Job_Products_Set_Input>;
  where: Job_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Products_By_PkArgs = {
  _inc?: InputMaybe<Job_Products_Inc_Input>;
  _set?: InputMaybe<Job_Products_Set_Input>;
  pk_columns: Job_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Products_ManyArgs = {
  updates: Array<Job_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_StatusArgs = {
  _set?: InputMaybe<Job_Status_Set_Input>;
  where: Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Status_By_PkArgs = {
  _set?: InputMaybe<Job_Status_Set_Input>;
  pk_columns: Job_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Status_ManyArgs = {
  updates: Array<Job_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JobsArgs = {
  _inc?: InputMaybe<Jobs_Inc_Input>;
  _set?: InputMaybe<Jobs_Set_Input>;
  where: Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_By_PkArgs = {
  _inc?: InputMaybe<Jobs_Inc_Input>;
  _set?: InputMaybe<Jobs_Set_Input>;
  pk_columns: Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Jobs_ManyArgs = {
  updates: Array<Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_ExtrasArgs = {
  _inc?: InputMaybe<Operation_Extras_Inc_Input>;
  _set?: InputMaybe<Operation_Extras_Set_Input>;
  where: Operation_Extras_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Extras_By_PkArgs = {
  _inc?: InputMaybe<Operation_Extras_Inc_Input>;
  _set?: InputMaybe<Operation_Extras_Set_Input>;
  pk_columns: Operation_Extras_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Extras_ManyArgs = {
  updates: Array<Operation_Extras_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_ProductsArgs = {
  _inc?: InputMaybe<Operation_Products_Inc_Input>;
  _set?: InputMaybe<Operation_Products_Set_Input>;
  where: Operation_Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Products_By_PkArgs = {
  _inc?: InputMaybe<Operation_Products_Inc_Input>;
  _set?: InputMaybe<Operation_Products_Set_Input>;
  pk_columns: Operation_Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operation_Products_ManyArgs = {
  updates: Array<Operation_Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OperationsArgs = {
  _inc?: InputMaybe<Operations_Inc_Input>;
  _set?: InputMaybe<Operations_Set_Input>;
  where: Operations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_By_PkArgs = {
  _inc?: InputMaybe<Operations_Inc_Input>;
  _set?: InputMaybe<Operations_Set_Input>;
  pk_columns: Operations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Operations_ManyArgs = {
  updates: Array<Operations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OtpsArgs = {
  _inc?: InputMaybe<Otps_Inc_Input>;
  _set?: InputMaybe<Otps_Set_Input>;
  where: Otps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Otps_By_PkArgs = {
  _inc?: InputMaybe<Otps_Inc_Input>;
  _set?: InputMaybe<Otps_Set_Input>;
  pk_columns: Otps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Otps_ManyArgs = {
  updates: Array<Otps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ownership_TypesArgs = {
  _set?: InputMaybe<Ownership_Types_Set_Input>;
  where: Ownership_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ownership_Types_By_PkArgs = {
  _set?: InputMaybe<Ownership_Types_Set_Input>;
  pk_columns: Ownership_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ownership_Types_ManyArgs = {
  updates: Array<Ownership_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PolygonsArgs = {
  _inc?: InputMaybe<Polygons_Inc_Input>;
  _set?: InputMaybe<Polygons_Set_Input>;
  where: Polygons_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Polygons_By_PkArgs = {
  _inc?: InputMaybe<Polygons_Inc_Input>;
  _set?: InputMaybe<Polygons_Set_Input>;
  pk_columns: Polygons_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Polygons_ManyArgs = {
  updates: Array<Polygons_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductsArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  where: Products_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Products_By_PkArgs = {
  _inc?: InputMaybe<Products_Inc_Input>;
  _set?: InputMaybe<Products_Set_Input>;
  pk_columns: Products_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Products_ManyArgs = {
  updates: Array<Products_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportsArgs = {
  _append?: InputMaybe<Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Reports_Inc_Input>;
  _prepend?: InputMaybe<Reports_Prepend_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  where: Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_By_PkArgs = {
  _append?: InputMaybe<Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Reports_Inc_Input>;
  _prepend?: InputMaybe<Reports_Prepend_Input>;
  _set?: InputMaybe<Reports_Set_Input>;
  pk_columns: Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reports_ManyArgs = {
  updates: Array<Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RolesArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  where: Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_By_PkArgs = {
  _set?: InputMaybe<Roles_Set_Input>;
  pk_columns: Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Roles_ManyArgs = {
  updates: Array<Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Team_MembersArgs = {
  _inc?: InputMaybe<Team_Members_Inc_Input>;
  _set?: InputMaybe<Team_Members_Set_Input>;
  where: Team_Members_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Members_By_PkArgs = {
  _inc?: InputMaybe<Team_Members_Inc_Input>;
  _set?: InputMaybe<Team_Members_Set_Input>;
  pk_columns: Team_Members_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Team_Members_ManyArgs = {
  updates: Array<Team_Members_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_InvitesArgs = {
  _inc?: InputMaybe<User_Invites_Inc_Input>;
  _set?: InputMaybe<User_Invites_Set_Input>;
  where: User_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Invites_By_PkArgs = {
  _inc?: InputMaybe<User_Invites_Inc_Input>;
  _set?: InputMaybe<User_Invites_Set_Input>;
  pk_columns: User_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Invites_ManyArgs = {
  updates: Array<User_Invites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PrefsArgs = {
  _inc?: InputMaybe<User_Prefs_Inc_Input>;
  _set?: InputMaybe<User_Prefs_Set_Input>;
  where: User_Prefs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Prefs_By_PkArgs = {
  _inc?: InputMaybe<User_Prefs_Inc_Input>;
  _set?: InputMaybe<User_Prefs_Set_Input>;
  pk_columns: User_Prefs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Prefs_ManyArgs = {
  updates: Array<User_Prefs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfilesArgs = {
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  where: User_Profiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_By_PkArgs = {
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  _set?: InputMaybe<User_Profiles_Set_Input>;
  pk_columns: User_Profiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profiles_ManyArgs = {
  updates: Array<User_Profiles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RolesArgs = {
  _inc?: InputMaybe<User_Roles_Inc_Input>;
  _set?: InputMaybe<User_Roles_Set_Input>;
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_By_PkArgs = {
  _inc?: InputMaybe<User_Roles_Inc_Input>;
  _set?: InputMaybe<User_Roles_Set_Input>;
  pk_columns: User_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_ManyArgs = {
  updates: Array<User_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tax_RatesArgs = {
  _inc?: InputMaybe<User_Tax_Rates_Inc_Input>;
  _set?: InputMaybe<User_Tax_Rates_Set_Input>;
  where: User_Tax_Rates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tax_Rates_By_PkArgs = {
  _inc?: InputMaybe<User_Tax_Rates_Inc_Input>;
  _set?: InputMaybe<User_Tax_Rates_Set_Input>;
  pk_columns: User_Tax_Rates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tax_Rates_ManyArgs = {
  updates: Array<User_Tax_Rates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VehiclesArgs = {
  _inc?: InputMaybe<Vehicles_Inc_Input>;
  _set?: InputMaybe<Vehicles_Set_Input>;
  where: Vehicles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicles_By_PkArgs = {
  _inc?: InputMaybe<Vehicles_Inc_Input>;
  _set?: InputMaybe<Vehicles_Set_Input>;
  pk_columns: Vehicles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vehicles_ManyArgs = {
  updates: Array<Vehicles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WarehousesArgs = {
  _inc?: InputMaybe<Warehouses_Inc_Input>;
  _set?: InputMaybe<Warehouses_Set_Input>;
  where: Warehouses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Warehouses_By_PkArgs = {
  _inc?: InputMaybe<Warehouses_Inc_Input>;
  _set?: InputMaybe<Warehouses_Set_Input>;
  pk_columns: Warehouses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Warehouses_ManyArgs = {
  updates: Array<Warehouses_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "operation_extras" */
export type Operation_Extras = {
  __typename?: 'operation_extras';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  operation: Operations;
  operationId: Scalars['bigint'];
  unit: Chargeable_Units_Enum;
  value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "operation_extras" */
export type Operation_Extras_Aggregate = {
  __typename?: 'operation_extras_aggregate';
  aggregate?: Maybe<Operation_Extras_Aggregate_Fields>;
  nodes: Array<Operation_Extras>;
};

export type Operation_Extras_Aggregate_Bool_Exp = {
  count?: InputMaybe<Operation_Extras_Aggregate_Bool_Exp_Count>;
};

export type Operation_Extras_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Operation_Extras_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operation_extras" */
export type Operation_Extras_Aggregate_Fields = {
  __typename?: 'operation_extras_aggregate_fields';
  avg?: Maybe<Operation_Extras_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operation_Extras_Max_Fields>;
  min?: Maybe<Operation_Extras_Min_Fields>;
  stddev?: Maybe<Operation_Extras_Stddev_Fields>;
  stddev_pop?: Maybe<Operation_Extras_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operation_Extras_Stddev_Samp_Fields>;
  sum?: Maybe<Operation_Extras_Sum_Fields>;
  var_pop?: Maybe<Operation_Extras_Var_Pop_Fields>;
  var_samp?: Maybe<Operation_Extras_Var_Samp_Fields>;
  variance?: Maybe<Operation_Extras_Variance_Fields>;
};


/** aggregate fields of "operation_extras" */
export type Operation_Extras_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operation_extras" */
export type Operation_Extras_Aggregate_Order_By = {
  avg?: InputMaybe<Operation_Extras_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operation_Extras_Max_Order_By>;
  min?: InputMaybe<Operation_Extras_Min_Order_By>;
  stddev?: InputMaybe<Operation_Extras_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operation_Extras_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operation_Extras_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operation_Extras_Sum_Order_By>;
  var_pop?: InputMaybe<Operation_Extras_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operation_Extras_Var_Samp_Order_By>;
  variance?: InputMaybe<Operation_Extras_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operation_extras" */
export type Operation_Extras_Arr_Rel_Insert_Input = {
  data: Array<Operation_Extras_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operation_Extras_On_Conflict>;
};

/** aggregate avg on columns */
export type Operation_Extras_Avg_Fields = {
  __typename?: 'operation_extras_avg_fields';
  operationId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operation_extras" */
export type Operation_Extras_Avg_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operation_extras". All fields are combined with a logical 'AND'. */
export type Operation_Extras_Bool_Exp = {
  _and?: InputMaybe<Array<Operation_Extras_Bool_Exp>>;
  _not?: InputMaybe<Operation_Extras_Bool_Exp>;
  _or?: InputMaybe<Array<Operation_Extras_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  operation?: InputMaybe<Operations_Bool_Exp>;
  operationId?: InputMaybe<Bigint_Comparison_Exp>;
  unit?: InputMaybe<Chargeable_Units_Enum_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "operation_extras" */
export enum Operation_Extras_Constraint {
  /** unique or primary key constraint on columns "name", "id" */
  OperationExtrasIdNameKey = 'operation_extras_id_name_key',
  /** unique or primary key constraint on columns "id" */
  OperationExtrasPkey = 'operation_extras_pkey'
}

/** input type for incrementing numeric columns in table "operation_extras" */
export type Operation_Extras_Inc_Input = {
  operationId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "operation_extras" */
export type Operation_Extras_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<Operations_Obj_Rel_Insert_Input>;
  operationId?: InputMaybe<Scalars['bigint']>;
  unit?: InputMaybe<Chargeable_Units_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Operation_Extras_Max_Fields = {
  __typename?: 'operation_extras_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  operationId?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "operation_extras" */
export type Operation_Extras_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operation_Extras_Min_Fields = {
  __typename?: 'operation_extras_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  operationId?: Maybe<Scalars['bigint']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "operation_extras" */
export type Operation_Extras_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operationId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operation_extras" */
export type Operation_Extras_Mutation_Response = {
  __typename?: 'operation_extras_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operation_Extras>;
};

/** on_conflict condition type for table "operation_extras" */
export type Operation_Extras_On_Conflict = {
  constraint: Operation_Extras_Constraint;
  update_columns?: Array<Operation_Extras_Update_Column>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};

/** Ordering options when selecting data from "operation_extras". */
export type Operation_Extras_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  operation?: InputMaybe<Operations_Order_By>;
  operationId?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operation_extras */
export type Operation_Extras_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "operation_extras" */
export enum Operation_Extras_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OperationId = 'operationId',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "operation_extras" */
export type Operation_Extras_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  operationId?: InputMaybe<Scalars['bigint']>;
  unit?: InputMaybe<Chargeable_Units_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Operation_Extras_Stddev_Fields = {
  __typename?: 'operation_extras_stddev_fields';
  operationId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operation_extras" */
export type Operation_Extras_Stddev_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operation_Extras_Stddev_Pop_Fields = {
  __typename?: 'operation_extras_stddev_pop_fields';
  operationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operation_extras" */
export type Operation_Extras_Stddev_Pop_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operation_Extras_Stddev_Samp_Fields = {
  __typename?: 'operation_extras_stddev_samp_fields';
  operationId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operation_extras" */
export type Operation_Extras_Stddev_Samp_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operation_extras" */
export type Operation_Extras_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operation_Extras_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operation_Extras_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  operationId?: InputMaybe<Scalars['bigint']>;
  unit?: InputMaybe<Chargeable_Units_Enum>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Operation_Extras_Sum_Fields = {
  __typename?: 'operation_extras_sum_fields';
  operationId?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "operation_extras" */
export type Operation_Extras_Sum_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** update columns of table "operation_extras" */
export enum Operation_Extras_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OperationId = 'operationId',
  /** column name */
  Unit = 'unit',
  /** column name */
  Value = 'value'
}

export type Operation_Extras_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operation_Extras_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operation_Extras_Set_Input>;
  /** filter the rows which have to be updated */
  where: Operation_Extras_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operation_Extras_Var_Pop_Fields = {
  __typename?: 'operation_extras_var_pop_fields';
  operationId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operation_extras" */
export type Operation_Extras_Var_Pop_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operation_Extras_Var_Samp_Fields = {
  __typename?: 'operation_extras_var_samp_fields';
  operationId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operation_extras" */
export type Operation_Extras_Var_Samp_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operation_Extras_Variance_Fields = {
  __typename?: 'operation_extras_variance_fields';
  operationId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operation_extras" */
export type Operation_Extras_Variance_Order_By = {
  operationId?: InputMaybe<Order_By>;
};

/** One to Many relational mapping Operation -> Products */
export type Operation_Products = {
  __typename?: 'operation_products';
  operationId: Scalars['bigint'];
  /** An object relationship */
  product: Products;
  productId: Scalars['uuid'];
  userId: Scalars['Int'];
};

/** aggregated selection of "operation_products" */
export type Operation_Products_Aggregate = {
  __typename?: 'operation_products_aggregate';
  aggregate?: Maybe<Operation_Products_Aggregate_Fields>;
  nodes: Array<Operation_Products>;
};

export type Operation_Products_Aggregate_Bool_Exp = {
  count?: InputMaybe<Operation_Products_Aggregate_Bool_Exp_Count>;
};

export type Operation_Products_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Operation_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Operation_Products_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "operation_products" */
export type Operation_Products_Aggregate_Fields = {
  __typename?: 'operation_products_aggregate_fields';
  avg?: Maybe<Operation_Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operation_Products_Max_Fields>;
  min?: Maybe<Operation_Products_Min_Fields>;
  stddev?: Maybe<Operation_Products_Stddev_Fields>;
  stddev_pop?: Maybe<Operation_Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operation_Products_Stddev_Samp_Fields>;
  sum?: Maybe<Operation_Products_Sum_Fields>;
  var_pop?: Maybe<Operation_Products_Var_Pop_Fields>;
  var_samp?: Maybe<Operation_Products_Var_Samp_Fields>;
  variance?: Maybe<Operation_Products_Variance_Fields>;
};


/** aggregate fields of "operation_products" */
export type Operation_Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operation_Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "operation_products" */
export type Operation_Products_Aggregate_Order_By = {
  avg?: InputMaybe<Operation_Products_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Operation_Products_Max_Order_By>;
  min?: InputMaybe<Operation_Products_Min_Order_By>;
  stddev?: InputMaybe<Operation_Products_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Operation_Products_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Operation_Products_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Operation_Products_Sum_Order_By>;
  var_pop?: InputMaybe<Operation_Products_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Operation_Products_Var_Samp_Order_By>;
  variance?: InputMaybe<Operation_Products_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "operation_products" */
export type Operation_Products_Arr_Rel_Insert_Input = {
  data: Array<Operation_Products_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Operation_Products_On_Conflict>;
};

/** aggregate avg on columns */
export type Operation_Products_Avg_Fields = {
  __typename?: 'operation_products_avg_fields';
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "operation_products" */
export type Operation_Products_Avg_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "operation_products". All fields are combined with a logical 'AND'. */
export type Operation_Products_Bool_Exp = {
  _and?: InputMaybe<Array<Operation_Products_Bool_Exp>>;
  _not?: InputMaybe<Operation_Products_Bool_Exp>;
  _or?: InputMaybe<Array<Operation_Products_Bool_Exp>>;
  operationId?: InputMaybe<Bigint_Comparison_Exp>;
  product?: InputMaybe<Products_Bool_Exp>;
  productId?: InputMaybe<Uuid_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "operation_products" */
export enum Operation_Products_Constraint {
  /** unique or primary key constraint on columns "product_id", "operation_id" */
  OperationProductsPkey = 'operation_products_pkey'
}

/** input type for incrementing numeric columns in table "operation_products" */
export type Operation_Products_Inc_Input = {
  operationId?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "operation_products" */
export type Operation_Products_Insert_Input = {
  operationId?: InputMaybe<Scalars['bigint']>;
  product?: InputMaybe<Products_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Operation_Products_Max_Fields = {
  __typename?: 'operation_products_max_fields';
  operationId?: Maybe<Scalars['bigint']>;
  productId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "operation_products" */
export type Operation_Products_Max_Order_By = {
  operationId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Operation_Products_Min_Fields = {
  __typename?: 'operation_products_min_fields';
  operationId?: Maybe<Scalars['bigint']>;
  productId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "operation_products" */
export type Operation_Products_Min_Order_By = {
  operationId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "operation_products" */
export type Operation_Products_Mutation_Response = {
  __typename?: 'operation_products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operation_Products>;
};

/** on_conflict condition type for table "operation_products" */
export type Operation_Products_On_Conflict = {
  constraint: Operation_Products_Constraint;
  update_columns?: Array<Operation_Products_Update_Column>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};

/** Ordering options when selecting data from "operation_products". */
export type Operation_Products_Order_By = {
  operationId?: InputMaybe<Order_By>;
  product?: InputMaybe<Products_Order_By>;
  productId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operation_products */
export type Operation_Products_Pk_Columns_Input = {
  operationId: Scalars['bigint'];
  productId: Scalars['uuid'];
};

/** select columns of table "operation_products" */
export enum Operation_Products_Select_Column {
  /** column name */
  OperationId = 'operationId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "operation_products" */
export type Operation_Products_Set_Input = {
  operationId?: InputMaybe<Scalars['bigint']>;
  productId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Operation_Products_Stddev_Fields = {
  __typename?: 'operation_products_stddev_fields';
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "operation_products" */
export type Operation_Products_Stddev_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Operation_Products_Stddev_Pop_Fields = {
  __typename?: 'operation_products_stddev_pop_fields';
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "operation_products" */
export type Operation_Products_Stddev_Pop_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Operation_Products_Stddev_Samp_Fields = {
  __typename?: 'operation_products_stddev_samp_fields';
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "operation_products" */
export type Operation_Products_Stddev_Samp_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "operation_products" */
export type Operation_Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operation_Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operation_Products_Stream_Cursor_Value_Input = {
  operationId?: InputMaybe<Scalars['bigint']>;
  productId?: InputMaybe<Scalars['uuid']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Operation_Products_Sum_Fields = {
  __typename?: 'operation_products_sum_fields';
  operationId?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "operation_products" */
export type Operation_Products_Sum_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "operation_products" */
export enum Operation_Products_Update_Column {
  /** column name */
  OperationId = 'operationId',
  /** column name */
  ProductId = 'productId',
  /** column name */
  UserId = 'userId'
}

export type Operation_Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operation_Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operation_Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Operation_Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operation_Products_Var_Pop_Fields = {
  __typename?: 'operation_products_var_pop_fields';
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "operation_products" */
export type Operation_Products_Var_Pop_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Operation_Products_Var_Samp_Fields = {
  __typename?: 'operation_products_var_samp_fields';
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "operation_products" */
export type Operation_Products_Var_Samp_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Operation_Products_Variance_Fields = {
  __typename?: 'operation_products_variance_fields';
  operationId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "operation_products" */
export type Operation_Products_Variance_Order_By = {
  operationId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "operations" */
export type Operations = {
  __typename?: 'operations';
  billingRate: Scalars['numeric'];
  billingUnit: Chargeable_Units_Enum;
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  extras: Array<Operation_Extras>;
  /** An aggregate relationship */
  extras_aggregate: Operation_Extras_Aggregate;
  id: Scalars['bigint'];
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobs_aggregate: Jobs_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  products: Array<Operation_Products>;
  /** An aggregate relationship */
  products_aggregate: Operation_Products_Aggregate;
  status: Entity_Status_Enum;
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  userId: Scalars['Int'];
};


/** columns and relationships of "operations" */
export type OperationsExtrasArgs = {
  distinct_on?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Extras_Order_By>>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsExtras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Extras_Order_By>>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsProductsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Products_Order_By>>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};


/** columns and relationships of "operations" */
export type OperationsProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Products_Order_By>>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};

/** aggregated selection of "operations" */
export type Operations_Aggregate = {
  __typename?: 'operations_aggregate';
  aggregate?: Maybe<Operations_Aggregate_Fields>;
  nodes: Array<Operations>;
};

/** aggregate fields of "operations" */
export type Operations_Aggregate_Fields = {
  __typename?: 'operations_aggregate_fields';
  avg?: Maybe<Operations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Operations_Max_Fields>;
  min?: Maybe<Operations_Min_Fields>;
  stddev?: Maybe<Operations_Stddev_Fields>;
  stddev_pop?: Maybe<Operations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Operations_Stddev_Samp_Fields>;
  sum?: Maybe<Operations_Sum_Fields>;
  var_pop?: Maybe<Operations_Var_Pop_Fields>;
  var_samp?: Maybe<Operations_Var_Samp_Fields>;
  variance?: Maybe<Operations_Variance_Fields>;
};


/** aggregate fields of "operations" */
export type Operations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Operations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Operations_Avg_Fields = {
  __typename?: 'operations_avg_fields';
  billingRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "operations". All fields are combined with a logical 'AND'. */
export type Operations_Bool_Exp = {
  _and?: InputMaybe<Array<Operations_Bool_Exp>>;
  _not?: InputMaybe<Operations_Bool_Exp>;
  _or?: InputMaybe<Array<Operations_Bool_Exp>>;
  billingRate?: InputMaybe<Numeric_Comparison_Exp>;
  billingUnit?: InputMaybe<Chargeable_Units_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  extras?: InputMaybe<Operation_Extras_Bool_Exp>;
  extras_aggregate?: InputMaybe<Operation_Extras_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jobs?: InputMaybe<Jobs_Bool_Exp>;
  jobs_aggregate?: InputMaybe<Jobs_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Operation_Products_Bool_Exp>;
  products_aggregate?: InputMaybe<Operation_Products_Aggregate_Bool_Exp>;
  status?: InputMaybe<Entity_Status_Enum_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "operations" */
export enum Operations_Constraint {
  /** unique or primary key constraint on columns "id" */
  OperationsPkey = 'operations_pkey'
}

/** input type for incrementing numeric columns in table "operations" */
export type Operations_Inc_Input = {
  billingRate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "operations" */
export type Operations_Insert_Input = {
  billingRate?: InputMaybe<Scalars['numeric']>;
  billingUnit?: InputMaybe<Chargeable_Units_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  extras?: InputMaybe<Operation_Extras_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']>;
  jobs?: InputMaybe<Jobs_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Operation_Products_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Entity_Status_Enum>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Operations_Max_Fields = {
  __typename?: 'operations_max_fields';
  billingRate?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Operations_Min_Fields = {
  __typename?: 'operations_min_fields';
  billingRate?: Maybe<Scalars['numeric']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "operations" */
export type Operations_Mutation_Response = {
  __typename?: 'operations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Operations>;
};

/** input type for inserting object relation for remote table "operations" */
export type Operations_Obj_Rel_Insert_Input = {
  data: Operations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Operations_On_Conflict>;
};

/** on_conflict condition type for table "operations" */
export type Operations_On_Conflict = {
  constraint: Operations_Constraint;
  update_columns?: Array<Operations_Update_Column>;
  where?: InputMaybe<Operations_Bool_Exp>;
};

/** Ordering options when selecting data from "operations". */
export type Operations_Order_By = {
  billingRate?: InputMaybe<Order_By>;
  billingUnit?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  extras_aggregate?: InputMaybe<Operation_Extras_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<Jobs_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Operation_Products_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: operations */
export type Operations_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "operations" */
export enum Operations_Select_Column {
  /** column name */
  BillingRate = 'billingRate',
  /** column name */
  BillingUnit = 'billingUnit',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "operations" */
export type Operations_Set_Input = {
  billingRate?: InputMaybe<Scalars['numeric']>;
  billingUnit?: InputMaybe<Chargeable_Units_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Entity_Status_Enum>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Operations_Stddev_Fields = {
  __typename?: 'operations_stddev_fields';
  billingRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Operations_Stddev_Pop_Fields = {
  __typename?: 'operations_stddev_pop_fields';
  billingRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Operations_Stddev_Samp_Fields = {
  __typename?: 'operations_stddev_samp_fields';
  billingRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "operations" */
export type Operations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Operations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Operations_Stream_Cursor_Value_Input = {
  billingRate?: InputMaybe<Scalars['numeric']>;
  billingUnit?: InputMaybe<Chargeable_Units_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Entity_Status_Enum>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Operations_Sum_Fields = {
  __typename?: 'operations_sum_fields';
  billingRate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** update columns of table "operations" */
export enum Operations_Update_Column {
  /** column name */
  BillingRate = 'billingRate',
  /** column name */
  BillingUnit = 'billingUnit',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Operations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Operations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Operations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Operations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Operations_Var_Pop_Fields = {
  __typename?: 'operations_var_pop_fields';
  billingRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Operations_Var_Samp_Fields = {
  __typename?: 'operations_var_samp_fields';
  billingRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Operations_Variance_Fields = {
  __typename?: 'operations_variance_fields';
  billingRate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Stores short-lived otp for users */
export type Otps = {
  __typename?: 'otps';
  expires_at: Scalars['timestamp'];
  otp: Scalars['String'];
  user_id: Scalars['Int'];
};

/** aggregated selection of "otps" */
export type Otps_Aggregate = {
  __typename?: 'otps_aggregate';
  aggregate?: Maybe<Otps_Aggregate_Fields>;
  nodes: Array<Otps>;
};

/** aggregate fields of "otps" */
export type Otps_Aggregate_Fields = {
  __typename?: 'otps_aggregate_fields';
  avg?: Maybe<Otps_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Otps_Max_Fields>;
  min?: Maybe<Otps_Min_Fields>;
  stddev?: Maybe<Otps_Stddev_Fields>;
  stddev_pop?: Maybe<Otps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Otps_Stddev_Samp_Fields>;
  sum?: Maybe<Otps_Sum_Fields>;
  var_pop?: Maybe<Otps_Var_Pop_Fields>;
  var_samp?: Maybe<Otps_Var_Samp_Fields>;
  variance?: Maybe<Otps_Variance_Fields>;
};


/** aggregate fields of "otps" */
export type Otps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Otps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Otps_Avg_Fields = {
  __typename?: 'otps_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "otps". All fields are combined with a logical 'AND'. */
export type Otps_Bool_Exp = {
  _and?: InputMaybe<Array<Otps_Bool_Exp>>;
  _not?: InputMaybe<Otps_Bool_Exp>;
  _or?: InputMaybe<Array<Otps_Bool_Exp>>;
  expires_at?: InputMaybe<Timestamp_Comparison_Exp>;
  otp?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "otps" */
export enum Otps_Constraint {
  /** unique or primary key constraint on columns "user_id", "otp" */
  OtpsPkey = 'otps_pkey'
}

/** input type for incrementing numeric columns in table "otps" */
export type Otps_Inc_Input = {
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "otps" */
export type Otps_Insert_Input = {
  expires_at?: InputMaybe<Scalars['timestamp']>;
  otp?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Otps_Max_Fields = {
  __typename?: 'otps_max_fields';
  expires_at?: Maybe<Scalars['timestamp']>;
  otp?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Otps_Min_Fields = {
  __typename?: 'otps_min_fields';
  expires_at?: Maybe<Scalars['timestamp']>;
  otp?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "otps" */
export type Otps_Mutation_Response = {
  __typename?: 'otps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Otps>;
};

/** on_conflict condition type for table "otps" */
export type Otps_On_Conflict = {
  constraint: Otps_Constraint;
  update_columns?: Array<Otps_Update_Column>;
  where?: InputMaybe<Otps_Bool_Exp>;
};

/** Ordering options when selecting data from "otps". */
export type Otps_Order_By = {
  expires_at?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: otps */
export type Otps_Pk_Columns_Input = {
  otp: Scalars['String'];
  user_id: Scalars['Int'];
};

/** select columns of table "otps" */
export enum Otps_Select_Column {
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Otp = 'otp',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "otps" */
export type Otps_Set_Input = {
  expires_at?: InputMaybe<Scalars['timestamp']>;
  otp?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Otps_Stddev_Fields = {
  __typename?: 'otps_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Otps_Stddev_Pop_Fields = {
  __typename?: 'otps_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Otps_Stddev_Samp_Fields = {
  __typename?: 'otps_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "otps" */
export type Otps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Otps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Otps_Stream_Cursor_Value_Input = {
  expires_at?: InputMaybe<Scalars['timestamp']>;
  otp?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Otps_Sum_Fields = {
  __typename?: 'otps_sum_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "otps" */
export enum Otps_Update_Column {
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Otp = 'otp',
  /** column name */
  UserId = 'user_id'
}

export type Otps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Otps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Otps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Otps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Otps_Var_Pop_Fields = {
  __typename?: 'otps_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Otps_Var_Samp_Fields = {
  __typename?: 'otps_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Otps_Variance_Fields = {
  __typename?: 'otps_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ownership_types" */
export type Ownership_Types = {
  __typename?: 'ownership_types';
  comment: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "ownership_types" */
export type Ownership_Types_Aggregate = {
  __typename?: 'ownership_types_aggregate';
  aggregate?: Maybe<Ownership_Types_Aggregate_Fields>;
  nodes: Array<Ownership_Types>;
};

/** aggregate fields of "ownership_types" */
export type Ownership_Types_Aggregate_Fields = {
  __typename?: 'ownership_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ownership_Types_Max_Fields>;
  min?: Maybe<Ownership_Types_Min_Fields>;
};


/** aggregate fields of "ownership_types" */
export type Ownership_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ownership_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ownership_types". All fields are combined with a logical 'AND'. */
export type Ownership_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Ownership_Types_Bool_Exp>>;
  _not?: InputMaybe<Ownership_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Ownership_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ownership_types" */
export enum Ownership_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  OwnershipTypesPkey = 'ownership_types_pkey'
}

export enum Ownership_Types_Enum {
  Other = 'other',
  Owned = 'owned',
  Rented = 'rented'
}

/** Boolean expression to compare columns of type "ownership_types_enum". All fields are combined with logical 'AND'. */
export type Ownership_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ownership_Types_Enum>;
  _in?: InputMaybe<Array<Ownership_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Ownership_Types_Enum>;
  _nin?: InputMaybe<Array<Ownership_Types_Enum>>;
};

/** input type for inserting data into table "ownership_types" */
export type Ownership_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ownership_Types_Max_Fields = {
  __typename?: 'ownership_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ownership_Types_Min_Fields = {
  __typename?: 'ownership_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ownership_types" */
export type Ownership_Types_Mutation_Response = {
  __typename?: 'ownership_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ownership_Types>;
};

/** on_conflict condition type for table "ownership_types" */
export type Ownership_Types_On_Conflict = {
  constraint: Ownership_Types_Constraint;
  update_columns?: Array<Ownership_Types_Update_Column>;
  where?: InputMaybe<Ownership_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "ownership_types". */
export type Ownership_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ownership_types */
export type Ownership_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "ownership_types" */
export enum Ownership_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "ownership_types" */
export type Ownership_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ownership_types" */
export type Ownership_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ownership_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ownership_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ownership_types" */
export enum Ownership_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Ownership_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ownership_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ownership_Types_Bool_Exp;
};

/** Boolean expression to compare columns of type "point". All fields are combined with logical 'AND'. */
export type Point_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['point']>;
  _gt?: InputMaybe<Scalars['point']>;
  _gte?: InputMaybe<Scalars['point']>;
  _in?: InputMaybe<Array<Scalars['point']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['point']>;
  _lte?: InputMaybe<Scalars['point']>;
  _neq?: InputMaybe<Scalars['point']>;
  _nin?: InputMaybe<Array<Scalars['point']>>;
};

/** Boolean expression to compare columns of type "polygon". All fields are combined with logical 'AND'. */
export type Polygon_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['polygon']>;
  _gt?: InputMaybe<Scalars['polygon']>;
  _gte?: InputMaybe<Scalars['polygon']>;
  _in?: InputMaybe<Array<Scalars['polygon']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['polygon']>;
  _lte?: InputMaybe<Scalars['polygon']>;
  _neq?: InputMaybe<Scalars['polygon']>;
  _nin?: InputMaybe<Array<Scalars['polygon']>>;
};

/** columns and relationships of "polygons" */
export type Polygons = {
  __typename?: 'polygons';
  createdAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  defaultFarm: Farms;
  defaultFarmId: Scalars['bigint'];
  geometry?: Maybe<Scalars['polygon']>;
  geometry_wkt?: Maybe<Scalars['String']>;
  id: Scalars['bigint'];
  /** An array relationship */
  seasonShots: Array<Field_Season_Shot>;
  /** An aggregate relationship */
  seasonShots_aggregate: Field_Season_Shot_Aggregate;
  size?: Maybe<Scalars['float8']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "polygons" */
export type PolygonsSeasonShotsArgs = {
  distinct_on?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Season_Shot_Order_By>>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};


/** columns and relationships of "polygons" */
export type PolygonsSeasonShots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Season_Shot_Order_By>>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};

/** aggregated selection of "polygons" */
export type Polygons_Aggregate = {
  __typename?: 'polygons_aggregate';
  aggregate?: Maybe<Polygons_Aggregate_Fields>;
  nodes: Array<Polygons>;
};

/** aggregate fields of "polygons" */
export type Polygons_Aggregate_Fields = {
  __typename?: 'polygons_aggregate_fields';
  avg?: Maybe<Polygons_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Polygons_Max_Fields>;
  min?: Maybe<Polygons_Min_Fields>;
  stddev?: Maybe<Polygons_Stddev_Fields>;
  stddev_pop?: Maybe<Polygons_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Polygons_Stddev_Samp_Fields>;
  sum?: Maybe<Polygons_Sum_Fields>;
  var_pop?: Maybe<Polygons_Var_Pop_Fields>;
  var_samp?: Maybe<Polygons_Var_Samp_Fields>;
  variance?: Maybe<Polygons_Variance_Fields>;
};


/** aggregate fields of "polygons" */
export type Polygons_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Polygons_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Polygons_Avg_Fields = {
  __typename?: 'polygons_avg_fields';
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "polygons". All fields are combined with a logical 'AND'. */
export type Polygons_Bool_Exp = {
  _and?: InputMaybe<Array<Polygons_Bool_Exp>>;
  _not?: InputMaybe<Polygons_Bool_Exp>;
  _or?: InputMaybe<Array<Polygons_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  defaultFarm?: InputMaybe<Farms_Bool_Exp>;
  defaultFarmId?: InputMaybe<Bigint_Comparison_Exp>;
  geometry?: InputMaybe<Polygon_Comparison_Exp>;
  geometry_wkt?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  seasonShots?: InputMaybe<Field_Season_Shot_Bool_Exp>;
  seasonShots_aggregate?: InputMaybe<Field_Season_Shot_Aggregate_Bool_Exp>;
  size?: InputMaybe<Float8_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "polygons" */
export enum Polygons_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolygonsPkey = 'polygons_pkey'
}

/** input type for incrementing numeric columns in table "polygons" */
export type Polygons_Inc_Input = {
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "polygons" */
export type Polygons_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultFarm?: InputMaybe<Farms_Obj_Rel_Insert_Input>;
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  geometry?: InputMaybe<Scalars['polygon']>;
  geometry_wkt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  seasonShots?: InputMaybe<Field_Season_Shot_Arr_Rel_Insert_Input>;
  size?: InputMaybe<Scalars['float8']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Polygons_Max_Fields = {
  __typename?: 'polygons_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultFarmId?: Maybe<Scalars['bigint']>;
  geometry_wkt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['float8']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Polygons_Min_Fields = {
  __typename?: 'polygons_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  defaultFarmId?: Maybe<Scalars['bigint']>;
  geometry_wkt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['float8']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "polygons" */
export type Polygons_Mutation_Response = {
  __typename?: 'polygons_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Polygons>;
};

/** input type for inserting object relation for remote table "polygons" */
export type Polygons_Obj_Rel_Insert_Input = {
  data: Polygons_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Polygons_On_Conflict>;
};

/** on_conflict condition type for table "polygons" */
export type Polygons_On_Conflict = {
  constraint: Polygons_Constraint;
  update_columns?: Array<Polygons_Update_Column>;
  where?: InputMaybe<Polygons_Bool_Exp>;
};

/** Ordering options when selecting data from "polygons". */
export type Polygons_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  defaultFarm?: InputMaybe<Farms_Order_By>;
  defaultFarmId?: InputMaybe<Order_By>;
  geometry?: InputMaybe<Order_By>;
  geometry_wkt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  seasonShots_aggregate?: InputMaybe<Field_Season_Shot_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: polygons */
export type Polygons_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "polygons" */
export enum Polygons_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultFarmId = 'defaultFarmId',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GeometryWkt = 'geometry_wkt',
  /** column name */
  Id = 'id',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "polygons" */
export type Polygons_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  geometry?: InputMaybe<Scalars['polygon']>;
  geometry_wkt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['float8']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Polygons_Stddev_Fields = {
  __typename?: 'polygons_stddev_fields';
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Polygons_Stddev_Pop_Fields = {
  __typename?: 'polygons_stddev_pop_fields';
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Polygons_Stddev_Samp_Fields = {
  __typename?: 'polygons_stddev_samp_fields';
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "polygons" */
export type Polygons_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Polygons_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Polygons_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  defaultFarmId?: InputMaybe<Scalars['bigint']>;
  geometry?: InputMaybe<Scalars['polygon']>;
  geometry_wkt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['bigint']>;
  size?: InputMaybe<Scalars['float8']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Polygons_Sum_Fields = {
  __typename?: 'polygons_sum_fields';
  defaultFarmId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  size?: Maybe<Scalars['float8']>;
};

/** update columns of table "polygons" */
export enum Polygons_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DefaultFarmId = 'defaultFarmId',
  /** column name */
  Geometry = 'geometry',
  /** column name */
  GeometryWkt = 'geometry_wkt',
  /** column name */
  Id = 'id',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Polygons_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Polygons_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Polygons_Set_Input>;
  /** filter the rows which have to be updated */
  where: Polygons_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Polygons_Var_Pop_Fields = {
  __typename?: 'polygons_var_pop_fields';
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Polygons_Var_Samp_Fields = {
  __typename?: 'polygons_var_samp_fields';
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Polygons_Variance_Fields = {
  __typename?: 'polygons_variance_fields';
  defaultFarmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'products';
  chargeableUnit: Chargeable_Units_Enum;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  jobs: Array<Job_Products>;
  /** An aggregate relationship */
  jobs_aggregate: Job_Products_Aggregate;
  name: Scalars['String'];
  pricePerUnit: Scalars['numeric'];
  status: Entity_Status_Enum;
  userId: Scalars['Int'];
};


/** columns and relationships of "products" */
export type ProductsJobsArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


/** columns and relationships of "products" */
export type ProductsJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};

/** aggregated selection of "products" */
export type Products_Aggregate = {
  __typename?: 'products_aggregate';
  aggregate?: Maybe<Products_Aggregate_Fields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type Products_Aggregate_Fields = {
  __typename?: 'products_aggregate_fields';
  avg?: Maybe<Products_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Products_Max_Fields>;
  min?: Maybe<Products_Min_Fields>;
  stddev?: Maybe<Products_Stddev_Fields>;
  stddev_pop?: Maybe<Products_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Products_Stddev_Samp_Fields>;
  sum?: Maybe<Products_Sum_Fields>;
  var_pop?: Maybe<Products_Var_Pop_Fields>;
  var_samp?: Maybe<Products_Var_Samp_Fields>;
  variance?: Maybe<Products_Variance_Fields>;
};


/** aggregate fields of "products" */
export type Products_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Products_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Products_Avg_Fields = {
  __typename?: 'products_avg_fields';
  pricePerUnit?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type Products_Bool_Exp = {
  _and?: InputMaybe<Array<Products_Bool_Exp>>;
  _not?: InputMaybe<Products_Bool_Exp>;
  _or?: InputMaybe<Array<Products_Bool_Exp>>;
  chargeableUnit?: InputMaybe<Chargeable_Units_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobs?: InputMaybe<Job_Products_Bool_Exp>;
  jobs_aggregate?: InputMaybe<Job_Products_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pricePerUnit?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<Entity_Status_Enum_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "products" */
export enum Products_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductsPkey = 'products_pkey'
}

/** input type for incrementing numeric columns in table "products" */
export type Products_Inc_Input = {
  pricePerUnit?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "products" */
export type Products_Insert_Input = {
  chargeableUnit?: InputMaybe<Chargeable_Units_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobs?: InputMaybe<Job_Products_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  pricePerUnit?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Products_Max_Fields = {
  __typename?: 'products_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  pricePerUnit?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Products_Min_Fields = {
  __typename?: 'products_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  pricePerUnit?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "products" */
export type Products_Mutation_Response = {
  __typename?: 'products_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type Products_Obj_Rel_Insert_Input = {
  data: Products_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Products_On_Conflict>;
};

/** on_conflict condition type for table "products" */
export type Products_On_Conflict = {
  constraint: Products_Constraint;
  update_columns?: Array<Products_Update_Column>;
  where?: InputMaybe<Products_Bool_Exp>;
};

/** Ordering options when selecting data from "products". */
export type Products_Order_By = {
  chargeableUnit?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<Job_Products_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  pricePerUnit?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: products */
export type Products_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "products" */
export enum Products_Select_Column {
  /** column name */
  ChargeableUnit = 'chargeableUnit',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PricePerUnit = 'pricePerUnit',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "products" */
export type Products_Set_Input = {
  chargeableUnit?: InputMaybe<Chargeable_Units_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  pricePerUnit?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Products_Stddev_Fields = {
  __typename?: 'products_stddev_fields';
  pricePerUnit?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Products_Stddev_Pop_Fields = {
  __typename?: 'products_stddev_pop_fields';
  pricePerUnit?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Products_Stddev_Samp_Fields = {
  __typename?: 'products_stddev_samp_fields';
  pricePerUnit?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "products" */
export type Products_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Products_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Products_Stream_Cursor_Value_Input = {
  chargeableUnit?: InputMaybe<Chargeable_Units_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  pricePerUnit?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Products_Sum_Fields = {
  __typename?: 'products_sum_fields';
  pricePerUnit?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
};

/** update columns of table "products" */
export enum Products_Update_Column {
  /** column name */
  ChargeableUnit = 'chargeableUnit',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PricePerUnit = 'pricePerUnit',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'userId'
}

export type Products_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Products_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Products_Set_Input>;
  /** filter the rows which have to be updated */
  where: Products_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Products_Var_Pop_Fields = {
  __typename?: 'products_var_pop_fields';
  pricePerUnit?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Products_Var_Samp_Fields = {
  __typename?: 'products_var_samp_fields';
  pricePerUnit?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Products_Variance_Fields = {
  __typename?: 'products_variance_fields';
  pricePerUnit?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  api_login_user?: Maybe<Api_Login_User_Output>;
  /** fetch data from the table: "chargeable_units" */
  chargeable_units: Array<Chargeable_Units>;
  /** fetch aggregated fields from the table: "chargeable_units" */
  chargeable_units_aggregate: Chargeable_Units_Aggregate;
  /** fetch data from the table: "chargeable_units" using primary key columns */
  chargeable_units_by_pk?: Maybe<Chargeable_Units>;
  /** fetch data from the table: "entity_status" */
  entity_status: Array<Entity_Status>;
  /** fetch aggregated fields from the table: "entity_status" */
  entity_status_aggregate: Entity_Status_Aggregate;
  /** fetch data from the table: "entity_status" using primary key columns */
  entity_status_by_pk?: Maybe<Entity_Status>;
  /** fetch data from the table: "farms" */
  farms: Array<Farms>;
  /** fetch aggregated fields from the table: "farms" */
  farms_aggregate: Farms_Aggregate;
  /** fetch data from the table: "farms" using primary key columns */
  farms_by_pk?: Maybe<Farms>;
  /** fetch data from the table: "field_season_shot" */
  field_season_shot: Array<Field_Season_Shot>;
  /** fetch aggregated fields from the table: "field_season_shot" */
  field_season_shot_aggregate: Field_Season_Shot_Aggregate;
  /** fetch data from the table: "field_season_shot" using primary key columns */
  field_season_shot_by_pk?: Maybe<Field_Season_Shot>;
  /** fetch data from the table: "fields" */
  fields: Array<Fields>;
  /** fetch aggregated fields from the table: "fields" */
  fields_aggregate: Fields_Aggregate;
  /** fetch data from the table: "fields" using primary key columns */
  fields_by_pk?: Maybe<Fields>;
  /** fetch data from the table: "high_res_map_annotations" */
  high_res_map_annotations: Array<High_Res_Map_Annotations>;
  /** fetch aggregated fields from the table: "high_res_map_annotations" */
  high_res_map_annotations_aggregate: High_Res_Map_Annotations_Aggregate;
  /** fetch data from the table: "high_res_map_annotations" using primary key columns */
  high_res_map_annotations_by_pk?: Maybe<High_Res_Map_Annotations>;
  /** fetch data from the table: "high_res_map_layers" */
  high_res_map_layers: Array<High_Res_Map_Layers>;
  /** fetch aggregated fields from the table: "high_res_map_layers" */
  high_res_map_layers_aggregate: High_Res_Map_Layers_Aggregate;
  /** fetch data from the table: "high_res_map_layers" using primary key columns */
  high_res_map_layers_by_pk?: Maybe<High_Res_Map_Layers>;
  /** fetch data from the table: "high_res_maps" */
  high_res_maps: Array<High_Res_Maps>;
  /** fetch aggregated fields from the table: "high_res_maps" */
  high_res_maps_aggregate: High_Res_Maps_Aggregate;
  /** fetch data from the table: "high_res_maps" using primary key columns */
  high_res_maps_by_pk?: Maybe<High_Res_Maps>;
  /** fetch data from the table: "implements" */
  implements: Array<Implements>;
  /** fetch aggregated fields from the table: "implements" */
  implements_aggregate: Implements_Aggregate;
  /** fetch data from the table: "implements" using primary key columns */
  implements_by_pk?: Maybe<Implements>;
  /** fetch data from the table: "inventory" */
  inventory: Array<Inventory>;
  /** fetch aggregated fields from the table: "inventory" */
  inventory_aggregate: Inventory_Aggregate;
  /** fetch data from the table: "inventory" using primary key columns */
  inventory_by_pk?: Maybe<Inventory>;
  /** fetch data from the table: "job_extras" */
  job_extras: Array<Job_Extras>;
  /** fetch aggregated fields from the table: "job_extras" */
  job_extras_aggregate: Job_Extras_Aggregate;
  /** fetch data from the table: "job_extras" using primary key columns */
  job_extras_by_pk?: Maybe<Job_Extras>;
  /** fetch data from the table: "job_fields" */
  job_fields: Array<Job_Fields>;
  /** fetch aggregated fields from the table: "job_fields" */
  job_fields_aggregate: Job_Fields_Aggregate;
  /** fetch data from the table: "job_fields" using primary key columns */
  job_fields_by_pk?: Maybe<Job_Fields>;
  /** fetch data from the table: "job_locations" */
  job_locations: Array<Job_Locations>;
  /** fetch aggregated fields from the table: "job_locations" */
  job_locations_aggregate: Job_Locations_Aggregate;
  /** fetch data from the table: "job_locations" using primary key columns */
  job_locations_by_pk?: Maybe<Job_Locations>;
  /** fetch data from the table: "job_operator_implements" */
  job_operator_implements: Array<Job_Operator_Implements>;
  /** fetch aggregated fields from the table: "job_operator_implements" */
  job_operator_implements_aggregate: Job_Operator_Implements_Aggregate;
  /** fetch data from the table: "job_operator_implements" using primary key columns */
  job_operator_implements_by_pk?: Maybe<Job_Operator_Implements>;
  /** fetch data from the table: "job_operator_vehicles" */
  job_operator_vehicles: Array<Job_Operator_Vehicles>;
  /** fetch aggregated fields from the table: "job_operator_vehicles" */
  job_operator_vehicles_aggregate: Job_Operator_Vehicles_Aggregate;
  /** fetch data from the table: "job_operator_vehicles" using primary key columns */
  job_operator_vehicles_by_pk?: Maybe<Job_Operator_Vehicles>;
  /** fetch data from the table: "job_operators" */
  job_operators: Array<Job_Operators>;
  /** fetch aggregated fields from the table: "job_operators" */
  job_operators_aggregate: Job_Operators_Aggregate;
  /** fetch data from the table: "job_operators" using primary key columns */
  job_operators_by_pk?: Maybe<Job_Operators>;
  /** fetch data from the table: "job_products" */
  job_products: Array<Job_Products>;
  /** fetch aggregated fields from the table: "job_products" */
  job_products_aggregate: Job_Products_Aggregate;
  /** fetch data from the table: "job_products" using primary key columns */
  job_products_by_pk?: Maybe<Job_Products>;
  /** fetch data from the table: "job_status" */
  job_status: Array<Job_Status>;
  /** fetch aggregated fields from the table: "job_status" */
  job_status_aggregate: Job_Status_Aggregate;
  /** fetch data from the table: "job_status" using primary key columns */
  job_status_by_pk?: Maybe<Job_Status>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobs_aggregate: Jobs_Aggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobs_by_pk?: Maybe<Jobs>;
  /** fetch data from the table: "operation_extras" */
  operation_extras: Array<Operation_Extras>;
  /** fetch aggregated fields from the table: "operation_extras" */
  operation_extras_aggregate: Operation_Extras_Aggregate;
  /** fetch data from the table: "operation_extras" using primary key columns */
  operation_extras_by_pk?: Maybe<Operation_Extras>;
  /** fetch data from the table: "operation_products" */
  operation_products: Array<Operation_Products>;
  /** fetch aggregated fields from the table: "operation_products" */
  operation_products_aggregate: Operation_Products_Aggregate;
  /** fetch data from the table: "operation_products" using primary key columns */
  operation_products_by_pk?: Maybe<Operation_Products>;
  /** fetch data from the table: "operations" */
  operations: Array<Operations>;
  /** fetch aggregated fields from the table: "operations" */
  operations_aggregate: Operations_Aggregate;
  /** fetch data from the table: "operations" using primary key columns */
  operations_by_pk?: Maybe<Operations>;
  /** fetch data from the table: "otps" */
  otps: Array<Otps>;
  /** fetch aggregated fields from the table: "otps" */
  otps_aggregate: Otps_Aggregate;
  /** fetch data from the table: "otps" using primary key columns */
  otps_by_pk?: Maybe<Otps>;
  /** fetch data from the table: "ownership_types" */
  ownership_types: Array<Ownership_Types>;
  /** fetch aggregated fields from the table: "ownership_types" */
  ownership_types_aggregate: Ownership_Types_Aggregate;
  /** fetch data from the table: "ownership_types" using primary key columns */
  ownership_types_by_pk?: Maybe<Ownership_Types>;
  /** fetch data from the table: "polygons" */
  polygons: Array<Polygons>;
  /** fetch aggregated fields from the table: "polygons" */
  polygons_aggregate: Polygons_Aggregate;
  /** fetch data from the table: "polygons" using primary key columns */
  polygons_by_pk?: Maybe<Polygons>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table: "reports" */
  reports: Array<Reports>;
  /** fetch aggregated fields from the table: "reports" */
  reports_aggregate: Reports_Aggregate;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  required?: Maybe<Scalars['Int']>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table: "team_members" */
  team_members: Array<Team_Members>;
  /** fetch aggregated fields from the table: "team_members" */
  team_members_aggregate: Team_Members_Aggregate;
  /** fetch data from the table: "team_members" using primary key columns */
  team_members_by_pk?: Maybe<Team_Members>;
  /** fetch data from the table: "user_invites" */
  user_invites: Array<User_Invites>;
  /** fetch aggregated fields from the table: "user_invites" */
  user_invites_aggregate: User_Invites_Aggregate;
  /** fetch data from the table: "user_invites" using primary key columns */
  user_invites_by_pk?: Maybe<User_Invites>;
  /** fetch data from the table: "user_prefs" */
  user_prefs: Array<User_Prefs>;
  /** fetch aggregated fields from the table: "user_prefs" */
  user_prefs_aggregate: User_Prefs_Aggregate;
  /** fetch data from the table: "user_prefs" using primary key columns */
  user_prefs_by_pk?: Maybe<User_Prefs>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table: "user_tax_rates" */
  user_tax_rates: Array<User_Tax_Rates>;
  /** fetch aggregated fields from the table: "user_tax_rates" */
  user_tax_rates_aggregate: User_Tax_Rates_Aggregate;
  /** fetch data from the table: "user_tax_rates" using primary key columns */
  user_tax_rates_by_pk?: Maybe<User_Tax_Rates>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "vehicles" */
  vehicles: Array<Vehicles>;
  /** fetch aggregated fields from the table: "vehicles" */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
  /** fetch data from the table: "warehouses" */
  warehouses: Array<Warehouses>;
  /** fetch aggregated fields from the table: "warehouses" */
  warehouses_aggregate: Warehouses_Aggregate;
  /** fetch data from the table: "warehouses" using primary key columns */
  warehouses_by_pk?: Maybe<Warehouses>;
};


export type Query_RootApi_Login_UserArgs = {
  input?: InputMaybe<Api_Login_User_Input>;
};


export type Query_RootChargeable_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Chargeable_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chargeable_Units_Order_By>>;
  where?: InputMaybe<Chargeable_Units_Bool_Exp>;
};


export type Query_RootChargeable_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chargeable_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chargeable_Units_Order_By>>;
  where?: InputMaybe<Chargeable_Units_Bool_Exp>;
};


export type Query_RootChargeable_Units_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootEntity_StatusArgs = {
  distinct_on?: InputMaybe<Array<Entity_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Status_Order_By>>;
  where?: InputMaybe<Entity_Status_Bool_Exp>;
};


export type Query_RootEntity_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Status_Order_By>>;
  where?: InputMaybe<Entity_Status_Bool_Exp>;
};


export type Query_RootEntity_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farms_Order_By>>;
  where?: InputMaybe<Farms_Bool_Exp>;
};


export type Query_RootFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farms_Order_By>>;
  where?: InputMaybe<Farms_Bool_Exp>;
};


export type Query_RootFarms_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootField_Season_ShotArgs = {
  distinct_on?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Season_Shot_Order_By>>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};


export type Query_RootField_Season_Shot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Season_Shot_Order_By>>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};


export type Query_RootField_Season_Shot_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootFieldsArgs = {
  distinct_on?: InputMaybe<Array<Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fields_Order_By>>;
  where?: InputMaybe<Fields_Bool_Exp>;
};


export type Query_RootFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fields_Order_By>>;
  where?: InputMaybe<Fields_Bool_Exp>;
};


export type Query_RootFields_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootHigh_Res_Map_AnnotationsArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Annotations_Order_By>>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};


export type Query_RootHigh_Res_Map_Annotations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Annotations_Order_By>>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};


export type Query_RootHigh_Res_Map_Annotations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootHigh_Res_Map_LayersArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Layers_Order_By>>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};


export type Query_RootHigh_Res_Map_Layers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Layers_Order_By>>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};


export type Query_RootHigh_Res_Map_Layers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootHigh_Res_MapsArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Maps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Maps_Order_By>>;
  where?: InputMaybe<High_Res_Maps_Bool_Exp>;
};


export type Query_RootHigh_Res_Maps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Maps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Maps_Order_By>>;
  where?: InputMaybe<High_Res_Maps_Bool_Exp>;
};


export type Query_RootHigh_Res_Maps_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootImplementsArgs = {
  distinct_on?: InputMaybe<Array<Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Implements_Order_By>>;
  where?: InputMaybe<Implements_Bool_Exp>;
};


export type Query_RootImplements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Implements_Order_By>>;
  where?: InputMaybe<Implements_Bool_Exp>;
};


export type Query_RootImplements_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootInventoryArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Query_RootInventory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Query_RootInventory_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootJob_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Job_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Extras_Order_By>>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};


export type Query_RootJob_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Extras_Order_By>>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};


export type Query_RootJob_Extras_By_PkArgs = {
  jobId: Scalars['bigint'];
  name: Scalars['String'];
};


export type Query_RootJob_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


export type Query_RootJob_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


export type Query_RootJob_Fields_By_PkArgs = {
  jobId: Scalars['bigint'];
  seasonShotId: Scalars['bigint'];
};


export type Query_RootJob_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Job_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Locations_Order_By>>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};


export type Query_RootJob_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Locations_Order_By>>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};


export type Query_RootJob_Locations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootJob_Operator_ImplementsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


export type Query_RootJob_Operator_Implements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


export type Query_RootJob_Operator_Implements_By_PkArgs = {
  implementId: Scalars['uuid'];
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};


export type Query_RootJob_Operator_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


export type Query_RootJob_Operator_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


export type Query_RootJob_Operator_Vehicles_By_PkArgs = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
  vehicleId: Scalars['uuid'];
};


export type Query_RootJob_OperatorsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operators_Order_By>>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};


export type Query_RootJob_Operators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operators_Order_By>>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};


export type Query_RootJob_Operators_By_PkArgs = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};


export type Query_RootJob_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


export type Query_RootJob_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


export type Query_RootJob_Products_By_PkArgs = {
  jobId: Scalars['bigint'];
  productId: Scalars['uuid'];
};


export type Query_RootJob_StatusArgs = {
  distinct_on?: InputMaybe<Array<Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Status_Order_By>>;
  where?: InputMaybe<Job_Status_Bool_Exp>;
};


export type Query_RootJob_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Status_Order_By>>;
  where?: InputMaybe<Job_Status_Bool_Exp>;
};


export type Query_RootJob_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Query_RootJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Query_RootJobs_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOperation_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Extras_Order_By>>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};


export type Query_RootOperation_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Extras_Order_By>>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};


export type Query_RootOperation_Extras_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOperation_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Products_Order_By>>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};


export type Query_RootOperation_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Products_Order_By>>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};


export type Query_RootOperation_Products_By_PkArgs = {
  operationId: Scalars['bigint'];
  productId: Scalars['uuid'];
};


export type Query_RootOperationsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Query_RootOperations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Query_RootOperations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootOtpsArgs = {
  distinct_on?: InputMaybe<Array<Otps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otps_Order_By>>;
  where?: InputMaybe<Otps_Bool_Exp>;
};


export type Query_RootOtps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Otps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otps_Order_By>>;
  where?: InputMaybe<Otps_Bool_Exp>;
};


export type Query_RootOtps_By_PkArgs = {
  otp: Scalars['String'];
  user_id: Scalars['Int'];
};


export type Query_RootOwnership_TypesArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownership_Types_Order_By>>;
  where?: InputMaybe<Ownership_Types_Bool_Exp>;
};


export type Query_RootOwnership_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownership_Types_Order_By>>;
  where?: InputMaybe<Ownership_Types_Bool_Exp>;
};


export type Query_RootOwnership_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootPolygonsArgs = {
  distinct_on?: InputMaybe<Array<Polygons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polygons_Order_By>>;
  where?: InputMaybe<Polygons_Bool_Exp>;
};


export type Query_RootPolygons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polygons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polygons_Order_By>>;
  where?: InputMaybe<Polygons_Bool_Exp>;
};


export type Query_RootPolygons_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Query_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Query_RootReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Query_RootReports_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Query_RootRoles_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootTeam_MembersArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


export type Query_RootTeam_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


export type Query_RootTeam_Members_By_PkArgs = {
  ownerId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type Query_RootUser_InvitesArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Query_RootUser_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Query_RootUser_Invites_By_PkArgs = {
  invite_id: Scalars['String'];
};


export type Query_RootUser_PrefsArgs = {
  distinct_on?: InputMaybe<Array<User_Prefs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Prefs_Order_By>>;
  where?: InputMaybe<User_Prefs_Bool_Exp>;
};


export type Query_RootUser_Prefs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Prefs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Prefs_Order_By>>;
  where?: InputMaybe<User_Prefs_Bool_Exp>;
};


export type Query_RootUser_Prefs_By_PkArgs = {
  userId: Scalars['Int'];
};


export type Query_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Query_RootUser_Profiles_By_PkArgs = {
  userId: Scalars['Int'];
};


export type Query_RootUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Query_RootUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Query_RootUser_Roles_By_PkArgs = {
  role: Roles_Enum;
  user_id: Scalars['Int'];
};


export type Query_RootUser_Tax_RatesArgs = {
  distinct_on?: InputMaybe<Array<User_Tax_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Tax_Rates_Order_By>>;
  where?: InputMaybe<User_Tax_Rates_Bool_Exp>;
};


export type Query_RootUser_Tax_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Tax_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Tax_Rates_Order_By>>;
  where?: InputMaybe<User_Tax_Rates_Bool_Exp>;
};


export type Query_RootUser_Tax_Rates_By_PkArgs = {
  label: Scalars['String'];
  userId: Scalars['Int'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Query_RootVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Query_RootVehicles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWarehousesArgs = {
  distinct_on?: InputMaybe<Array<Warehouses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Warehouses_Order_By>>;
  where?: InputMaybe<Warehouses_Bool_Exp>;
};


export type Query_RootWarehouses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warehouses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Warehouses_Order_By>>;
  where?: InputMaybe<Warehouses_Bool_Exp>;
};


export type Query_RootWarehouses_By_PkArgs = {
  id: Scalars['bigint'];
};

/** contains snapshot reports */
export type Reports = {
  __typename?: 'reports';
  createdAt: Scalars['timestamptz'];
  id: Scalars['bigint'];
  jsonSummary?: Maybe<Scalars['jsonb']>;
  link: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  seasonShot: Field_Season_Shot;
  seasonShotId: Scalars['bigint'];
  tag: Scalars['uuid'];
};


/** contains snapshot reports */
export type ReportsJsonSummaryArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "reports" */
export type Reports_Aggregate = {
  __typename?: 'reports_aggregate';
  aggregate?: Maybe<Reports_Aggregate_Fields>;
  nodes: Array<Reports>;
};

/** aggregate fields of "reports" */
export type Reports_Aggregate_Fields = {
  __typename?: 'reports_aggregate_fields';
  avg?: Maybe<Reports_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Reports_Max_Fields>;
  min?: Maybe<Reports_Min_Fields>;
  stddev?: Maybe<Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Reports_Sum_Fields>;
  var_pop?: Maybe<Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Reports_Var_Samp_Fields>;
  variance?: Maybe<Reports_Variance_Fields>;
};


/** aggregate fields of "reports" */
export type Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Reports_Append_Input = {
  jsonSummary?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Reports_Avg_Fields = {
  __typename?: 'reports_avg_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reports". All fields are combined with a logical 'AND'. */
export type Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Reports_Bool_Exp>>;
  _not?: InputMaybe<Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Reports_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jsonSummary?: InputMaybe<Jsonb_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  seasonShot?: InputMaybe<Field_Season_Shot_Bool_Exp>;
  seasonShotId?: InputMaybe<Bigint_Comparison_Exp>;
  tag?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "reports" */
export enum Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReportsPkey = 'reports_pkey',
  /** unique or primary key constraint on columns "tag" */
  ReportsTagKey = 'reports_tag_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Reports_Delete_At_Path_Input = {
  jsonSummary?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Reports_Delete_Elem_Input = {
  jsonSummary?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Reports_Delete_Key_Input = {
  jsonSummary?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "reports" */
export type Reports_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "reports" */
export type Reports_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  jsonSummary?: InputMaybe<Scalars['jsonb']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seasonShot?: InputMaybe<Field_Season_Shot_Obj_Rel_Insert_Input>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
  tag?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Reports_Max_Fields = {
  __typename?: 'reports_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Reports_Min_Fields = {
  __typename?: 'reports_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
  tag?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "reports" */
export type Reports_Mutation_Response = {
  __typename?: 'reports_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reports>;
};

/** on_conflict condition type for table "reports" */
export type Reports_On_Conflict = {
  constraint: Reports_Constraint;
  update_columns?: Array<Reports_Update_Column>;
  where?: InputMaybe<Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "reports". */
export type Reports_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jsonSummary?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  seasonShot?: InputMaybe<Field_Season_Shot_Order_By>;
  seasonShotId?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reports */
export type Reports_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Reports_Prepend_Input = {
  jsonSummary?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "reports" */
export enum Reports_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JsonSummary = 'jsonSummary',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  SeasonShotId = 'seasonShotId',
  /** column name */
  Tag = 'tag'
}

/** input type for updating data in table "reports" */
export type Reports_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  jsonSummary?: InputMaybe<Scalars['jsonb']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
  tag?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Reports_Stddev_Fields = {
  __typename?: 'reports_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Reports_Stddev_Pop_Fields = {
  __typename?: 'reports_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Reports_Stddev_Samp_Fields = {
  __typename?: 'reports_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reports" */
export type Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reports_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  jsonSummary?: InputMaybe<Scalars['jsonb']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  seasonShotId?: InputMaybe<Scalars['bigint']>;
  tag?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Reports_Sum_Fields = {
  __typename?: 'reports_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  seasonShotId?: Maybe<Scalars['bigint']>;
};

/** update columns of table "reports" */
export enum Reports_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JsonSummary = 'jsonSummary',
  /** column name */
  Link = 'link',
  /** column name */
  Name = 'name',
  /** column name */
  SeasonShotId = 'seasonShotId',
  /** column name */
  Tag = 'tag'
}

export type Reports_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Reports_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Reports_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Reports_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Reports_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reports_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Reports_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reports_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reports_Var_Pop_Fields = {
  __typename?: 'reports_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Reports_Var_Samp_Fields = {
  __typename?: 'reports_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Reports_Variance_Fields = {
  __typename?: 'reports_variance_fields';
  id?: Maybe<Scalars['Float']>;
  seasonShotId?: Maybe<Scalars['Float']>;
};

/** Enum table */
export type Roles = {
  __typename?: 'roles';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "roles" */
export type Roles_Aggregate = {
  __typename?: 'roles_aggregate';
  aggregate?: Maybe<Roles_Aggregate_Fields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type Roles_Aggregate_Fields = {
  __typename?: 'roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Roles_Max_Fields>;
  min?: Maybe<Roles_Min_Fields>;
};


/** aggregate fields of "roles" */
export type Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type Roles_Bool_Exp = {
  _and?: InputMaybe<Array<Roles_Bool_Exp>>;
  _not?: InputMaybe<Roles_Bool_Exp>;
  _or?: InputMaybe<Array<Roles_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "roles" */
export enum Roles_Constraint {
  /** unique or primary key constraint on columns "value" */
  RolesPkey = 'roles_pkey'
}

export enum Roles_Enum {
  Contractor = 'contractor',
  Farmer = 'farmer',
  Manager = 'manager',
  Operator = 'operator'
}

/** Boolean expression to compare columns of type "roles_enum". All fields are combined with logical 'AND'. */
export type Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Roles_Enum>;
  _in?: InputMaybe<Array<Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Roles_Enum>;
  _nin?: InputMaybe<Array<Roles_Enum>>;
};

/** input type for inserting data into table "roles" */
export type Roles_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Roles_Max_Fields = {
  __typename?: 'roles_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Roles_Min_Fields = {
  __typename?: 'roles_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "roles" */
export type Roles_Mutation_Response = {
  __typename?: 'roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** on_conflict condition type for table "roles" */
export type Roles_On_Conflict = {
  constraint: Roles_Constraint;
  update_columns?: Array<Roles_Update_Column>;
  where?: InputMaybe<Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "roles". */
export type Roles_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roles */
export type Roles_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "roles" */
export enum Roles_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "roles" */
export type Roles_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "roles" */
export type Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Roles_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "roles" */
export enum Roles_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Roles_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "chargeable_units" */
  chargeable_units: Array<Chargeable_Units>;
  /** fetch aggregated fields from the table: "chargeable_units" */
  chargeable_units_aggregate: Chargeable_Units_Aggregate;
  /** fetch data from the table: "chargeable_units" using primary key columns */
  chargeable_units_by_pk?: Maybe<Chargeable_Units>;
  /** fetch data from the table in a streaming manner: "chargeable_units" */
  chargeable_units_stream: Array<Chargeable_Units>;
  /** fetch data from the table: "entity_status" */
  entity_status: Array<Entity_Status>;
  /** fetch aggregated fields from the table: "entity_status" */
  entity_status_aggregate: Entity_Status_Aggregate;
  /** fetch data from the table: "entity_status" using primary key columns */
  entity_status_by_pk?: Maybe<Entity_Status>;
  /** fetch data from the table in a streaming manner: "entity_status" */
  entity_status_stream: Array<Entity_Status>;
  /** fetch data from the table: "farms" */
  farms: Array<Farms>;
  /** fetch aggregated fields from the table: "farms" */
  farms_aggregate: Farms_Aggregate;
  /** fetch data from the table: "farms" using primary key columns */
  farms_by_pk?: Maybe<Farms>;
  /** fetch data from the table in a streaming manner: "farms" */
  farms_stream: Array<Farms>;
  /** fetch data from the table: "field_season_shot" */
  field_season_shot: Array<Field_Season_Shot>;
  /** fetch aggregated fields from the table: "field_season_shot" */
  field_season_shot_aggregate: Field_Season_Shot_Aggregate;
  /** fetch data from the table: "field_season_shot" using primary key columns */
  field_season_shot_by_pk?: Maybe<Field_Season_Shot>;
  /** fetch data from the table in a streaming manner: "field_season_shot" */
  field_season_shot_stream: Array<Field_Season_Shot>;
  /** fetch data from the table: "fields" */
  fields: Array<Fields>;
  /** fetch aggregated fields from the table: "fields" */
  fields_aggregate: Fields_Aggregate;
  /** fetch data from the table: "fields" using primary key columns */
  fields_by_pk?: Maybe<Fields>;
  /** fetch data from the table in a streaming manner: "fields" */
  fields_stream: Array<Fields>;
  /** fetch data from the table: "high_res_map_annotations" */
  high_res_map_annotations: Array<High_Res_Map_Annotations>;
  /** fetch aggregated fields from the table: "high_res_map_annotations" */
  high_res_map_annotations_aggregate: High_Res_Map_Annotations_Aggregate;
  /** fetch data from the table: "high_res_map_annotations" using primary key columns */
  high_res_map_annotations_by_pk?: Maybe<High_Res_Map_Annotations>;
  /** fetch data from the table in a streaming manner: "high_res_map_annotations" */
  high_res_map_annotations_stream: Array<High_Res_Map_Annotations>;
  /** fetch data from the table: "high_res_map_layers" */
  high_res_map_layers: Array<High_Res_Map_Layers>;
  /** fetch aggregated fields from the table: "high_res_map_layers" */
  high_res_map_layers_aggregate: High_Res_Map_Layers_Aggregate;
  /** fetch data from the table: "high_res_map_layers" using primary key columns */
  high_res_map_layers_by_pk?: Maybe<High_Res_Map_Layers>;
  /** fetch data from the table in a streaming manner: "high_res_map_layers" */
  high_res_map_layers_stream: Array<High_Res_Map_Layers>;
  /** fetch data from the table: "high_res_maps" */
  high_res_maps: Array<High_Res_Maps>;
  /** fetch aggregated fields from the table: "high_res_maps" */
  high_res_maps_aggregate: High_Res_Maps_Aggregate;
  /** fetch data from the table: "high_res_maps" using primary key columns */
  high_res_maps_by_pk?: Maybe<High_Res_Maps>;
  /** fetch data from the table in a streaming manner: "high_res_maps" */
  high_res_maps_stream: Array<High_Res_Maps>;
  /** fetch data from the table: "implements" */
  implements: Array<Implements>;
  /** fetch aggregated fields from the table: "implements" */
  implements_aggregate: Implements_Aggregate;
  /** fetch data from the table: "implements" using primary key columns */
  implements_by_pk?: Maybe<Implements>;
  /** fetch data from the table in a streaming manner: "implements" */
  implements_stream: Array<Implements>;
  /** fetch data from the table: "inventory" */
  inventory: Array<Inventory>;
  /** fetch aggregated fields from the table: "inventory" */
  inventory_aggregate: Inventory_Aggregate;
  /** fetch data from the table: "inventory" using primary key columns */
  inventory_by_pk?: Maybe<Inventory>;
  /** fetch data from the table in a streaming manner: "inventory" */
  inventory_stream: Array<Inventory>;
  /** fetch data from the table: "job_extras" */
  job_extras: Array<Job_Extras>;
  /** fetch aggregated fields from the table: "job_extras" */
  job_extras_aggregate: Job_Extras_Aggregate;
  /** fetch data from the table: "job_extras" using primary key columns */
  job_extras_by_pk?: Maybe<Job_Extras>;
  /** fetch data from the table in a streaming manner: "job_extras" */
  job_extras_stream: Array<Job_Extras>;
  /** fetch data from the table: "job_fields" */
  job_fields: Array<Job_Fields>;
  /** fetch aggregated fields from the table: "job_fields" */
  job_fields_aggregate: Job_Fields_Aggregate;
  /** fetch data from the table: "job_fields" using primary key columns */
  job_fields_by_pk?: Maybe<Job_Fields>;
  /** fetch data from the table in a streaming manner: "job_fields" */
  job_fields_stream: Array<Job_Fields>;
  /** fetch data from the table: "job_locations" */
  job_locations: Array<Job_Locations>;
  /** fetch aggregated fields from the table: "job_locations" */
  job_locations_aggregate: Job_Locations_Aggregate;
  /** fetch data from the table: "job_locations" using primary key columns */
  job_locations_by_pk?: Maybe<Job_Locations>;
  /** fetch data from the table in a streaming manner: "job_locations" */
  job_locations_stream: Array<Job_Locations>;
  /** fetch data from the table: "job_operator_implements" */
  job_operator_implements: Array<Job_Operator_Implements>;
  /** fetch aggregated fields from the table: "job_operator_implements" */
  job_operator_implements_aggregate: Job_Operator_Implements_Aggregate;
  /** fetch data from the table: "job_operator_implements" using primary key columns */
  job_operator_implements_by_pk?: Maybe<Job_Operator_Implements>;
  /** fetch data from the table in a streaming manner: "job_operator_implements" */
  job_operator_implements_stream: Array<Job_Operator_Implements>;
  /** fetch data from the table: "job_operator_vehicles" */
  job_operator_vehicles: Array<Job_Operator_Vehicles>;
  /** fetch aggregated fields from the table: "job_operator_vehicles" */
  job_operator_vehicles_aggregate: Job_Operator_Vehicles_Aggregate;
  /** fetch data from the table: "job_operator_vehicles" using primary key columns */
  job_operator_vehicles_by_pk?: Maybe<Job_Operator_Vehicles>;
  /** fetch data from the table in a streaming manner: "job_operator_vehicles" */
  job_operator_vehicles_stream: Array<Job_Operator_Vehicles>;
  /** fetch data from the table: "job_operators" */
  job_operators: Array<Job_Operators>;
  /** fetch aggregated fields from the table: "job_operators" */
  job_operators_aggregate: Job_Operators_Aggregate;
  /** fetch data from the table: "job_operators" using primary key columns */
  job_operators_by_pk?: Maybe<Job_Operators>;
  /** fetch data from the table in a streaming manner: "job_operators" */
  job_operators_stream: Array<Job_Operators>;
  /** fetch data from the table: "job_products" */
  job_products: Array<Job_Products>;
  /** fetch aggregated fields from the table: "job_products" */
  job_products_aggregate: Job_Products_Aggregate;
  /** fetch data from the table: "job_products" using primary key columns */
  job_products_by_pk?: Maybe<Job_Products>;
  /** fetch data from the table in a streaming manner: "job_products" */
  job_products_stream: Array<Job_Products>;
  /** fetch data from the table: "job_status" */
  job_status: Array<Job_Status>;
  /** fetch aggregated fields from the table: "job_status" */
  job_status_aggregate: Job_Status_Aggregate;
  /** fetch data from the table: "job_status" using primary key columns */
  job_status_by_pk?: Maybe<Job_Status>;
  /** fetch data from the table in a streaming manner: "job_status" */
  job_status_stream: Array<Job_Status>;
  /** An array relationship */
  jobs: Array<Jobs>;
  /** An aggregate relationship */
  jobs_aggregate: Jobs_Aggregate;
  /** fetch data from the table: "jobs" using primary key columns */
  jobs_by_pk?: Maybe<Jobs>;
  /** fetch data from the table in a streaming manner: "jobs" */
  jobs_stream: Array<Jobs>;
  /** fetch data from the table: "operation_extras" */
  operation_extras: Array<Operation_Extras>;
  /** fetch aggregated fields from the table: "operation_extras" */
  operation_extras_aggregate: Operation_Extras_Aggregate;
  /** fetch data from the table: "operation_extras" using primary key columns */
  operation_extras_by_pk?: Maybe<Operation_Extras>;
  /** fetch data from the table in a streaming manner: "operation_extras" */
  operation_extras_stream: Array<Operation_Extras>;
  /** fetch data from the table: "operation_products" */
  operation_products: Array<Operation_Products>;
  /** fetch aggregated fields from the table: "operation_products" */
  operation_products_aggregate: Operation_Products_Aggregate;
  /** fetch data from the table: "operation_products" using primary key columns */
  operation_products_by_pk?: Maybe<Operation_Products>;
  /** fetch data from the table in a streaming manner: "operation_products" */
  operation_products_stream: Array<Operation_Products>;
  /** fetch data from the table: "operations" */
  operations: Array<Operations>;
  /** fetch aggregated fields from the table: "operations" */
  operations_aggregate: Operations_Aggregate;
  /** fetch data from the table: "operations" using primary key columns */
  operations_by_pk?: Maybe<Operations>;
  /** fetch data from the table in a streaming manner: "operations" */
  operations_stream: Array<Operations>;
  /** fetch data from the table: "otps" */
  otps: Array<Otps>;
  /** fetch aggregated fields from the table: "otps" */
  otps_aggregate: Otps_Aggregate;
  /** fetch data from the table: "otps" using primary key columns */
  otps_by_pk?: Maybe<Otps>;
  /** fetch data from the table in a streaming manner: "otps" */
  otps_stream: Array<Otps>;
  /** fetch data from the table: "ownership_types" */
  ownership_types: Array<Ownership_Types>;
  /** fetch aggregated fields from the table: "ownership_types" */
  ownership_types_aggregate: Ownership_Types_Aggregate;
  /** fetch data from the table: "ownership_types" using primary key columns */
  ownership_types_by_pk?: Maybe<Ownership_Types>;
  /** fetch data from the table in a streaming manner: "ownership_types" */
  ownership_types_stream: Array<Ownership_Types>;
  /** fetch data from the table: "polygons" */
  polygons: Array<Polygons>;
  /** fetch aggregated fields from the table: "polygons" */
  polygons_aggregate: Polygons_Aggregate;
  /** fetch data from the table: "polygons" using primary key columns */
  polygons_by_pk?: Maybe<Polygons>;
  /** fetch data from the table in a streaming manner: "polygons" */
  polygons_stream: Array<Polygons>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  products_aggregate: Products_Aggregate;
  /** fetch data from the table: "products" using primary key columns */
  products_by_pk?: Maybe<Products>;
  /** fetch data from the table in a streaming manner: "products" */
  products_stream: Array<Products>;
  /** fetch data from the table: "reports" */
  reports: Array<Reports>;
  /** fetch aggregated fields from the table: "reports" */
  reports_aggregate: Reports_Aggregate;
  /** fetch data from the table: "reports" using primary key columns */
  reports_by_pk?: Maybe<Reports>;
  /** fetch data from the table in a streaming manner: "reports" */
  reports_stream: Array<Reports>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  roles_aggregate: Roles_Aggregate;
  /** fetch data from the table: "roles" using primary key columns */
  roles_by_pk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  roles_stream: Array<Roles>;
  /** fetch data from the table: "team_members" */
  team_members: Array<Team_Members>;
  /** fetch aggregated fields from the table: "team_members" */
  team_members_aggregate: Team_Members_Aggregate;
  /** fetch data from the table: "team_members" using primary key columns */
  team_members_by_pk?: Maybe<Team_Members>;
  /** fetch data from the table in a streaming manner: "team_members" */
  team_members_stream: Array<Team_Members>;
  /** fetch data from the table: "user_invites" */
  user_invites: Array<User_Invites>;
  /** fetch aggregated fields from the table: "user_invites" */
  user_invites_aggregate: User_Invites_Aggregate;
  /** fetch data from the table: "user_invites" using primary key columns */
  user_invites_by_pk?: Maybe<User_Invites>;
  /** fetch data from the table in a streaming manner: "user_invites" */
  user_invites_stream: Array<User_Invites>;
  /** fetch data from the table: "user_prefs" */
  user_prefs: Array<User_Prefs>;
  /** fetch aggregated fields from the table: "user_prefs" */
  user_prefs_aggregate: User_Prefs_Aggregate;
  /** fetch data from the table: "user_prefs" using primary key columns */
  user_prefs_by_pk?: Maybe<User_Prefs>;
  /** fetch data from the table in a streaming manner: "user_prefs" */
  user_prefs_stream: Array<User_Prefs>;
  /** fetch data from the table: "user_profiles" */
  user_profiles: Array<User_Profiles>;
  /** fetch aggregated fields from the table: "user_profiles" */
  user_profiles_aggregate: User_Profiles_Aggregate;
  /** fetch data from the table: "user_profiles" using primary key columns */
  user_profiles_by_pk?: Maybe<User_Profiles>;
  /** fetch data from the table in a streaming manner: "user_profiles" */
  user_profiles_stream: Array<User_Profiles>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** fetch data from the table in a streaming manner: "user_roles" */
  user_roles_stream: Array<User_Roles>;
  /** fetch data from the table: "user_tax_rates" */
  user_tax_rates: Array<User_Tax_Rates>;
  /** fetch aggregated fields from the table: "user_tax_rates" */
  user_tax_rates_aggregate: User_Tax_Rates_Aggregate;
  /** fetch data from the table: "user_tax_rates" using primary key columns */
  user_tax_rates_by_pk?: Maybe<User_Tax_Rates>;
  /** fetch data from the table in a streaming manner: "user_tax_rates" */
  user_tax_rates_stream: Array<User_Tax_Rates>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "vehicles" */
  vehicles: Array<Vehicles>;
  /** fetch aggregated fields from the table: "vehicles" */
  vehicles_aggregate: Vehicles_Aggregate;
  /** fetch data from the table: "vehicles" using primary key columns */
  vehicles_by_pk?: Maybe<Vehicles>;
  /** fetch data from the table in a streaming manner: "vehicles" */
  vehicles_stream: Array<Vehicles>;
  /** fetch data from the table: "warehouses" */
  warehouses: Array<Warehouses>;
  /** fetch aggregated fields from the table: "warehouses" */
  warehouses_aggregate: Warehouses_Aggregate;
  /** fetch data from the table: "warehouses" using primary key columns */
  warehouses_by_pk?: Maybe<Warehouses>;
  /** fetch data from the table in a streaming manner: "warehouses" */
  warehouses_stream: Array<Warehouses>;
};


export type Subscription_RootChargeable_UnitsArgs = {
  distinct_on?: InputMaybe<Array<Chargeable_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chargeable_Units_Order_By>>;
  where?: InputMaybe<Chargeable_Units_Bool_Exp>;
};


export type Subscription_RootChargeable_Units_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chargeable_Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chargeable_Units_Order_By>>;
  where?: InputMaybe<Chargeable_Units_Bool_Exp>;
};


export type Subscription_RootChargeable_Units_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootChargeable_Units_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Chargeable_Units_Stream_Cursor_Input>>;
  where?: InputMaybe<Chargeable_Units_Bool_Exp>;
};


export type Subscription_RootEntity_StatusArgs = {
  distinct_on?: InputMaybe<Array<Entity_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Status_Order_By>>;
  where?: InputMaybe<Entity_Status_Bool_Exp>;
};


export type Subscription_RootEntity_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Entity_Status_Order_By>>;
  where?: InputMaybe<Entity_Status_Bool_Exp>;
};


export type Subscription_RootEntity_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootEntity_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Entity_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_Status_Bool_Exp>;
};


export type Subscription_RootFarmsArgs = {
  distinct_on?: InputMaybe<Array<Farms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farms_Order_By>>;
  where?: InputMaybe<Farms_Bool_Exp>;
};


export type Subscription_RootFarms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Farms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Farms_Order_By>>;
  where?: InputMaybe<Farms_Bool_Exp>;
};


export type Subscription_RootFarms_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFarms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Farms_Stream_Cursor_Input>>;
  where?: InputMaybe<Farms_Bool_Exp>;
};


export type Subscription_RootField_Season_ShotArgs = {
  distinct_on?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Season_Shot_Order_By>>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};


export type Subscription_RootField_Season_Shot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Field_Season_Shot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Field_Season_Shot_Order_By>>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};


export type Subscription_RootField_Season_Shot_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootField_Season_Shot_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Field_Season_Shot_Stream_Cursor_Input>>;
  where?: InputMaybe<Field_Season_Shot_Bool_Exp>;
};


export type Subscription_RootFieldsArgs = {
  distinct_on?: InputMaybe<Array<Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fields_Order_By>>;
  where?: InputMaybe<Fields_Bool_Exp>;
};


export type Subscription_RootFields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fields_Order_By>>;
  where?: InputMaybe<Fields_Bool_Exp>;
};


export type Subscription_RootFields_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootFields_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Fields_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Map_AnnotationsArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Annotations_Order_By>>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Map_Annotations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Annotations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Annotations_Order_By>>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Map_Annotations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootHigh_Res_Map_Annotations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<High_Res_Map_Annotations_Stream_Cursor_Input>>;
  where?: InputMaybe<High_Res_Map_Annotations_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Map_LayersArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Layers_Order_By>>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Map_Layers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Map_Layers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Map_Layers_Order_By>>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Map_Layers_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootHigh_Res_Map_Layers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<High_Res_Map_Layers_Stream_Cursor_Input>>;
  where?: InputMaybe<High_Res_Map_Layers_Bool_Exp>;
};


export type Subscription_RootHigh_Res_MapsArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Maps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Maps_Order_By>>;
  where?: InputMaybe<High_Res_Maps_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Maps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<High_Res_Maps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<High_Res_Maps_Order_By>>;
  where?: InputMaybe<High_Res_Maps_Bool_Exp>;
};


export type Subscription_RootHigh_Res_Maps_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootHigh_Res_Maps_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<High_Res_Maps_Stream_Cursor_Input>>;
  where?: InputMaybe<High_Res_Maps_Bool_Exp>;
};


export type Subscription_RootImplementsArgs = {
  distinct_on?: InputMaybe<Array<Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Implements_Order_By>>;
  where?: InputMaybe<Implements_Bool_Exp>;
};


export type Subscription_RootImplements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Implements_Order_By>>;
  where?: InputMaybe<Implements_Bool_Exp>;
};


export type Subscription_RootImplements_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootImplements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Implements_Stream_Cursor_Input>>;
  where?: InputMaybe<Implements_Bool_Exp>;
};


export type Subscription_RootInventoryArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Subscription_RootInventory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Inventory_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Inventory_Order_By>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Subscription_RootInventory_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootInventory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Inventory_Stream_Cursor_Input>>;
  where?: InputMaybe<Inventory_Bool_Exp>;
};


export type Subscription_RootJob_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Job_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Extras_Order_By>>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};


export type Subscription_RootJob_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Extras_Order_By>>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};


export type Subscription_RootJob_Extras_By_PkArgs = {
  jobId: Scalars['bigint'];
  name: Scalars['String'];
};


export type Subscription_RootJob_Extras_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Extras_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Extras_Bool_Exp>;
};


export type Subscription_RootJob_FieldsArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


export type Subscription_RootJob_Fields_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Fields_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Fields_Order_By>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


export type Subscription_RootJob_Fields_By_PkArgs = {
  jobId: Scalars['bigint'];
  seasonShotId: Scalars['bigint'];
};


export type Subscription_RootJob_Fields_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Fields_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Fields_Bool_Exp>;
};


export type Subscription_RootJob_LocationsArgs = {
  distinct_on?: InputMaybe<Array<Job_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Locations_Order_By>>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};


export type Subscription_RootJob_Locations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Locations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Locations_Order_By>>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};


export type Subscription_RootJob_Locations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootJob_Locations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Locations_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Locations_Bool_Exp>;
};


export type Subscription_RootJob_Operator_ImplementsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


export type Subscription_RootJob_Operator_Implements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Implements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Implements_Order_By>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


export type Subscription_RootJob_Operator_Implements_By_PkArgs = {
  implementId: Scalars['uuid'];
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};


export type Subscription_RootJob_Operator_Implements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Operator_Implements_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Operator_Implements_Bool_Exp>;
};


export type Subscription_RootJob_Operator_VehiclesArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


export type Subscription_RootJob_Operator_Vehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


export type Subscription_RootJob_Operator_Vehicles_By_PkArgs = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
  vehicleId: Scalars['uuid'];
};


export type Subscription_RootJob_Operator_Vehicles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Operator_Vehicles_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


export type Subscription_RootJob_OperatorsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operators_Order_By>>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};


export type Subscription_RootJob_Operators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operators_Order_By>>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};


export type Subscription_RootJob_Operators_By_PkArgs = {
  jobId: Scalars['bigint'];
  userId: Scalars['Int'];
};


export type Subscription_RootJob_Operators_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Operators_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Operators_Bool_Exp>;
};


export type Subscription_RootJob_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


export type Subscription_RootJob_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Products_Order_By>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


export type Subscription_RootJob_Products_By_PkArgs = {
  jobId: Scalars['bigint'];
  productId: Scalars['uuid'];
};


export type Subscription_RootJob_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Products_Bool_Exp>;
};


export type Subscription_RootJob_StatusArgs = {
  distinct_on?: InputMaybe<Array<Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Status_Order_By>>;
  where?: InputMaybe<Job_Status_Bool_Exp>;
};


export type Subscription_RootJob_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Status_Order_By>>;
  where?: InputMaybe<Job_Status_Bool_Exp>;
};


export type Subscription_RootJob_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootJob_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Status_Bool_Exp>;
};


export type Subscription_RootJobsArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Jobs_Order_By>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootJobs_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootJobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Jobs_Bool_Exp>;
};


export type Subscription_RootOperation_ExtrasArgs = {
  distinct_on?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Extras_Order_By>>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};


export type Subscription_RootOperation_Extras_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Extras_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Extras_Order_By>>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};


export type Subscription_RootOperation_Extras_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOperation_Extras_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operation_Extras_Stream_Cursor_Input>>;
  where?: InputMaybe<Operation_Extras_Bool_Exp>;
};


export type Subscription_RootOperation_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Operation_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Products_Order_By>>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};


export type Subscription_RootOperation_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operation_Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operation_Products_Order_By>>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};


export type Subscription_RootOperation_Products_By_PkArgs = {
  operationId: Scalars['bigint'];
  productId: Scalars['uuid'];
};


export type Subscription_RootOperation_Products_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operation_Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Operation_Products_Bool_Exp>;
};


export type Subscription_RootOperationsArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Subscription_RootOperations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Operations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Operations_Order_By>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Subscription_RootOperations_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootOperations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Operations_Stream_Cursor_Input>>;
  where?: InputMaybe<Operations_Bool_Exp>;
};


export type Subscription_RootOtpsArgs = {
  distinct_on?: InputMaybe<Array<Otps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otps_Order_By>>;
  where?: InputMaybe<Otps_Bool_Exp>;
};


export type Subscription_RootOtps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Otps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otps_Order_By>>;
  where?: InputMaybe<Otps_Bool_Exp>;
};


export type Subscription_RootOtps_By_PkArgs = {
  otp: Scalars['String'];
  user_id: Scalars['Int'];
};


export type Subscription_RootOtps_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Otps_Stream_Cursor_Input>>;
  where?: InputMaybe<Otps_Bool_Exp>;
};


export type Subscription_RootOwnership_TypesArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownership_Types_Order_By>>;
  where?: InputMaybe<Ownership_Types_Bool_Exp>;
};


export type Subscription_RootOwnership_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ownership_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ownership_Types_Order_By>>;
  where?: InputMaybe<Ownership_Types_Bool_Exp>;
};


export type Subscription_RootOwnership_Types_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootOwnership_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ownership_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Ownership_Types_Bool_Exp>;
};


export type Subscription_RootPolygonsArgs = {
  distinct_on?: InputMaybe<Array<Polygons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polygons_Order_By>>;
  where?: InputMaybe<Polygons_Bool_Exp>;
};


export type Subscription_RootPolygons_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Polygons_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Polygons_Order_By>>;
  where?: InputMaybe<Polygons_Bool_Exp>;
};


export type Subscription_RootPolygons_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootPolygons_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Polygons_Stream_Cursor_Input>>;
  where?: InputMaybe<Polygons_Bool_Exp>;
};


export type Subscription_RootProductsArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Products_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Products_Order_By>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootProducts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProducts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Products_Stream_Cursor_Input>>;
  where?: InputMaybe<Products_Bool_Exp>;
};


export type Subscription_RootReportsArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Subscription_RootReports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reports_Order_By>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Subscription_RootReports_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootReports_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Reports_Bool_Exp>;
};


export type Subscription_RootRolesArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Roles_Order_By>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootRoles_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootRoles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<Roles_Bool_Exp>;
};


export type Subscription_RootTeam_MembersArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


export type Subscription_RootTeam_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


export type Subscription_RootTeam_Members_By_PkArgs = {
  ownerId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type Subscription_RootTeam_Members_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Team_Members_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


export type Subscription_RootUser_InvitesArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Subscription_RootUser_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Invites_Order_By>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Subscription_RootUser_Invites_By_PkArgs = {
  invite_id: Scalars['String'];
};


export type Subscription_RootUser_Invites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Invites_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};


export type Subscription_RootUser_PrefsArgs = {
  distinct_on?: InputMaybe<Array<User_Prefs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Prefs_Order_By>>;
  where?: InputMaybe<User_Prefs_Bool_Exp>;
};


export type Subscription_RootUser_Prefs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Prefs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Prefs_Order_By>>;
  where?: InputMaybe<User_Prefs_Bool_Exp>;
};


export type Subscription_RootUser_Prefs_By_PkArgs = {
  userId: Scalars['Int'];
};


export type Subscription_RootUser_Prefs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Prefs_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Prefs_Bool_Exp>;
};


export type Subscription_RootUser_ProfilesArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Profiles_Order_By>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_Profiles_By_PkArgs = {
  userId: Scalars['Int'];
};


export type Subscription_RootUser_Profiles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Profiles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};


export type Subscription_RootUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Roles_By_PkArgs = {
  role: Roles_Enum;
  user_id: Scalars['Int'];
};


export type Subscription_RootUser_Roles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_Tax_RatesArgs = {
  distinct_on?: InputMaybe<Array<User_Tax_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Tax_Rates_Order_By>>;
  where?: InputMaybe<User_Tax_Rates_Bool_Exp>;
};


export type Subscription_RootUser_Tax_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Tax_Rates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Tax_Rates_Order_By>>;
  where?: InputMaybe<User_Tax_Rates_Bool_Exp>;
};


export type Subscription_RootUser_Tax_Rates_By_PkArgs = {
  label: Scalars['String'];
  userId: Scalars['Int'];
};


export type Subscription_RootUser_Tax_Rates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Tax_Rates_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Tax_Rates_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootVehiclesArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootVehicles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vehicles_Order_By>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootVehicles_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVehicles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vehicles_Stream_Cursor_Input>>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};


export type Subscription_RootWarehousesArgs = {
  distinct_on?: InputMaybe<Array<Warehouses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Warehouses_Order_By>>;
  where?: InputMaybe<Warehouses_Bool_Exp>;
};


export type Subscription_RootWarehouses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Warehouses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Warehouses_Order_By>>;
  where?: InputMaybe<Warehouses_Bool_Exp>;
};


export type Subscription_RootWarehouses_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootWarehouses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Warehouses_Stream_Cursor_Input>>;
  where?: InputMaybe<Warehouses_Bool_Exp>;
};

/** columns and relationships of "team_members" */
export type Team_Members = {
  __typename?: 'team_members';
  ownerId: Scalars['Int'];
  /** An object relationship */
  teamMember: Users;
  userId: Scalars['Int'];
};

/** aggregated selection of "team_members" */
export type Team_Members_Aggregate = {
  __typename?: 'team_members_aggregate';
  aggregate?: Maybe<Team_Members_Aggregate_Fields>;
  nodes: Array<Team_Members>;
};

export type Team_Members_Aggregate_Bool_Exp = {
  count?: InputMaybe<Team_Members_Aggregate_Bool_Exp_Count>;
};

export type Team_Members_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Team_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Team_Members_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "team_members" */
export type Team_Members_Aggregate_Fields = {
  __typename?: 'team_members_aggregate_fields';
  avg?: Maybe<Team_Members_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Team_Members_Max_Fields>;
  min?: Maybe<Team_Members_Min_Fields>;
  stddev?: Maybe<Team_Members_Stddev_Fields>;
  stddev_pop?: Maybe<Team_Members_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Team_Members_Stddev_Samp_Fields>;
  sum?: Maybe<Team_Members_Sum_Fields>;
  var_pop?: Maybe<Team_Members_Var_Pop_Fields>;
  var_samp?: Maybe<Team_Members_Var_Samp_Fields>;
  variance?: Maybe<Team_Members_Variance_Fields>;
};


/** aggregate fields of "team_members" */
export type Team_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Team_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team_members" */
export type Team_Members_Aggregate_Order_By = {
  avg?: InputMaybe<Team_Members_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Team_Members_Max_Order_By>;
  min?: InputMaybe<Team_Members_Min_Order_By>;
  stddev?: InputMaybe<Team_Members_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Team_Members_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Team_Members_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Team_Members_Sum_Order_By>;
  var_pop?: InputMaybe<Team_Members_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Team_Members_Var_Samp_Order_By>;
  variance?: InputMaybe<Team_Members_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "team_members" */
export type Team_Members_Arr_Rel_Insert_Input = {
  data: Array<Team_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Members_On_Conflict>;
};

/** aggregate avg on columns */
export type Team_Members_Avg_Fields = {
  __typename?: 'team_members_avg_fields';
  ownerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "team_members" */
export type Team_Members_Avg_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "team_members". All fields are combined with a logical 'AND'. */
export type Team_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Members_Bool_Exp>>;
  _not?: InputMaybe<Team_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Members_Bool_Exp>>;
  ownerId?: InputMaybe<Int_Comparison_Exp>;
  teamMember?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_members" */
export enum Team_Members_Constraint {
  /** unique or primary key constraint on columns "owner_id", "user_id" */
  TeamMembersPkey = 'team_members_pkey'
}

/** input type for incrementing numeric columns in table "team_members" */
export type Team_Members_Inc_Input = {
  ownerId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "team_members" */
export type Team_Members_Insert_Input = {
  ownerId?: InputMaybe<Scalars['Int']>;
  teamMember?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Team_Members_Max_Fields = {
  __typename?: 'team_members_max_fields';
  ownerId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "team_members" */
export type Team_Members_Max_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Members_Min_Fields = {
  __typename?: 'team_members_min_fields';
  ownerId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "team_members" */
export type Team_Members_Min_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "team_members" */
export type Team_Members_Mutation_Response = {
  __typename?: 'team_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Members>;
};

/** on_conflict condition type for table "team_members" */
export type Team_Members_On_Conflict = {
  constraint: Team_Members_Constraint;
  update_columns?: Array<Team_Members_Update_Column>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "team_members". */
export type Team_Members_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  teamMember?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: team_members */
export type Team_Members_Pk_Columns_Input = {
  ownerId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** select columns of table "team_members" */
export enum Team_Members_Select_Column {
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "team_members" */
export type Team_Members_Set_Input = {
  ownerId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Team_Members_Stddev_Fields = {
  __typename?: 'team_members_stddev_fields';
  ownerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "team_members" */
export type Team_Members_Stddev_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Team_Members_Stddev_Pop_Fields = {
  __typename?: 'team_members_stddev_pop_fields';
  ownerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "team_members" */
export type Team_Members_Stddev_Pop_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Team_Members_Stddev_Samp_Fields = {
  __typename?: 'team_members_stddev_samp_fields';
  ownerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "team_members" */
export type Team_Members_Stddev_Samp_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "team_members" */
export type Team_Members_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Members_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Members_Stream_Cursor_Value_Input = {
  ownerId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Team_Members_Sum_Fields = {
  __typename?: 'team_members_sum_fields';
  ownerId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "team_members" */
export type Team_Members_Sum_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "team_members" */
export enum Team_Members_Update_Column {
  /** column name */
  OwnerId = 'ownerId',
  /** column name */
  UserId = 'userId'
}

export type Team_Members_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Team_Members_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Team_Members_Set_Input>;
  /** filter the rows which have to be updated */
  where: Team_Members_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Team_Members_Var_Pop_Fields = {
  __typename?: 'team_members_var_pop_fields';
  ownerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "team_members" */
export type Team_Members_Var_Pop_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Team_Members_Var_Samp_Fields = {
  __typename?: 'team_members_var_samp_fields';
  ownerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "team_members" */
export type Team_Members_Var_Samp_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Team_Members_Variance_Fields = {
  __typename?: 'team_members_variance_fields';
  ownerId?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "team_members" */
export type Team_Members_Variance_Order_By = {
  ownerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user_invites" */
export type User_Invites = {
  __typename?: 'user_invites';
  invite_id: Scalars['String'];
  invitee_email: Scalars['String'];
  invitee_role: Roles_Enum;
  user_id: Scalars['Int'];
};

/** aggregated selection of "user_invites" */
export type User_Invites_Aggregate = {
  __typename?: 'user_invites_aggregate';
  aggregate?: Maybe<User_Invites_Aggregate_Fields>;
  nodes: Array<User_Invites>;
};

/** aggregate fields of "user_invites" */
export type User_Invites_Aggregate_Fields = {
  __typename?: 'user_invites_aggregate_fields';
  avg?: Maybe<User_Invites_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Invites_Max_Fields>;
  min?: Maybe<User_Invites_Min_Fields>;
  stddev?: Maybe<User_Invites_Stddev_Fields>;
  stddev_pop?: Maybe<User_Invites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Invites_Stddev_Samp_Fields>;
  sum?: Maybe<User_Invites_Sum_Fields>;
  var_pop?: Maybe<User_Invites_Var_Pop_Fields>;
  var_samp?: Maybe<User_Invites_Var_Samp_Fields>;
  variance?: Maybe<User_Invites_Variance_Fields>;
};


/** aggregate fields of "user_invites" */
export type User_Invites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Invites_Avg_Fields = {
  __typename?: 'user_invites_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_invites". All fields are combined with a logical 'AND'. */
export type User_Invites_Bool_Exp = {
  _and?: InputMaybe<Array<User_Invites_Bool_Exp>>;
  _not?: InputMaybe<User_Invites_Bool_Exp>;
  _or?: InputMaybe<Array<User_Invites_Bool_Exp>>;
  invite_id?: InputMaybe<String_Comparison_Exp>;
  invitee_email?: InputMaybe<String_Comparison_Exp>;
  invitee_role?: InputMaybe<Roles_Enum_Comparison_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_invites" */
export enum User_Invites_Constraint {
  /** unique or primary key constraint on columns "invite_id" */
  UserInvitesPkey = 'user_invites_pkey',
  /** unique or primary key constraint on columns "user_id", "invitee_email" */
  UserInvitesUserIdInviteeEmailKey = 'user_invites_user_id_invitee_email_key'
}

/** input type for incrementing numeric columns in table "user_invites" */
export type User_Invites_Inc_Input = {
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_invites" */
export type User_Invites_Insert_Input = {
  invite_id?: InputMaybe<Scalars['String']>;
  invitee_email?: InputMaybe<Scalars['String']>;
  invitee_role?: InputMaybe<Roles_Enum>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Invites_Max_Fields = {
  __typename?: 'user_invites_max_fields';
  invite_id?: Maybe<Scalars['String']>;
  invitee_email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Invites_Min_Fields = {
  __typename?: 'user_invites_min_fields';
  invite_id?: Maybe<Scalars['String']>;
  invitee_email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_invites" */
export type User_Invites_Mutation_Response = {
  __typename?: 'user_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Invites>;
};

/** on_conflict condition type for table "user_invites" */
export type User_Invites_On_Conflict = {
  constraint: User_Invites_Constraint;
  update_columns?: Array<User_Invites_Update_Column>;
  where?: InputMaybe<User_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "user_invites". */
export type User_Invites_Order_By = {
  invite_id?: InputMaybe<Order_By>;
  invitee_email?: InputMaybe<Order_By>;
  invitee_role?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_invites */
export type User_Invites_Pk_Columns_Input = {
  invite_id: Scalars['String'];
};

/** select columns of table "user_invites" */
export enum User_Invites_Select_Column {
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  InviteeEmail = 'invitee_email',
  /** column name */
  InviteeRole = 'invitee_role',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_invites" */
export type User_Invites_Set_Input = {
  invite_id?: InputMaybe<Scalars['String']>;
  invitee_email?: InputMaybe<Scalars['String']>;
  invitee_role?: InputMaybe<Roles_Enum>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Invites_Stddev_Fields = {
  __typename?: 'user_invites_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Invites_Stddev_Pop_Fields = {
  __typename?: 'user_invites_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Invites_Stddev_Samp_Fields = {
  __typename?: 'user_invites_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_invites" */
export type User_Invites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Invites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Invites_Stream_Cursor_Value_Input = {
  invite_id?: InputMaybe<Scalars['String']>;
  invitee_email?: InputMaybe<Scalars['String']>;
  invitee_role?: InputMaybe<Roles_Enum>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Invites_Sum_Fields = {
  __typename?: 'user_invites_sum_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_invites" */
export enum User_Invites_Update_Column {
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  InviteeEmail = 'invitee_email',
  /** column name */
  InviteeRole = 'invitee_role',
  /** column name */
  UserId = 'user_id'
}

export type User_Invites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Invites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Invites_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Invites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Invites_Var_Pop_Fields = {
  __typename?: 'user_invites_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Invites_Var_Samp_Fields = {
  __typename?: 'user_invites_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Invites_Variance_Fields = {
  __typename?: 'user_invites_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** Stores user default preferences */
export type User_Prefs = {
  __typename?: 'user_prefs';
  currency?: Maybe<Scalars['String']>;
  fieldColor?: Maybe<Scalars['String']>;
  fieldUnit?: Maybe<Scalars['String']>;
  /** geo point where map spans to by default */
  geoLocation?: Maybe<Scalars['point']>;
  /** payment instructions added to invoice pdf */
  invoicePayInfo?: Maybe<Scalars['String']>;
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['Int'];
};

/** aggregated selection of "user_prefs" */
export type User_Prefs_Aggregate = {
  __typename?: 'user_prefs_aggregate';
  aggregate?: Maybe<User_Prefs_Aggregate_Fields>;
  nodes: Array<User_Prefs>;
};

/** aggregate fields of "user_prefs" */
export type User_Prefs_Aggregate_Fields = {
  __typename?: 'user_prefs_aggregate_fields';
  avg?: Maybe<User_Prefs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Prefs_Max_Fields>;
  min?: Maybe<User_Prefs_Min_Fields>;
  stddev?: Maybe<User_Prefs_Stddev_Fields>;
  stddev_pop?: Maybe<User_Prefs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Prefs_Stddev_Samp_Fields>;
  sum?: Maybe<User_Prefs_Sum_Fields>;
  var_pop?: Maybe<User_Prefs_Var_Pop_Fields>;
  var_samp?: Maybe<User_Prefs_Var_Samp_Fields>;
  variance?: Maybe<User_Prefs_Variance_Fields>;
};


/** aggregate fields of "user_prefs" */
export type User_Prefs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Prefs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Prefs_Avg_Fields = {
  __typename?: 'user_prefs_avg_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_prefs". All fields are combined with a logical 'AND'. */
export type User_Prefs_Bool_Exp = {
  _and?: InputMaybe<Array<User_Prefs_Bool_Exp>>;
  _not?: InputMaybe<User_Prefs_Bool_Exp>;
  _or?: InputMaybe<Array<User_Prefs_Bool_Exp>>;
  currency?: InputMaybe<String_Comparison_Exp>;
  fieldColor?: InputMaybe<String_Comparison_Exp>;
  fieldUnit?: InputMaybe<String_Comparison_Exp>;
  geoLocation?: InputMaybe<Point_Comparison_Exp>;
  invoicePayInfo?: InputMaybe<String_Comparison_Exp>;
  invoiceTerms?: InputMaybe<Int_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_prefs" */
export enum User_Prefs_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UserPrefsPkey = 'user_prefs_pkey'
}

/** input type for incrementing numeric columns in table "user_prefs" */
export type User_Prefs_Inc_Input = {
  /** number of days before next invoice */
  invoiceTerms?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_prefs" */
export type User_Prefs_Insert_Input = {
  currency?: InputMaybe<Scalars['String']>;
  fieldColor?: InputMaybe<Scalars['String']>;
  fieldUnit?: InputMaybe<Scalars['String']>;
  /** geo point where map spans to by default */
  geoLocation?: InputMaybe<Scalars['point']>;
  /** payment instructions added to invoice pdf */
  invoicePayInfo?: InputMaybe<Scalars['String']>;
  /** number of days before next invoice */
  invoiceTerms?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Prefs_Max_Fields = {
  __typename?: 'user_prefs_max_fields';
  currency?: Maybe<Scalars['String']>;
  fieldColor?: Maybe<Scalars['String']>;
  fieldUnit?: Maybe<Scalars['String']>;
  /** payment instructions added to invoice pdf */
  invoicePayInfo?: Maybe<Scalars['String']>;
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Prefs_Min_Fields = {
  __typename?: 'user_prefs_min_fields';
  currency?: Maybe<Scalars['String']>;
  fieldColor?: Maybe<Scalars['String']>;
  fieldUnit?: Maybe<Scalars['String']>;
  /** payment instructions added to invoice pdf */
  invoicePayInfo?: Maybe<Scalars['String']>;
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_prefs" */
export type User_Prefs_Mutation_Response = {
  __typename?: 'user_prefs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Prefs>;
};

/** input type for inserting object relation for remote table "user_prefs" */
export type User_Prefs_Obj_Rel_Insert_Input = {
  data: User_Prefs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Prefs_On_Conflict>;
};

/** on_conflict condition type for table "user_prefs" */
export type User_Prefs_On_Conflict = {
  constraint: User_Prefs_Constraint;
  update_columns?: Array<User_Prefs_Update_Column>;
  where?: InputMaybe<User_Prefs_Bool_Exp>;
};

/** Ordering options when selecting data from "user_prefs". */
export type User_Prefs_Order_By = {
  currency?: InputMaybe<Order_By>;
  fieldColor?: InputMaybe<Order_By>;
  fieldUnit?: InputMaybe<Order_By>;
  geoLocation?: InputMaybe<Order_By>;
  invoicePayInfo?: InputMaybe<Order_By>;
  invoiceTerms?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_prefs */
export type User_Prefs_Pk_Columns_Input = {
  userId: Scalars['Int'];
};

/** select columns of table "user_prefs" */
export enum User_Prefs_Select_Column {
  /** column name */
  Currency = 'currency',
  /** column name */
  FieldColor = 'fieldColor',
  /** column name */
  FieldUnit = 'fieldUnit',
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  InvoicePayInfo = 'invoicePayInfo',
  /** column name */
  InvoiceTerms = 'invoiceTerms',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_prefs" */
export type User_Prefs_Set_Input = {
  currency?: InputMaybe<Scalars['String']>;
  fieldColor?: InputMaybe<Scalars['String']>;
  fieldUnit?: InputMaybe<Scalars['String']>;
  /** geo point where map spans to by default */
  geoLocation?: InputMaybe<Scalars['point']>;
  /** payment instructions added to invoice pdf */
  invoicePayInfo?: InputMaybe<Scalars['String']>;
  /** number of days before next invoice */
  invoiceTerms?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Prefs_Stddev_Fields = {
  __typename?: 'user_prefs_stddev_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Prefs_Stddev_Pop_Fields = {
  __typename?: 'user_prefs_stddev_pop_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Prefs_Stddev_Samp_Fields = {
  __typename?: 'user_prefs_stddev_samp_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_prefs" */
export type User_Prefs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Prefs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Prefs_Stream_Cursor_Value_Input = {
  currency?: InputMaybe<Scalars['String']>;
  fieldColor?: InputMaybe<Scalars['String']>;
  fieldUnit?: InputMaybe<Scalars['String']>;
  /** geo point where map spans to by default */
  geoLocation?: InputMaybe<Scalars['point']>;
  /** payment instructions added to invoice pdf */
  invoicePayInfo?: InputMaybe<Scalars['String']>;
  /** number of days before next invoice */
  invoiceTerms?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Prefs_Sum_Fields = {
  __typename?: 'user_prefs_sum_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_prefs" */
export enum User_Prefs_Update_Column {
  /** column name */
  Currency = 'currency',
  /** column name */
  FieldColor = 'fieldColor',
  /** column name */
  FieldUnit = 'fieldUnit',
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  InvoicePayInfo = 'invoicePayInfo',
  /** column name */
  InvoiceTerms = 'invoiceTerms',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UserId = 'userId'
}

export type User_Prefs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Prefs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Prefs_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Prefs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Prefs_Var_Pop_Fields = {
  __typename?: 'user_prefs_var_pop_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Prefs_Var_Samp_Fields = {
  __typename?: 'user_prefs_var_samp_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Prefs_Variance_Fields = {
  __typename?: 'user_prefs_variance_fields';
  /** number of days before next invoice */
  invoiceTerms?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Stores additional information about users */
export type User_Profiles = {
  __typename?: 'user_profiles';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['Int'];
};

/** aggregated selection of "user_profiles" */
export type User_Profiles_Aggregate = {
  __typename?: 'user_profiles_aggregate';
  aggregate?: Maybe<User_Profiles_Aggregate_Fields>;
  nodes: Array<User_Profiles>;
};

/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_Fields = {
  __typename?: 'user_profiles_aggregate_fields';
  avg?: Maybe<User_Profiles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Profiles_Max_Fields>;
  min?: Maybe<User_Profiles_Min_Fields>;
  stddev?: Maybe<User_Profiles_Stddev_Fields>;
  stddev_pop?: Maybe<User_Profiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Profiles_Stddev_Samp_Fields>;
  sum?: Maybe<User_Profiles_Sum_Fields>;
  var_pop?: Maybe<User_Profiles_Var_Pop_Fields>;
  var_samp?: Maybe<User_Profiles_Var_Samp_Fields>;
  variance?: Maybe<User_Profiles_Variance_Fields>;
};


/** aggregate fields of "user_profiles" */
export type User_Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Profiles_Avg_Fields = {
  __typename?: 'user_profiles_avg_fields';
  userId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_profiles". All fields are combined with a logical 'AND'. */
export type User_Profiles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  _not?: InputMaybe<User_Profiles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profiles_Bool_Exp>>;
  address1?: InputMaybe<String_Comparison_Exp>;
  address2?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  companyName?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  taxNumber?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profiles" */
export enum User_Profiles_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UserProfilesPkey = 'user_profiles_pkey'
}

/** input type for incrementing numeric columns in table "user_profiles" */
export type User_Profiles_Inc_Input = {
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_profiles" */
export type User_Profiles_Insert_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxNumber?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Profiles_Max_Fields = {
  __typename?: 'user_profiles_max_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Profiles_Min_Fields = {
  __typename?: 'user_profiles_min_fields';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  taxNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_profiles" */
export type User_Profiles_Mutation_Response = {
  __typename?: 'user_profiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profiles>;
};

/** input type for inserting object relation for remote table "user_profiles" */
export type User_Profiles_Obj_Rel_Insert_Input = {
  data: User_Profiles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profiles_On_Conflict>;
};

/** on_conflict condition type for table "user_profiles" */
export type User_Profiles_On_Conflict = {
  constraint: User_Profiles_Constraint;
  update_columns?: Array<User_Profiles_Update_Column>;
  where?: InputMaybe<User_Profiles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profiles". */
export type User_Profiles_Order_By = {
  address1?: InputMaybe<Order_By>;
  address2?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  companyName?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  taxNumber?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profiles */
export type User_Profiles_Pk_Columns_Input = {
  userId: Scalars['Int'];
};

/** select columns of table "user_profiles" */
export enum User_Profiles_Select_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Country = 'country',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  State = 'state',
  /** column name */
  TaxNumber = 'taxNumber',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_profiles" */
export type User_Profiles_Set_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxNumber?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Profiles_Stddev_Fields = {
  __typename?: 'user_profiles_stddev_fields';
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Profiles_Stddev_Pop_Fields = {
  __typename?: 'user_profiles_stddev_pop_fields';
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Profiles_Stddev_Samp_Fields = {
  __typename?: 'user_profiles_stddev_samp_fields';
  userId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_profiles" */
export type User_Profiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profiles_Stream_Cursor_Value_Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxNumber?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Profiles_Sum_Fields = {
  __typename?: 'user_profiles_sum_fields';
  userId?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_profiles" */
export enum User_Profiles_Update_Column {
  /** column name */
  Address1 = 'address1',
  /** column name */
  Address2 = 'address2',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'companyName',
  /** column name */
  Country = 'country',
  /** column name */
  Phone = 'phone',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  State = 'state',
  /** column name */
  TaxNumber = 'taxNumber',
  /** column name */
  UserId = 'userId'
}

export type User_Profiles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Profiles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profiles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Profiles_Var_Pop_Fields = {
  __typename?: 'user_profiles_var_pop_fields';
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Profiles_Var_Samp_Fields = {
  __typename?: 'user_profiles_var_samp_fields';
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Profiles_Variance_Fields = {
  __typename?: 'user_profiles_variance_fields';
  userId?: Maybe<Scalars['Float']>;
};

/** Roles for each user – many-to-many */
export type User_Roles = {
  __typename?: 'user_roles';
  role: Roles_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int'];
};

/** aggregated selection of "user_roles" */
export type User_Roles_Aggregate = {
  __typename?: 'user_roles_aggregate';
  aggregate?: Maybe<User_Roles_Aggregate_Fields>;
  nodes: Array<User_Roles>;
};

export type User_Roles_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Roles_Aggregate_Bool_Exp_Count>;
};

export type User_Roles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Roles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_Fields = {
  __typename?: 'user_roles_aggregate_fields';
  avg?: Maybe<User_Roles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Roles_Max_Fields>;
  min?: Maybe<User_Roles_Min_Fields>;
  stddev?: Maybe<User_Roles_Stddev_Fields>;
  stddev_pop?: Maybe<User_Roles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Roles_Stddev_Samp_Fields>;
  sum?: Maybe<User_Roles_Sum_Fields>;
  var_pop?: Maybe<User_Roles_Var_Pop_Fields>;
  var_samp?: Maybe<User_Roles_Var_Samp_Fields>;
  variance?: Maybe<User_Roles_Variance_Fields>;
};


/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_roles" */
export type User_Roles_Aggregate_Order_By = {
  avg?: InputMaybe<User_Roles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Roles_Max_Order_By>;
  min?: InputMaybe<User_Roles_Min_Order_By>;
  stddev?: InputMaybe<User_Roles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Roles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Roles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Roles_Sum_Order_By>;
  var_pop?: InputMaybe<User_Roles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Roles_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Roles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_roles" */
export type User_Roles_Arr_Rel_Insert_Input = {
  data: Array<User_Roles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Roles_Avg_Fields = {
  __typename?: 'user_roles_avg_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_roles" */
export type User_Roles_Avg_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type User_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  _not?: InputMaybe<User_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  role?: InputMaybe<Roles_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum User_Roles_Constraint {
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesPkey = 'user_roles_pkey'
}

/** input type for incrementing numeric columns in table "user_roles" */
export type User_Roles_Inc_Input = {
  user_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_roles" */
export type User_Roles_Insert_Input = {
  role?: InputMaybe<Roles_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Roles_Max_Fields = {
  __typename?: 'user_roles_max_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "user_roles" */
export type User_Roles_Max_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Roles_Min_Fields = {
  __typename?: 'user_roles_min_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "user_roles" */
export type User_Roles_Min_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_roles" */
export type User_Roles_Mutation_Response = {
  __typename?: 'user_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Roles>;
};

/** on_conflict condition type for table "user_roles" */
export type User_Roles_On_Conflict = {
  constraint: User_Roles_Constraint;
  update_columns?: Array<User_Roles_Update_Column>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_roles". */
export type User_Roles_Order_By = {
  role?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_roles */
export type User_Roles_Pk_Columns_Input = {
  role: Roles_Enum;
  user_id: Scalars['Int'];
};

/** select columns of table "user_roles" */
export enum User_Roles_Select_Column {
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_roles" */
export type User_Roles_Set_Input = {
  role?: InputMaybe<Roles_Enum>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Roles_Stddev_Fields = {
  __typename?: 'user_roles_stddev_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_roles" */
export type User_Roles_Stddev_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Roles_Stddev_Pop_Fields = {
  __typename?: 'user_roles_stddev_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_roles" */
export type User_Roles_Stddev_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Roles_Stddev_Samp_Fields = {
  __typename?: 'user_roles_stddev_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_roles" */
export type User_Roles_Stddev_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_roles" */
export type User_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Roles_Stream_Cursor_Value_Input = {
  role?: InputMaybe<Roles_Enum>;
  user_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Roles_Sum_Fields = {
  __typename?: 'user_roles_sum_fields';
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_roles" */
export type User_Roles_Sum_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "user_roles" */
export enum User_Roles_Update_Column {
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

export type User_Roles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Roles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Roles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Roles_Var_Pop_Fields = {
  __typename?: 'user_roles_var_pop_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_roles" */
export type User_Roles_Var_Pop_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Roles_Var_Samp_Fields = {
  __typename?: 'user_roles_var_samp_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_roles" */
export type User_Roles_Var_Samp_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Roles_Variance_Fields = {
  __typename?: 'user_roles_variance_fields';
  user_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_roles" */
export type User_Roles_Variance_Order_By = {
  user_id?: InputMaybe<Order_By>;
};

/** Stores different tax rates for each user */
export type User_Tax_Rates = {
  __typename?: 'user_tax_rates';
  created_at: Scalars['timestamptz'];
  label: Scalars['String'];
  name: Scalars['String'];
  rate: Scalars['float8'];
  updated_at: Scalars['timestamptz'];
  userId: Scalars['Int'];
};

/** aggregated selection of "user_tax_rates" */
export type User_Tax_Rates_Aggregate = {
  __typename?: 'user_tax_rates_aggregate';
  aggregate?: Maybe<User_Tax_Rates_Aggregate_Fields>;
  nodes: Array<User_Tax_Rates>;
};

/** aggregate fields of "user_tax_rates" */
export type User_Tax_Rates_Aggregate_Fields = {
  __typename?: 'user_tax_rates_aggregate_fields';
  avg?: Maybe<User_Tax_Rates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Tax_Rates_Max_Fields>;
  min?: Maybe<User_Tax_Rates_Min_Fields>;
  stddev?: Maybe<User_Tax_Rates_Stddev_Fields>;
  stddev_pop?: Maybe<User_Tax_Rates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Tax_Rates_Stddev_Samp_Fields>;
  sum?: Maybe<User_Tax_Rates_Sum_Fields>;
  var_pop?: Maybe<User_Tax_Rates_Var_Pop_Fields>;
  var_samp?: Maybe<User_Tax_Rates_Var_Samp_Fields>;
  variance?: Maybe<User_Tax_Rates_Variance_Fields>;
};


/** aggregate fields of "user_tax_rates" */
export type User_Tax_Rates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Tax_Rates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Tax_Rates_Avg_Fields = {
  __typename?: 'user_tax_rates_avg_fields';
  rate?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_tax_rates". All fields are combined with a logical 'AND'. */
export type User_Tax_Rates_Bool_Exp = {
  _and?: InputMaybe<Array<User_Tax_Rates_Bool_Exp>>;
  _not?: InputMaybe<User_Tax_Rates_Bool_Exp>;
  _or?: InputMaybe<Array<User_Tax_Rates_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  rate?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_tax_rates" */
export enum User_Tax_Rates_Constraint {
  /** unique or primary key constraint on columns "label", "user_id" */
  UserTaxRatesPkey = 'user_tax_rates_pkey'
}

/** input type for incrementing numeric columns in table "user_tax_rates" */
export type User_Tax_Rates_Inc_Input = {
  rate?: InputMaybe<Scalars['float8']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_tax_rates" */
export type User_Tax_Rates_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Tax_Rates_Max_Fields = {
  __typename?: 'user_tax_rates_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Tax_Rates_Min_Fields = {
  __typename?: 'user_tax_rates_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['float8']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_tax_rates" */
export type User_Tax_Rates_Mutation_Response = {
  __typename?: 'user_tax_rates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Tax_Rates>;
};

/** on_conflict condition type for table "user_tax_rates" */
export type User_Tax_Rates_On_Conflict = {
  constraint: User_Tax_Rates_Constraint;
  update_columns?: Array<User_Tax_Rates_Update_Column>;
  where?: InputMaybe<User_Tax_Rates_Bool_Exp>;
};

/** Ordering options when selecting data from "user_tax_rates". */
export type User_Tax_Rates_Order_By = {
  created_at?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_tax_rates */
export type User_Tax_Rates_Pk_Columns_Input = {
  label: Scalars['String'];
  userId: Scalars['Int'];
};

/** select columns of table "user_tax_rates" */
export enum User_Tax_Rates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  Rate = 'rate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_tax_rates" */
export type User_Tax_Rates_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Tax_Rates_Stddev_Fields = {
  __typename?: 'user_tax_rates_stddev_fields';
  rate?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Tax_Rates_Stddev_Pop_Fields = {
  __typename?: 'user_tax_rates_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Tax_Rates_Stddev_Samp_Fields = {
  __typename?: 'user_tax_rates_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_tax_rates" */
export type User_Tax_Rates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Tax_Rates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Tax_Rates_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['float8']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Tax_Rates_Sum_Fields = {
  __typename?: 'user_tax_rates_sum_fields';
  rate?: Maybe<Scalars['float8']>;
  userId?: Maybe<Scalars['Int']>;
};

/** update columns of table "user_tax_rates" */
export enum User_Tax_Rates_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Label = 'label',
  /** column name */
  Name = 'name',
  /** column name */
  Rate = 'rate',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'userId'
}

export type User_Tax_Rates_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Tax_Rates_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Tax_Rates_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Tax_Rates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Tax_Rates_Var_Pop_Fields = {
  __typename?: 'user_tax_rates_var_pop_fields';
  rate?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Tax_Rates_Var_Samp_Fields = {
  __typename?: 'user_tax_rates_var_samp_fields';
  rate?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Tax_Rates_Variance_Fields = {
  __typename?: 'user_tax_rates_variance_fields';
  rate?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isEmailVerified: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  /** An object relationship */
  prefs?: Maybe<User_Prefs>;
  /** An object relationship */
  profile?: Maybe<User_Profiles>;
  /** An array relationship */
  roles: Array<User_Roles>;
  /** An aggregate relationship */
  roles_aggregate: User_Roles_Aggregate;
  /** An array relationship */
  teamMembers: Array<Team_Members>;
  /** An aggregate relationship */
  teamMembers_aggregate: Team_Members_Aggregate;
  /** An array relationship */
  teams: Array<Team_Members>;
  /** An aggregate relationship */
  teams_aggregate: Team_Members_Aggregate;
  username: Scalars['String'];
};


/** columns and relationships of "users" */
export type UsersRolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeamMembersArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeamMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeamsArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Members_Order_By>>;
  where?: InputMaybe<Team_Members_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isEmailVerified?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  prefs?: InputMaybe<User_Prefs_Bool_Exp>;
  profile?: InputMaybe<User_Profiles_Bool_Exp>;
  roles?: InputMaybe<User_Roles_Bool_Exp>;
  roles_aggregate?: InputMaybe<User_Roles_Aggregate_Bool_Exp>;
  teamMembers?: InputMaybe<Team_Members_Bool_Exp>;
  teamMembers_aggregate?: InputMaybe<Team_Members_Aggregate_Bool_Exp>;
  teams?: InputMaybe<Team_Members_Bool_Exp>;
  teams_aggregate?: InputMaybe<Team_Members_Aggregate_Bool_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey',
  /** unique or primary key constraint on columns "username" */
  UsersUsernameKey = 'users_username_key'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  prefs?: InputMaybe<User_Prefs_Obj_Rel_Insert_Input>;
  profile?: InputMaybe<User_Profiles_Obj_Rel_Insert_Input>;
  roles?: InputMaybe<User_Roles_Arr_Rel_Insert_Input>;
  teamMembers?: InputMaybe<Team_Members_Arr_Rel_Insert_Input>;
  teams?: InputMaybe<Team_Members_Arr_Rel_Insert_Input>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  email?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isEmailVerified?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  prefs?: InputMaybe<User_Prefs_Order_By>;
  profile?: InputMaybe<User_Profiles_Order_By>;
  roles_aggregate?: InputMaybe<User_Roles_Aggregate_Order_By>;
  teamMembers_aggregate?: InputMaybe<Team_Members_Aggregate_Order_By>;
  teams_aggregate?: InputMaybe<Team_Members_Aggregate_Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsEmailVerified = 'isEmailVerified',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Password = 'password',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsEmailVerified = 'isEmailVerified',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Password = 'password',
  /** column name */
  Username = 'username'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vehicles" */
export type Vehicles = {
  __typename?: 'vehicles';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An array relationship */
  jobs: Array<Job_Operator_Vehicles>;
  /** An aggregate relationship */
  jobs_aggregate: Job_Operator_Vehicles_Aggregate;
  length?: Maybe<Scalars['numeric']>;
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ownership: Ownership_Types_Enum;
  registrationNumber: Scalars['String'];
  status: Entity_Status_Enum;
  userId: Scalars['Int'];
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "vehicles" */
export type VehiclesJobsArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};


/** columns and relationships of "vehicles" */
export type VehiclesJobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Operator_Vehicles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Operator_Vehicles_Order_By>>;
  where?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
};

/** aggregated selection of "vehicles" */
export type Vehicles_Aggregate = {
  __typename?: 'vehicles_aggregate';
  aggregate?: Maybe<Vehicles_Aggregate_Fields>;
  nodes: Array<Vehicles>;
};

/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_Fields = {
  __typename?: 'vehicles_aggregate_fields';
  avg?: Maybe<Vehicles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Vehicles_Max_Fields>;
  min?: Maybe<Vehicles_Min_Fields>;
  stddev?: Maybe<Vehicles_Stddev_Fields>;
  stddev_pop?: Maybe<Vehicles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vehicles_Stddev_Samp_Fields>;
  sum?: Maybe<Vehicles_Sum_Fields>;
  var_pop?: Maybe<Vehicles_Var_Pop_Fields>;
  var_samp?: Maybe<Vehicles_Var_Samp_Fields>;
  variance?: Maybe<Vehicles_Variance_Fields>;
};


/** aggregate fields of "vehicles" */
export type Vehicles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vehicles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Vehicles_Avg_Fields = {
  __typename?: 'vehicles_avg_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vehicles". All fields are combined with a logical 'AND'. */
export type Vehicles_Bool_Exp = {
  _and?: InputMaybe<Array<Vehicles_Bool_Exp>>;
  _not?: InputMaybe<Vehicles_Bool_Exp>;
  _or?: InputMaybe<Array<Vehicles_Bool_Exp>>;
  brand?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobs?: InputMaybe<Job_Operator_Vehicles_Bool_Exp>;
  jobs_aggregate?: InputMaybe<Job_Operator_Vehicles_Aggregate_Bool_Exp>;
  length?: InputMaybe<Numeric_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ownership?: InputMaybe<Ownership_Types_Enum_Comparison_Exp>;
  registrationNumber?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Entity_Status_Enum_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
  width?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "vehicles" */
export enum Vehicles_Constraint {
  /** unique or primary key constraint on columns "id" */
  VehiclesPkey = 'vehicles_pkey'
}

/** input type for incrementing numeric columns in table "vehicles" */
export type Vehicles_Inc_Input = {
  length?: InputMaybe<Scalars['numeric']>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "vehicles" */
export type Vehicles_Insert_Input = {
  brand?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  jobs?: InputMaybe<Job_Operator_Vehicles_Arr_Rel_Insert_Input>;
  length?: InputMaybe<Scalars['numeric']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Ownership_Types_Enum>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Vehicles_Max_Fields = {
  __typename?: 'vehicles_max_fields';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  length?: Maybe<Scalars['numeric']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Vehicles_Min_Fields = {
  __typename?: 'vehicles_min_fields';
  brand?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  length?: Maybe<Scalars['numeric']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "vehicles" */
export type Vehicles_Mutation_Response = {
  __typename?: 'vehicles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vehicles>;
};

/** input type for inserting object relation for remote table "vehicles" */
export type Vehicles_Obj_Rel_Insert_Input = {
  data: Vehicles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vehicles_On_Conflict>;
};

/** on_conflict condition type for table "vehicles" */
export type Vehicles_On_Conflict = {
  constraint: Vehicles_Constraint;
  update_columns?: Array<Vehicles_Update_Column>;
  where?: InputMaybe<Vehicles_Bool_Exp>;
};

/** Ordering options when selecting data from "vehicles". */
export type Vehicles_Order_By = {
  brand?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobs_aggregate?: InputMaybe<Job_Operator_Vehicles_Aggregate_Order_By>;
  length?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  registrationNumber?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vehicles */
export type Vehicles_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "vehicles" */
export enum Vehicles_Select_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Length = 'length',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  RegistrationNumber = 'registrationNumber',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'userId',
  /** column name */
  Weight = 'weight',
  /** column name */
  Width = 'width'
}

/** input type for updating data in table "vehicles" */
export type Vehicles_Set_Input = {
  brand?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  length?: InputMaybe<Scalars['numeric']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Ownership_Types_Enum>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Vehicles_Stddev_Fields = {
  __typename?: 'vehicles_stddev_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Vehicles_Stddev_Pop_Fields = {
  __typename?: 'vehicles_stddev_pop_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Vehicles_Stddev_Samp_Fields = {
  __typename?: 'vehicles_stddev_samp_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vehicles" */
export type Vehicles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vehicles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vehicles_Stream_Cursor_Value_Input = {
  brand?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  length?: InputMaybe<Scalars['numeric']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Ownership_Types_Enum>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Entity_Status_Enum>;
  userId?: InputMaybe<Scalars['Int']>;
  weight?: InputMaybe<Scalars['numeric']>;
  width?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Vehicles_Sum_Fields = {
  __typename?: 'vehicles_sum_fields';
  length?: Maybe<Scalars['numeric']>;
  userId?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['numeric']>;
  width?: Maybe<Scalars['numeric']>;
};

/** update columns of table "vehicles" */
export enum Vehicles_Update_Column {
  /** column name */
  Brand = 'brand',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Length = 'length',
  /** column name */
  Model = 'model',
  /** column name */
  Name = 'name',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  RegistrationNumber = 'registrationNumber',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'userId',
  /** column name */
  Weight = 'weight',
  /** column name */
  Width = 'width'
}

export type Vehicles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vehicles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vehicles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vehicles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vehicles_Var_Pop_Fields = {
  __typename?: 'vehicles_var_pop_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Vehicles_Var_Samp_Fields = {
  __typename?: 'vehicles_var_samp_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Vehicles_Variance_Fields = {
  __typename?: 'vehicles_variance_fields';
  length?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "warehouses" */
export type Warehouses = {
  __typename?: 'warehouses';
  address?: Maybe<Scalars['String']>;
  /** An object relationship */
  farm?: Maybe<Farms>;
  farmId?: Maybe<Scalars['bigint']>;
  geoLocation?: Maybe<Scalars['point']>;
  id: Scalars['bigint'];
  name: Scalars['String'];
  userId: Scalars['Int'];
};

/** aggregated selection of "warehouses" */
export type Warehouses_Aggregate = {
  __typename?: 'warehouses_aggregate';
  aggregate?: Maybe<Warehouses_Aggregate_Fields>;
  nodes: Array<Warehouses>;
};

/** aggregate fields of "warehouses" */
export type Warehouses_Aggregate_Fields = {
  __typename?: 'warehouses_aggregate_fields';
  avg?: Maybe<Warehouses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Warehouses_Max_Fields>;
  min?: Maybe<Warehouses_Min_Fields>;
  stddev?: Maybe<Warehouses_Stddev_Fields>;
  stddev_pop?: Maybe<Warehouses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Warehouses_Stddev_Samp_Fields>;
  sum?: Maybe<Warehouses_Sum_Fields>;
  var_pop?: Maybe<Warehouses_Var_Pop_Fields>;
  var_samp?: Maybe<Warehouses_Var_Samp_Fields>;
  variance?: Maybe<Warehouses_Variance_Fields>;
};


/** aggregate fields of "warehouses" */
export type Warehouses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Warehouses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Warehouses_Avg_Fields = {
  __typename?: 'warehouses_avg_fields';
  farmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "warehouses". All fields are combined with a logical 'AND'. */
export type Warehouses_Bool_Exp = {
  _and?: InputMaybe<Array<Warehouses_Bool_Exp>>;
  _not?: InputMaybe<Warehouses_Bool_Exp>;
  _or?: InputMaybe<Array<Warehouses_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  farm?: InputMaybe<Farms_Bool_Exp>;
  farmId?: InputMaybe<Bigint_Comparison_Exp>;
  geoLocation?: InputMaybe<Point_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "warehouses" */
export enum Warehouses_Constraint {
  /** unique or primary key constraint on columns "id" */
  WarehousesPkey = 'warehouses_pkey'
}

/** input type for incrementing numeric columns in table "warehouses" */
export type Warehouses_Inc_Input = {
  farmId?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "warehouses" */
export type Warehouses_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  farm?: InputMaybe<Farms_Obj_Rel_Insert_Input>;
  farmId?: InputMaybe<Scalars['bigint']>;
  geoLocation?: InputMaybe<Scalars['point']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Warehouses_Max_Fields = {
  __typename?: 'warehouses_max_fields';
  address?: Maybe<Scalars['String']>;
  farmId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Warehouses_Min_Fields = {
  __typename?: 'warehouses_min_fields';
  address?: Maybe<Scalars['String']>;
  farmId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "warehouses" */
export type Warehouses_Mutation_Response = {
  __typename?: 'warehouses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Warehouses>;
};

/** input type for inserting object relation for remote table "warehouses" */
export type Warehouses_Obj_Rel_Insert_Input = {
  data: Warehouses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Warehouses_On_Conflict>;
};

/** on_conflict condition type for table "warehouses" */
export type Warehouses_On_Conflict = {
  constraint: Warehouses_Constraint;
  update_columns?: Array<Warehouses_Update_Column>;
  where?: InputMaybe<Warehouses_Bool_Exp>;
};

/** Ordering options when selecting data from "warehouses". */
export type Warehouses_Order_By = {
  address?: InputMaybe<Order_By>;
  farm?: InputMaybe<Farms_Order_By>;
  farmId?: InputMaybe<Order_By>;
  geoLocation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: warehouses */
export type Warehouses_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** select columns of table "warehouses" */
export enum Warehouses_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  FarmId = 'farmId',
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "warehouses" */
export type Warehouses_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  farmId?: InputMaybe<Scalars['bigint']>;
  geoLocation?: InputMaybe<Scalars['point']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Warehouses_Stddev_Fields = {
  __typename?: 'warehouses_stddev_fields';
  farmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Warehouses_Stddev_Pop_Fields = {
  __typename?: 'warehouses_stddev_pop_fields';
  farmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Warehouses_Stddev_Samp_Fields = {
  __typename?: 'warehouses_stddev_samp_fields';
  farmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "warehouses" */
export type Warehouses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Warehouses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Warehouses_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  farmId?: InputMaybe<Scalars['bigint']>;
  geoLocation?: InputMaybe<Scalars['point']>;
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Warehouses_Sum_Fields = {
  __typename?: 'warehouses_sum_fields';
  farmId?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['Int']>;
};

/** update columns of table "warehouses" */
export enum Warehouses_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  FarmId = 'farmId',
  /** column name */
  GeoLocation = 'geoLocation',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UserId = 'userId'
}

export type Warehouses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Warehouses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Warehouses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Warehouses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Warehouses_Var_Pop_Fields = {
  __typename?: 'warehouses_var_pop_fields';
  farmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Warehouses_Var_Samp_Fields = {
  __typename?: 'warehouses_var_samp_fields';
  farmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Warehouses_Variance_Fields = {
  __typename?: 'warehouses_variance_fields';
  farmId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  userId?: Maybe<Scalars['Float']>;
};

export type SaveMyBasicProfileMutationVariables = Exact<{
  userId: Scalars['Int'];
  updateUserPayload: Users_Set_Input;
}>;


export type SaveMyBasicProfileMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', firstName: string, lastName?: string | null, username: string } | null };

export type SaveMyUserProfileMutationVariables = Exact<{
  userId: Scalars['Int'];
  updateUserProfilePayload: User_Profiles_Set_Input;
}>;


export type SaveMyUserProfileMutation = { __typename?: 'mutation_root', update_user_profiles_by_pk?: { __typename?: 'user_profiles', address1?: string | null, address2?: string | null, city?: string | null, companyName?: string | null, country?: string | null, phone?: string | null, postalCode?: string | null, state?: string | null, taxNumber?: string | null } | null };

export type GetMyUserProfileQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyUserProfileQuery = { __typename?: 'query_root', user_profiles_by_pk?: { __typename?: 'user_profiles', address1?: string | null, address2?: string | null, city?: string | null, companyName?: string | null, country?: string | null, phone?: string | null, postalCode?: string | null, state?: string | null, taxNumber?: string | null } | null };

export type GetMyUserPreferencesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyUserPreferencesQuery = { __typename?: 'query_root', user_prefs: Array<{ __typename?: 'user_prefs', currency?: string | null, fieldColor?: string | null, fieldUnit?: string | null, geoLocation?: any | null, invoicePayInfo?: string | null, invoiceTerms?: number | null, timezone?: string | null }> };

export type SaveMyUserPreferencesMutationVariables = Exact<{
  userId: Scalars['Int'];
  updateUserPreferencesPayload: User_Prefs_Set_Input;
}>;


export type SaveMyUserPreferencesMutation = { __typename?: 'mutation_root', update_user_prefs_by_pk?: { __typename?: 'user_prefs', currency?: string | null, fieldColor?: string | null, fieldUnit?: string | null, geoLocation?: any | null, invoicePayInfo?: string | null, invoiceTerms?: number | null, timezone?: string | null } | null };

export type GetMyTaxRatesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyTaxRatesQuery = { __typename?: 'query_root', user_tax_rates: Array<{ __typename?: 'user_tax_rates', label: string, name: string, rate: any, userId: number }> };

export type SaveMyTaxRatesMutationVariables = Exact<{
  rates: Array<User_Tax_Rates_Insert_Input> | User_Tax_Rates_Insert_Input;
}>;


export type SaveMyTaxRatesMutation = { __typename?: 'mutation_root', insert_user_tax_rates?: { __typename?: 'user_tax_rates_mutation_response', affected_rows: number } | null };

export type GetFarmsQueryVariables = Exact<{
  userId: Scalars['bigint'];
}>;


export type GetFarmsQuery = { __typename?: 'query_root', farms: Array<{ __typename?: 'farms', id: any, name: string }> };

export type GetFieldsQueryVariables = Exact<{
  filter: Field_Season_Shot_Bool_Exp;
}>;


export type GetFieldsQuery = { __typename?: 'query_root', field_season_shot: Array<{ __typename?: 'field_season_shot', id: any, name?: string | null, notes?: string | null, season: string, fieldId: any, cropName: string, description?: string | null, ownershipType: string, farm: { __typename?: 'farms', id: any, userId: any }, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } }> };

export type GetFieldSnapshotsQueryVariables = Exact<{
  userId: Scalars['bigint'];
  fieldId: Scalars['bigint'];
}>;


export type GetFieldSnapshotsQuery = { __typename?: 'query_root', field_season_shot: Array<{ __typename?: 'field_season_shot', id: any, name?: string | null, notes?: string | null, season: string, fieldId: any, cropName: string, description?: string | null, ownershipType: string, farm: { __typename?: 'farms', id: any, userId: any }, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } }> };

export type GetSnapshotReportsQueryVariables = Exact<{
  shotId: Scalars['bigint'];
}>;


export type GetSnapshotReportsQuery = { __typename?: 'query_root', reports: Array<{ __typename?: 'reports', id: any, name?: string | null, link: string, tag: any, createdAt: any }> };

export type InsertFarmMutationVariables = Exact<{
  farm: Farms_Insert_Input;
}>;


export type InsertFarmMutation = { __typename?: 'mutation_root', insert_farms_one?: { __typename?: 'farms', id: any, name: string } | null };

export type InsertFieldSeasonShotMutationVariables = Exact<{
  shot: Field_Season_Shot_Insert_Input;
}>;


export type InsertFieldSeasonShotMutation = { __typename?: 'mutation_root', insert_field_season_shot_one?: { __typename?: 'field_season_shot', id: any, name?: string | null, notes?: string | null, season: string, fieldId: any, cropName: string, description?: string | null, ownershipType: string, farm: { __typename?: 'farms', id: any, userId: any }, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } } | null };

export type SaveFieldShotAndPolygonMutationVariables = Exact<{
  shotId: Scalars['bigint'];
  polygonId: Scalars['bigint'];
  shot: Field_Season_Shot_Set_Input;
  polygon: Polygons_Set_Input;
}>;


export type SaveFieldShotAndPolygonMutation = { __typename?: 'mutation_root', update_polygons_by_pk?: { __typename?: 'polygons', id: any } | null, update_field_season_shot_by_pk?: { __typename?: 'field_season_shot', id: any, name?: string | null, notes?: string | null, season: string, fieldId: any, cropName: string, description?: string | null, ownershipType: string, farm: { __typename?: 'farms', id: any, userId: any }, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } } | null };

export type SaveFieldSeasonShotMutationVariables = Exact<{
  shotId: Scalars['bigint'];
  shot: Field_Season_Shot_Set_Input;
}>;


export type SaveFieldSeasonShotMutation = { __typename?: 'mutation_root', update_field_season_shot_by_pk?: { __typename?: 'field_season_shot', id: any, name?: string | null, notes?: string | null, season: string, fieldId: any, cropName: string, description?: string | null, ownershipType: string, farm: { __typename?: 'farms', id: any, userId: any }, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } } | null };

export type SaveSnapshotReportMutationVariables = Exact<{
  report: Reports_Insert_Input;
}>;


export type SaveSnapshotReportMutation = { __typename?: 'mutation_root', insert_reports_one?: { __typename?: 'reports', id: any, name?: string | null, link: string, tag: any, createdAt: any } | null };

export type GetSnapshotJobsQueryVariables = Exact<{
  shotId: Scalars['bigint'];
}>;


export type GetSnapshotJobsQuery = { __typename?: 'query_root', job_fields: Array<{ __typename?: 'job_fields', jobId: any, job: { __typename?: 'jobs', id: any, operationName: string, from?: any | null, status: Job_Status_Enum } }> };

export type GetMyImplementsQueryVariables = Exact<{
  filter: Implements_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetMyImplementsQuery = { __typename?: 'query_root', implements_aggregate: { __typename?: 'implements_aggregate', aggregate?: { __typename?: 'implements_aggregate_fields', count: number } | null }, implements: Array<{ __typename?: 'implements', brand?: string | null, length?: any | null, model?: string | null, name: string, ownership: Ownership_Types_Enum, status: Entity_Status_Enum, weight?: any | null, width?: any | null, id: any, userId: number }> };

export type UpdateMyImplementMutationVariables = Exact<{
  updateImplementPayload: Implements_Set_Input;
  id: Scalars['uuid'];
}>;


export type UpdateMyImplementMutation = { __typename?: 'mutation_root', update_implements_by_pk?: { __typename?: 'implements', brand?: string | null, length?: any | null, model?: string | null, name: string, ownership: Ownership_Types_Enum, status: Entity_Status_Enum, weight?: any | null, width?: any | null, id: any, userId: number } | null };

export type SaveMyImplementMutationVariables = Exact<{
  saveImplementPayload: Implements_Insert_Input;
}>;


export type SaveMyImplementMutation = { __typename?: 'mutation_root', insert_implements_one?: { __typename?: 'implements', brand?: string | null, length?: any | null, model?: string | null, name: string, ownership: Ownership_Types_Enum, status: Entity_Status_Enum, weight?: any | null, width?: any | null, id: any, userId: number } | null };

export type UpdateMyImplementStatusMutationVariables = Exact<{
  status: Entity_Status_Enum;
  id: Scalars['uuid'];
}>;


export type UpdateMyImplementStatusMutation = { __typename?: 'mutation_root', update_implements_by_pk?: { __typename?: 'implements', status: Entity_Status_Enum, id: any } | null };

export type GetMyInventoryQueryVariables = Exact<{
  filter: Inventory_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetMyInventoryQuery = { __typename?: 'query_root', inventory_aggregate: { __typename?: 'inventory_aggregate', aggregate?: { __typename?: 'inventory_aggregate_fields', count: number } | null }, inventory: Array<{ __typename?: 'inventory', amount: any, createdAt: any, id: any, price: any, remaining: any, userId: number, warehouse?: { __typename?: 'warehouses', id: any, name: string } | null, product: { __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum, pricePerUnit: any } }> };

export type UpdateMyProductPriceMutationVariables = Exact<{
  id: Scalars['uuid'];
  price: Scalars['numeric'];
}>;


export type UpdateMyProductPriceMutation = { __typename?: 'mutation_root', update_products_by_pk?: { __typename?: 'products', id: any } | null };

export type SaveMyInventoryMutationVariables = Exact<{
  saveInventoryPayload: Inventory_Insert_Input;
}>;


export type SaveMyInventoryMutation = { __typename?: 'mutation_root', insert_inventory_one?: { __typename?: 'inventory', amount: any, createdAt: any, id: any, price: any, remaining: any, userId: number, warehouse?: { __typename?: 'warehouses', id: any, name: string } | null, product: { __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum, pricePerUnit: any } } | null };

export type GetOperatorsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetOperatorsQuery = { __typename?: 'query_root', team_members: Array<{ __typename?: 'team_members', teamMember: { __typename?: 'users', id: number, firstName: string, lastName?: string | null, roles: Array<{ __typename?: 'user_roles', role: Roles_Enum }>, prefs?: { __typename?: 'user_prefs', currency?: string | null } | null } }> };

export type GetVehiclesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetVehiclesQuery = { __typename?: 'query_root', vehicles: Array<{ __typename?: 'vehicles', id: any, name: string, model?: string | null, brand?: string | null }> };

export type GetImplementsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetImplementsQuery = { __typename?: 'query_root', implements: Array<{ __typename?: 'implements', id: any, name: string, model?: string | null, brand?: string | null }> };

export type GetFieldsCompactQueryVariables = Exact<{
  filter: Field_Season_Shot_Bool_Exp;
}>;


export type GetFieldsCompactQuery = { __typename?: 'query_root', field_season_shot: Array<{ __typename?: 'field_season_shot', id: any, name?: string | null, farmId: any, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } }> };

export type GetOperationsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetOperationsQuery = { __typename?: 'query_root', operations: Array<{ __typename?: 'operations', id: any, name: string, billingRate: any, billingUnit: Chargeable_Units_Enum }> };

export type GetOperationExtrasQueryVariables = Exact<{
  operationId: Scalars['bigint'];
}>;


export type GetOperationExtrasQuery = { __typename?: 'query_root', operation_extras: Array<{ __typename?: 'operation_extras', id: any, unit: Chargeable_Units_Enum, value?: string | null, name: string }> };

export type GetOperationProductsQueryVariables = Exact<{
  operationId: Scalars['bigint'];
}>;


export type GetOperationProductsQuery = { __typename?: 'query_root', operation_products: Array<{ __typename?: 'operation_products', product: { __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum } }> };

export type GetProductsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetProductsQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum }> };

export type AddJobMutationVariables = Exact<{
  job: Jobs_Insert_Input;
}>;


export type AddJobMutation = { __typename?: 'mutation_root', insert_jobs_one?: { __typename?: 'jobs', id: any, userId: any, operationName: string, instructions?: string | null, from?: any | null, to?: any | null, status: Job_Status_Enum, createdAt: any, completedAt?: any | null, assignedUser: { __typename?: 'users', id: number, firstName: string }, extras: Array<{ __typename?: 'job_extras', name: string, unit: Chargeable_Units_Enum, value?: string | null }>, user: { __typename?: 'users', id: number, profile?: { __typename?: 'user_profiles', companyName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, phone?: string | null } | null }, locations: Array<{ __typename?: 'job_locations', id: any, notes: string, geoLocation?: any | null }>, products: Array<{ __typename?: 'job_products', productId: any, jobId: any, locked: boolean, value?: string | null, product: { __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum } }>, operators: Array<{ __typename?: 'job_operators', teamLead?: boolean | null, user: { __typename?: 'users', id: number, firstName: string }, vehicles: Array<{ __typename?: 'job_operator_vehicles', vehicle: { __typename?: 'vehicles', id: any, name: string, model?: string | null, brand?: string | null } }>, implements: Array<{ __typename?: 'job_operator_implements', implement: { __typename?: 'implements', id: any, name: string, model?: string | null, brand?: string | null } }> }>, fields: Array<{ __typename?: 'job_fields', seasonShot: { __typename?: 'field_season_shot', id: any, name?: string | null, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } } }> } | null };

export type UpdateJobMutationVariables = Exact<{
  jobId: Scalars['bigint'];
  updatedJob: Jobs_Insert_Input;
  removedOperators?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  removedFields?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
  removedExtras?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  removedLocations?: InputMaybe<Array<Scalars['bigint']> | Scalars['bigint']>;
  removedProducts?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type UpdateJobMutation = { __typename?: 'mutation_root', delete_job_operators?: { __typename?: 'job_operators_mutation_response', affected_rows: number } | null, delete_job_fields?: { __typename?: 'job_fields_mutation_response', affected_rows: number } | null, delete_job_extras?: { __typename?: 'job_extras_mutation_response', affected_rows: number } | null, delete_job_products?: { __typename?: 'job_products_mutation_response', affected_rows: number } | null, delete_job_locations?: { __typename?: 'job_locations_mutation_response', affected_rows: number } | null, insert_jobs_one?: { __typename?: 'jobs', id: any, userId: any, operationName: string, instructions?: string | null, from?: any | null, to?: any | null, status: Job_Status_Enum, createdAt: any, completedAt?: any | null, assignedUser: { __typename?: 'users', id: number, firstName: string }, extras: Array<{ __typename?: 'job_extras', name: string, unit: Chargeable_Units_Enum, value?: string | null }>, locations: Array<{ __typename?: 'job_locations', id: any, notes: string, geoLocation?: any | null }>, products: Array<{ __typename?: 'job_products', productId: any, jobId: any, locked: boolean, value?: string | null, product: { __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum } }>, operators: Array<{ __typename?: 'job_operators', teamLead?: boolean | null, user: { __typename?: 'users', id: number, firstName: string }, vehicles: Array<{ __typename?: 'job_operator_vehicles', vehicle: { __typename?: 'vehicles', id: any, name: string, model?: string | null, brand?: string | null } }>, implements: Array<{ __typename?: 'job_operator_implements', implement: { __typename?: 'implements', id: any, name: string, model?: string | null, brand?: string | null } }> }>, fields: Array<{ __typename?: 'job_fields', seasonShot: { __typename?: 'field_season_shot', id: any, name?: string | null, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } } }> } | null };

export type UpdateJobAsOperatorMutationVariables = Exact<{
  extraUpdates: Array<Job_Extras_Updates> | Job_Extras_Updates;
  productUpdates: Array<Job_Products_Updates> | Job_Products_Updates;
}>;


export type UpdateJobAsOperatorMutation = { __typename?: 'mutation_root', update_job_extras_many?: Array<{ __typename?: 'job_extras_mutation_response', returning: Array<{ __typename?: 'job_extras', name: string, value?: string | null, unit: Chargeable_Units_Enum }> } | null> | null, update_job_products_many?: Array<{ __typename?: 'job_products_mutation_response', returning: Array<{ __typename?: 'job_products', productId: any, jobId: any, locked: boolean, value?: string | null, product: { __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum } }> } | null> | null };

export type GetJobDetailsQueryVariables = Exact<{
  jobId: Scalars['bigint'];
  isOperator: Scalars['Boolean'];
}>;


export type GetJobDetailsQuery = { __typename?: 'query_root', jobs_by_pk?: { __typename?: 'jobs', id: any, userId?: any, operationName: string, instructions?: string | null, from?: any | null, to?: any | null, status: Job_Status_Enum, createdAt: any, completedAt?: any | null, user?: { __typename?: 'users', id: number, profile?: { __typename?: 'user_profiles', companyName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, phone?: string | null } | null }, operation?: { __typename?: 'operations', id: any, billingRate: any, billingUnit: Chargeable_Units_Enum } | null, assignedUser?: { __typename?: 'users', id: number, firstName: string, profile?: { __typename?: 'user_profiles', companyName?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, phone?: string | null } | null }, extras: Array<{ __typename?: 'job_extras', name: string, unit: Chargeable_Units_Enum, value?: string | null }>, locations: Array<{ __typename?: 'job_locations', id: any, notes: string, geoLocation?: any | null }>, products: Array<{ __typename?: 'job_products', productId: any, jobId: any, locked: boolean, value?: string | null, product: { __typename?: 'products', id: any, name: string, chargeableUnit: Chargeable_Units_Enum, pricePerUnit?: any } }>, operators: Array<{ __typename?: 'job_operators', teamLead?: boolean | null, user: { __typename?: 'users', id: number, firstName: string }, vehicles: Array<{ __typename?: 'job_operator_vehicles', vehicle: { __typename?: 'vehicles', id: any, name: string, model?: string | null, brand?: string | null } }>, implements: Array<{ __typename?: 'job_operator_implements', implement: { __typename?: 'implements', id: any, name: string, model?: string | null, brand?: string | null } }> }>, fields: Array<{ __typename?: 'job_fields', seasonShot: { __typename?: 'field_season_shot', id: any, name?: string | null, farmId: any, polygon: { __typename?: 'polygons', id: any, size?: any | null, geometry?: any | null } } }> } | null };

export type UpdateJobStatusMutationVariables = Exact<{
  jobId: Scalars['bigint'];
  status: Job_Status_Enum;
}>;


export type UpdateJobStatusMutation = { __typename?: 'mutation_root', update_jobs_by_pk?: { __typename?: 'jobs', id: any, status: Job_Status_Enum, completedAt?: any | null } | null };

export type GetJobsQueryVariables = Exact<{
  filter: Jobs_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetJobsQuery = { __typename?: 'query_root', count: { __typename?: 'jobs_aggregate', aggregate?: { __typename?: 'jobs_aggregate_fields', count: number } | null }, operations: { __typename?: 'jobs_aggregate', nodes: Array<{ __typename?: 'jobs', operationName: string, id: string }> }, jobs: Array<{ __typename?: 'jobs', id: any, operationName: string, from?: any | null, to?: any | null, status: Job_Status_Enum, assignedUser: { __typename?: 'users', id: number, firstName: string } }> };

export type ApiLoginUserQueryVariables = Exact<{
  input?: InputMaybe<Api_Login_User_Input>;
}>;


export type ApiLoginUserQuery = { __typename?: 'query_root', api_login_user?: { __typename?: 'api_login_user_output', token: string, id: number } | null };

export type SaveUserProfileMutationVariables = Exact<{
  userProfile: User_Profiles_Insert_Input;
  userPrefs: User_Prefs_Insert_Input;
  rates: Array<User_Tax_Rates_Insert_Input> | User_Tax_Rates_Insert_Input;
}>;


export type SaveUserProfileMutation = { __typename?: 'mutation_root', insert_user_profiles_one?: { __typename?: 'user_profiles', userId: number } | null, insert_user_prefs_one?: { __typename?: 'user_prefs', userId: number } | null, insert_user_tax_rates?: { __typename?: 'user_tax_rates_mutation_response', affected_rows: number } | null };

export type GetMyOperationsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyOperationsQuery = { __typename?: 'query_root', operations: Array<{ __typename?: 'operations', billingRate: any, billingUnit: Chargeable_Units_Enum, description?: string | null, createdAt: any, id: any, name: string, status: Entity_Status_Enum, type: string, userId: number, products: Array<{ __typename?: 'operation_products', productId: any, operationId: any, product: { __typename?: 'products', id: any, name: string } }>, extras: Array<{ __typename?: 'operation_extras', id: any, name: string, value?: string | null, unit: Chargeable_Units_Enum }> }> };

export type UpdateMyOperationMutationVariables = Exact<{
  id: Scalars['bigint'];
  updateOperationPayload: Operations_Set_Input;
  newProducts: Array<Operation_Products_Insert_Input> | Operation_Products_Insert_Input;
  newExtras: Array<Operation_Extras_Insert_Input> | Operation_Extras_Insert_Input;
  updatedExtras: Array<Operation_Extras_Updates> | Operation_Extras_Updates;
  deletedProductIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
  deletedExtraIds?: InputMaybe<Array<Scalars['uuid']> | Scalars['uuid']>;
}>;


export type UpdateMyOperationMutation = { __typename?: 'mutation_root', delete_operation_products?: { __typename?: 'operation_products_mutation_response', affected_rows: number } | null, delete_operation_extras?: { __typename?: 'operation_extras_mutation_response', affected_rows: number } | null, insert_operation_products?: { __typename?: 'operation_products_mutation_response', affected_rows: number } | null, insert_operation_extras?: { __typename?: 'operation_extras_mutation_response', affected_rows: number } | null, update_operation_extras_many?: Array<{ __typename?: 'operation_extras_mutation_response', affected_rows: number } | null> | null, update_operations_by_pk?: { __typename?: 'operations', billingRate: any, billingUnit: Chargeable_Units_Enum, description?: string | null, createdAt: any, id: any, name: string, status: Entity_Status_Enum, type: string, userId: number, products: Array<{ __typename?: 'operation_products', productId: any, operationId: any, product: { __typename?: 'products', id: any, name: string } }>, extras: Array<{ __typename?: 'operation_extras', name: string, value?: string | null, unit: Chargeable_Units_Enum, id: any }> } | null };

export type UpsertMyOperationExtraMutationVariables = Exact<{
  upsertOperationExtraPayload: Operation_Extras_Insert_Input;
}>;


export type UpsertMyOperationExtraMutation = { __typename?: 'mutation_root', insert_operation_extras_one?: { __typename?: 'operation_extras', id: any } | null };

export type DeleteMyOperationExtraMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteMyOperationExtraMutation = { __typename?: 'mutation_root', delete_operation_extras_by_pk?: { __typename?: 'operation_extras', operationId: any } | null };

export type DeleteMyOperationProductMutationVariables = Exact<{
  operationId: Scalars['bigint'];
  productId: Scalars['uuid'];
}>;


export type DeleteMyOperationProductMutation = { __typename?: 'mutation_root', delete_operation_products_by_pk?: { __typename?: 'operation_products', operationId: any, productId: any, userId: number, product: { __typename?: 'products', chargeableUnit: Chargeable_Units_Enum, id: any, name: string, pricePerUnit: any, status: Entity_Status_Enum, userId: number } } | null };

export type SaveMyOperationProductMutationVariables = Exact<{
  saveOperationProductPayload: Operation_Products_Insert_Input;
}>;


export type SaveMyOperationProductMutation = { __typename?: 'mutation_root', insert_operation_products_one?: { __typename?: 'operation_products', operationId: any, productId: any, userId: number, product: { __typename?: 'products', chargeableUnit: Chargeable_Units_Enum, id: any, name: string, pricePerUnit: any, status: Entity_Status_Enum, userId: number } } | null };

export type InsertMyOperationMutationVariables = Exact<{
  saveOperationPayload: Operations_Insert_Input;
}>;


export type InsertMyOperationMutation = { __typename?: 'mutation_root', insert_operations_one?: { __typename?: 'operations', billingRate: any, billingUnit: Chargeable_Units_Enum, description?: string | null, createdAt: any, id: any, name: string, status: Entity_Status_Enum, type: string, userId: number, products: Array<{ __typename?: 'operation_products', productId: any, operationId: any, product: { __typename?: 'products', id: any, name: string } }>, extras: Array<{ __typename?: 'operation_extras', name: string, value?: string | null, unit: Chargeable_Units_Enum, id: any }> } | null };

export type GetMyProductsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyProductsQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'products', chargeableUnit: Chargeable_Units_Enum, id: any, name: string, pricePerUnit: any, status: Entity_Status_Enum, userId: number }> };

export type GetMyProductsPaginatedQueryVariables = Exact<{
  filter: Products_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetMyProductsPaginatedQuery = { __typename?: 'query_root', products_aggregate: { __typename?: 'products_aggregate', aggregate?: { __typename?: 'products_aggregate_fields', count: number } | null }, products: Array<{ __typename?: 'products', chargeableUnit: Chargeable_Units_Enum, id: any, name: string, pricePerUnit: any, status: Entity_Status_Enum, userId: number }> };

export type UpdateMyProductMutationVariables = Exact<{
  updateProductPayload: Products_Set_Input;
  id: Scalars['uuid'];
}>;


export type UpdateMyProductMutation = { __typename?: 'mutation_root', update_products_by_pk?: { __typename?: 'products', chargeableUnit: Chargeable_Units_Enum, id: any, name: string, pricePerUnit: any, status: Entity_Status_Enum, userId: number } | null };

export type SaveMyProductMutationVariables = Exact<{
  saveProductPayload: Products_Insert_Input;
}>;


export type SaveMyProductMutation = { __typename?: 'mutation_root', insert_products_one?: { __typename?: 'products', chargeableUnit: Chargeable_Units_Enum, id: any, name: string, pricePerUnit: any, status: Entity_Status_Enum, userId: number } | null };

export type GetChargeableUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChargeableUnitsQuery = { __typename?: 'query_root', chargeable_units: Array<{ __typename?: 'chargeable_units', value: string, comment: string }> };

export type UpdateMyProductStatusMutationVariables = Exact<{
  status: Entity_Status_Enum;
  id: Scalars['uuid'];
}>;


export type UpdateMyProductStatusMutation = { __typename?: 'mutation_root', update_products_by_pk?: { __typename?: 'products', status: Entity_Status_Enum, id: any } | null };

export type GetReportByTagQueryVariables = Exact<{
  tag: Scalars['uuid'];
}>;


export type GetReportByTagQuery = { __typename?: 'query_root', reports: Array<{ __typename?: 'reports', id: any, link: string, name?: string | null, jsonSummary?: any | null, createdAt: any, seasonShot: { __typename?: 'field_season_shot', name?: string | null, cropName: string, createdAt?: any | null, polygon: { __typename?: 'polygons', size?: any | null }, farm: { __typename?: 'farms', name: string } } }> };

export type ApiSignUpUserMutationVariables = Exact<{
  input?: InputMaybe<Api_Sign_Up_User_Input>;
}>;


export type ApiSignUpUserMutation = { __typename?: 'mutation_root', api_sign_up_user?: { __typename?: 'api_sign_up_user_output', token: string, id: number } | null };

export type ApiAcceptInviteMutationVariables = Exact<{
  input?: InputMaybe<Api_Accept_Invite_Input>;
}>;


export type ApiAcceptInviteMutation = { __typename?: 'mutation_root', api_accept_invite?: { __typename?: 'api_accept_invite_output', ok: boolean } | null };

export type GetMyTeamMembersQueryVariables = Exact<{
  userId: Scalars['Int'];
  roles?: InputMaybe<Array<Roles_Enum> | Roles_Enum>;
}>;


export type GetMyTeamMembersQuery = { __typename?: 'query_root', team_members: Array<{ __typename?: 'team_members', teamMember: { __typename?: 'users', username: string, id: number, roles: Array<{ __typename?: 'user_roles', role: Roles_Enum }> } }> };

export type GetMyTeamInvitesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyTeamInvitesQuery = { __typename?: 'query_root', user_invites: Array<{ __typename?: 'user_invites', invitee_email: string, invitee_role: Roles_Enum, id: string }> };

export type GetMyVehiclesQueryVariables = Exact<{
  filter: Vehicles_Bool_Exp;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetMyVehiclesQuery = { __typename?: 'query_root', vehicles_aggregate: { __typename?: 'vehicles_aggregate', aggregate?: { __typename?: 'vehicles_aggregate_fields', count: number } | null }, vehicles: Array<{ __typename?: 'vehicles', brand?: string | null, length?: any | null, model?: string | null, name: string, ownership: Ownership_Types_Enum, registrationNumber: string, status: Entity_Status_Enum, weight?: any | null, width?: any | null, id: any, userId: number }> };

export type UpdateMyVehicleMutationVariables = Exact<{
  updateVehiclePayload: Vehicles_Set_Input;
  id: Scalars['uuid'];
}>;


export type UpdateMyVehicleMutation = { __typename?: 'mutation_root', update_vehicles_by_pk?: { __typename?: 'vehicles', brand?: string | null, length?: any | null, model?: string | null, name: string, ownership: Ownership_Types_Enum, registrationNumber: string, status: Entity_Status_Enum, weight?: any | null, width?: any | null, id: any, userId: number } | null };

export type SaveMyVehicleMutationVariables = Exact<{
  saveVehiclePayload: Vehicles_Insert_Input;
}>;


export type SaveMyVehicleMutation = { __typename?: 'mutation_root', insert_vehicles_one?: { __typename?: 'vehicles', brand?: string | null, length?: any | null, model?: string | null, name: string, ownership: Ownership_Types_Enum, registrationNumber: string, status: Entity_Status_Enum, weight?: any | null, width?: any | null, id: any, userId: number } | null };

export type UpdateMyVehicleStatusMutationVariables = Exact<{
  status: Entity_Status_Enum;
  id: Scalars['uuid'];
}>;


export type UpdateMyVehicleStatusMutation = { __typename?: 'mutation_root', update_vehicles_by_pk?: { __typename?: 'vehicles', status: Entity_Status_Enum, id: any } | null };

export type GetMyWarehousesQueryVariables = Exact<{
  filter: Warehouses_Bool_Exp;
}>;


export type GetMyWarehousesQuery = { __typename?: 'query_root', warehouses: Array<{ __typename?: 'warehouses', id: any, address?: string | null, geoLocation?: any | null, name: string, farm?: { __typename?: 'farms', id: any, name: string } | null }> };

export type SaveWarehouseMutationVariables = Exact<{
  warehouse: Warehouses_Insert_Input;
}>;


export type SaveWarehouseMutation = { __typename?: 'mutation_root', insert_warehouses_one?: { __typename?: 'warehouses', id: any, address?: string | null, geoLocation?: any | null, name: string, farm?: { __typename?: 'farms', id: any, name: string } | null } | null };

export type GetMyUserDetailsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetMyUserDetailsQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: number, email: string, username: string, firstName: string, lastName?: string | null, isEmailVerified: boolean, prefs?: { __typename?: 'user_prefs', userId: number, geoLocation?: any | null, fieldColor?: string | null, currency?: string | null } | null, profile?: { __typename?: 'user_profiles', userId: number, companyName?: string | null } | null, roles: Array<{ __typename?: 'user_roles', role: Roles_Enum }> } | null };


export const SaveMyBasicProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyBasicProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"username"}}]}}]}}]} as unknown as DocumentNode<SaveMyBasicProfileMutation, SaveMyBasicProfileMutationVariables>;
export const SaveMyUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserProfilePayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_profiles_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserProfilePayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"taxNumber"}}]}}]}}]} as unknown as DocumentNode<SaveMyUserProfileMutation, SaveMyUserProfileMutationVariables>;
export const GetMyUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"taxNumber"}}]}}]}}]} as unknown as DocumentNode<GetMyUserProfileQuery, GetMyUserProfileQueryVariables>;
export const GetMyUserPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyUserPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_prefs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"fieldColor"}},{"kind":"Field","name":{"kind":"Name","value":"fieldUnit"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayInfo"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerms"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<GetMyUserPreferencesQuery, GetMyUserPreferencesQueryVariables>;
export const SaveMyUserPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyUserPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserPreferencesPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_prefs_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_prefs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserPreferencesPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"fieldColor"}},{"kind":"Field","name":{"kind":"Name","value":"fieldUnit"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}},{"kind":"Field","name":{"kind":"Name","value":"invoicePayInfo"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTerms"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<SaveMyUserPreferencesMutation, SaveMyUserPreferencesMutationVariables>;
export const GetMyTaxRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyTaxRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_tax_rates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetMyTaxRatesQuery, GetMyTaxRatesQueryVariables>;
export const SaveMyTaxRatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyTaxRates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_tax_rates_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_tax_rates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rates"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_tax_rates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"rate"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<SaveMyTaxRatesMutation, SaveMyTaxRatesMutationVariables>;
export const GetFarmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFarms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"farms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetFarmsQuery, GetFarmsQueryVariables>;
export const GetFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"field_season_shot_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field_season_shot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldId"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"fieldId"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"cropName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]} as unknown as DocumentNode<GetFieldsQuery, GetFieldsQueryVariables>;
export const GetFieldSnapshotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFieldSnapshots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field_season_shot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldId"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"farm"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"cropName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]} as unknown as DocumentNode<GetFieldSnapshotsQuery, GetFieldSnapshotsQueryVariables>;
export const GetSnapshotReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSnapshotReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seasonShotId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetSnapshotReportsQuery, GetSnapshotReportsQueryVariables>;
export const InsertFarmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertFarm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"farm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"farms_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_farms_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"farm"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<InsertFarmMutation, InsertFarmMutationVariables>;
export const InsertFieldSeasonShotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertFieldSeasonShot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"field_season_shot_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_field_season_shot_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"cropName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]} as unknown as DocumentNode<InsertFieldSeasonShotMutation, InsertFieldSeasonShotMutationVariables>;
export const SaveFieldShotAndPolygonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFieldShotAndPolygon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"polygonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"field_season_shot_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"polygon"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"polygons_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_polygons_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"polygonId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"polygon"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_field_season_shot_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"cropName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]} as unknown as DocumentNode<SaveFieldShotAndPolygonMutation, SaveFieldShotAndPolygonMutationVariables>;
export const SaveFieldSeasonShotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFieldSeasonShot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"field_season_shot_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_field_season_shot_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"}},{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"cropName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"ownershipType"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]} as unknown as DocumentNode<SaveFieldSeasonShotMutation, SaveFieldSeasonShotMutationVariables>;
export const SaveSnapshotReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveSnapshotReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"report"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reports_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_reports_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"report"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"reports_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"link"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<SaveSnapshotReportMutation, SaveSnapshotReportMutationVariables>;
export const GetSnapshotJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSnapshotJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"job_fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seasonShotId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shotId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"job"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"operationName"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetSnapshotJobsQuery, GetSnapshotJobsQueryVariables>;
export const GetMyImplementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyImplements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"implements_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"implements_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"implements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetMyImplementsQuery, GetMyImplementsQueryVariables>;
export const UpdateMyImplementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyImplement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateImplementPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"implements_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_implements_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateImplementPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<UpdateMyImplementMutation, UpdateMyImplementMutationVariables>;
export const SaveMyImplementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyImplement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saveImplementPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"implements_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_implements_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saveImplementPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<SaveMyImplementMutation, SaveMyImplementMutationVariables>;
export const UpdateMyImplementStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyImplementStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"entity_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_implements_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMyImplementStatusMutation, UpdateMyImplementStatusMutationVariables>;
export const GetMyInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"inventory_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inventory_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"inventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyInventoryQuery, GetMyInventoryQueryVariables>;
export const UpdateMyProductPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyProductPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_products_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pricePerUnit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMyProductPriceMutation, UpdateMyProductPriceMutationVariables>;
export const SaveMyInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saveInventoryPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"inventory_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_inventory_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saveInventoryPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}}]}}]}}]}}]} as unknown as DocumentNode<SaveMyInventoryMutation, SaveMyInventoryMutationVariables>;
export const GetOperatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorsQuery, GetOperatorsQueryVariables>;
export const GetVehiclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVehicles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]} as unknown as DocumentNode<GetVehiclesQuery, GetVehiclesQueryVariables>;
export const GetImplementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImplements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"implements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]} as unknown as DocumentNode<GetImplementsQuery, GetImplementsQueryVariables>;
export const GetFieldsCompactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFieldsCompact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"field_season_shot_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field_season_shot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fieldId"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"fieldId"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"farmId"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]} as unknown as DocumentNode<GetFieldsCompactQuery, GetFieldsCompactQueryVariables>;
export const GetOperationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingRate"}},{"kind":"Field","name":{"kind":"Name","value":"billingUnit"}}]}}]}}]} as unknown as DocumentNode<GetOperationsQuery, GetOperationsQueryVariables>;
export const GetOperationExtrasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperationExtras"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operation_extras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetOperationExtrasQuery, GetOperationExtrasQueryVariables>;
export const GetOperationProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperationProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operation_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"product"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}}]}}]}}]}}]} as unknown as DocumentNode<GetOperationProductsQuery, GetOperationProductsQueryVariables>;
export const GetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}}]}}]}}]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const AddJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"job"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jobs_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_jobs_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"job"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"operationName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamLead"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"implements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"implement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonShot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddJobMutation, AddJobMutationVariables>;
export const UpdateJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedJob"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jobs_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedOperators"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedExtras"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedLocations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedProducts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_job_operators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedOperators"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_job_fields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonShotId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedFields"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_job_extras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedExtras"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_job_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedProducts"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_job_locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedLocations"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_jobs_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedJob"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"jobs_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"assignedUserId"},{"kind":"EnumValue","value":"operationId"},{"kind":"EnumValue","value":"operationName"},{"kind":"EnumValue","value":"from"},{"kind":"EnumValue","value":"to"},{"kind":"EnumValue","value":"instructions"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"operationName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamLead"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"implements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"implement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonShot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateJobMutation, UpdateJobMutationVariables>;
export const UpdateJobAsOperatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJobAsOperator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"extraUpdates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"job_extras_updates"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productUpdates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"job_products_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_job_extras_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"extraUpdates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_job_products_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productUpdates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateJobAsOperatorMutation, UpdateJobAsOperatorMutationVariables>;
export const GetJobDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOperator"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOperator"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"user"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOperator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operationName"}},{"kind":"Field","name":{"kind":"Name","value":"operation"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOperator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billingRate"}},{"kind":"Field","name":{"kind":"Name","value":"billingUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOperator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOperator"}}}]}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"operators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamLead"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"implements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"implement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasonShot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"farmId"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJobDetailsQuery, GetJobDetailsQueryVariables>;
export const UpdateJobStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJobStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"job_status_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_jobs_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateJobStatusMutation, UpdateJobStatusMutationVariables>;
export const GetJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jobs_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"jobs_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operations"},"name":{"kind":"Name","value":"jobs_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"operationName"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"operationName"}},{"kind":"Field","name":{"kind":"Name","value":"operationName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"operationName"}},{"kind":"Field","name":{"kind":"Name","value":"assignedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetJobsQuery, GetJobsQueryVariables>;
export const ApiLoginUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApiLoginUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"api_login_user_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"api_login_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiLoginUserQuery, ApiLoginUserQueryVariables>;
export const SaveUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userProfile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_profiles_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userPrefs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_prefs_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_tax_rates_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_profiles_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userProfile"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_profiles_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"companyName"},{"kind":"EnumValue","value":"phone"},{"kind":"EnumValue","value":"address1"},{"kind":"EnumValue","value":"address2"},{"kind":"EnumValue","value":"city"},{"kind":"EnumValue","value":"country"},{"kind":"EnumValue","value":"postalCode"},{"kind":"EnumValue","value":"state"},{"kind":"EnumValue","value":"taxNumber"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_user_prefs_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userPrefs"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_prefs_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"currency"},{"kind":"EnumValue","value":"fieldColor"},{"kind":"EnumValue","value":"fieldUnit"},{"kind":"EnumValue","value":"geoLocation"},{"kind":"EnumValue","value":"invoicePayInfo"},{"kind":"EnumValue","value":"invoiceTerms"},{"kind":"EnumValue","value":"timezone"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_user_tax_rates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rates"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_tax_rates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"rate"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<SaveUserProfileMutation, SaveUserProfileMutationVariables>;
export const GetMyOperationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyOperations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingRate"}},{"kind":"Field","name":{"kind":"Name","value":"billingUnit"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"operationId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyOperationsQuery, GetMyOperationsQueryVariables>;
export const UpdateMyOperationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyOperation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateOperationPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"operations_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newProducts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"operation_products_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newExtras"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"operation_extras_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatedExtras"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"operation_extras_updates"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletedProductIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletedExtraIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_operation_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletedProductIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_operation_extras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletedExtraIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_operation_products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newProducts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_operation_extras"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newExtras"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"operation_extras_id_name_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"},{"kind":"EnumValue","value":"unit"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_operation_extras_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatedExtras"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_operations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateOperationPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingRate"}},{"kind":"Field","name":{"kind":"Name","value":"billingUnit"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"operationId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMyOperationMutation, UpdateMyOperationMutationVariables>;
export const UpsertMyOperationExtraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertMyOperationExtra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upsertOperationExtraPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"operation_extras_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_operation_extras_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upsertOperationExtraPayload"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"operation_extras_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"unit"},{"kind":"EnumValue","value":"value"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertMyOperationExtraMutation, UpsertMyOperationExtraMutationVariables>;
export const DeleteMyOperationExtraDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMyOperationExtra"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_operation_extras_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationId"}}]}}]}}]} as unknown as DocumentNode<DeleteMyOperationExtraMutation, DeleteMyOperationExtraMutationVariables>;
export const DeleteMyOperationProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMyOperationProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_operation_products_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"operationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operationId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<DeleteMyOperationProductMutation, DeleteMyOperationProductMutationVariables>;
export const SaveMyOperationProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyOperationProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saveOperationProductPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"operation_products_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_operation_products_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saveOperationProductPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<SaveMyOperationProductMutation, SaveMyOperationProductMutationVariables>;
export const InsertMyOperationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertMyOperation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saveOperationPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"operations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_operations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saveOperationPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingRate"}},{"kind":"Field","name":{"kind":"Name","value":"billingUnit"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"operationId"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"extras"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertMyOperationMutation, InsertMyOperationMutationVariables>;
export const GetMyProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetMyProductsQuery, GetMyProductsQueryVariables>;
export const GetMyProductsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyProductsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"products_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetMyProductsPaginatedQuery, GetMyProductsPaginatedQueryVariables>;
export const UpdateMyProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateProductPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"products_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_products_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateProductPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<UpdateMyProductMutation, UpdateMyProductMutationVariables>;
export const SaveMyProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saveProductPayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"products_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_products_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saveProductPayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeableUnit"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerUnit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<SaveMyProductMutation, SaveMyProductMutationVariables>;
export const GetChargeableUnitsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChargeableUnits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeable_units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}}]}}]} as unknown as DocumentNode<GetChargeableUnitsQuery, GetChargeableUnitsQueryVariables>;
export const UpdateMyProductStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyProductStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"entity_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_products_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMyProductStatusMutation, UpdateMyProductStatusMutationVariables>;
export const GetReportByTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportByTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tag"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tag"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tag"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jsonSummary"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"seasonShot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cropName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"polygon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"size"}}]}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReportByTagQuery, GetReportByTagQueryVariables>;
export const ApiSignUpUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiSignUpUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"api_sign_up_user_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"api_sign_up_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiSignUpUserMutation, ApiSignUpUserMutationVariables>;
export const ApiAcceptInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiAcceptInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"api_accept_invite_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"api_accept_invite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<ApiAcceptInviteMutation, ApiAcceptInviteMutationVariables>;
export const GetMyTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roles"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"roles_enum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ownerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teamMember"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roles"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyTeamMembersQuery, GetMyTeamMembersQueryVariables>;
export const GetMyTeamInvitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyTeamInvites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_invites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitee_email"}},{"kind":"Field","name":{"kind":"Name","value":"invitee_role"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"invite_id"}}]}}]}}]} as unknown as DocumentNode<GetMyTeamInvitesQuery, GetMyTeamInvitesQueryVariables>;
export const GetMyVehiclesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyVehicles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vehicles_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetMyVehiclesQuery, GetMyVehiclesQueryVariables>;
export const UpdateMyVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyVehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateVehiclePayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_vehicles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateVehiclePayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<UpdateMyVehicleMutation, UpdateMyVehicleMutationVariables>;
export const SaveMyVehicleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMyVehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"saveVehiclePayload"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"vehicles_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_vehicles_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"saveVehiclePayload"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"length"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<SaveMyVehicleMutation, SaveMyVehicleMutationVariables>;
export const UpdateMyVehicleStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMyVehicleStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"entity_status_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_vehicles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMyVehicleStatusMutation, UpdateMyVehicleStatusMutationVariables>;
export const GetMyWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"warehouses_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyWarehousesQuery, GetMyWarehousesQueryVariables>;
export const SaveWarehouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveWarehouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warehouse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"warehouses_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_warehouses_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warehouse"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"warehouses_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"address"},{"kind":"EnumValue","value":"geoLocation"},{"kind":"EnumValue","value":"farmId"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"farm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SaveWarehouseMutation, SaveWarehouseMutationVariables>;
export const GetMyUserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyUserDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isEmailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"geoLocation"}},{"kind":"Field","name":{"kind":"Name","value":"fieldColor"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyUserDetailsQuery, GetMyUserDetailsQueryVariables>;